import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate, useLocation } from 'react-router-dom';
import { Settings as SettingsIcon, Building, Percent, Globe, Save, FileText, Mail, Phone, MapPin, Palette, RefreshCw, Hash, DollarSign, Truck, Search as SearchIcon, User, Users, Lock, Edit, CheckCircle, AlertCircle, Shield, Eye, Pipette, Database, Download, Upload, Clock, HardDrive, Cloud, Archive, ClipboardList, UserCheck, UserPlus, UserX, Activity, FileCheck, Trash2, X, Zap, TrendingUp, Award, Key, LogOut, Filter, ChevronUp, ChevronDown, LayoutGrid, Layers, XCircle, AlertTriangle, Search, LayoutList, List, Calendar, FileSpreadsheet, FileOutput, Square, CheckSquare, ArrowUpDown, ArrowUp, ArrowDown, Plus, Tag, Folder } from 'lucide-react';
import ColorThief from 'colorthief';
import { secureGetItem, secureSetItem } from '../../utils/secureStorage';
import { motion, AnimatePresence } from 'framer-motion';
// Tables-mobile.css - DELETED (not needed)
import { useSettings } from '../../../core/contexts/SettingsContext';
import { useLanguage } from '../../../core/contexts/LanguageContext';
import { formatBrandMoney, getBrandDefaultCurrency, SAUDI_CURRENCY_SYMBOL, getBrandLocale, getBrandDatePickerLocale } from '../../utils/brandCurrency';
import {
  SAUDI_BANKS,
  SAUDI_CITY_OPTIONS,
  SAUDI_FISCAL_YEAR_OPTIONS,
  SAUDI_LEGAL_FORMS,
  SAUDI_REGION_OPTIONS,
  SAUDI_VAT_CATEGORIES,
  SAUDI_VAT_REGISTRATION_THRESHOLD,
  SAUDI_VAT_RATE,
  SAUDI_IBAN_PLACEHOLDER,
  defaultSaudiBankSlot,
  formatBankAccountLegacyString,
  formatSaudiIbanDisplay,
  formatTRN,
  getBrandPhonePlaceholder,
  isBrandPhoneValid,
  normalizeBankAccountRecord,
  normalizeBrandPhone,
  normalizeSaudiIban,
  resolveCompanyField,
  validateSaudiPostalCode,
  validateSaudiVatNumber,
} from './companySettingsSaudi';
import { useTranslation } from 'react-i18next';
import settingsService from '../../../core/services/settingsService';
import authService from '../../../core/services/authService';
import { requestPasswordReset, resetPasswordWithCode, changePasswordWithCurrent, updateAdminProfile } from '../../../core/services/passwordResetService';
import backupService from '../../../core/services/backupService';
import TemplateWrapper from '../../../pages/facturation/invoice/templates/TemplateWrapper';
// import ArchitecturalInvoicePreview from '../../../pages/facturation/invoice/templates/ArchitecturalInvoicePreview'; // DELETED
// import GeometricInvoicePreview from '../../../pages/facturation/invoice/templates/GeometricInvoicePreview'; // DELETED
import { logAuditEvent, getAuditLogs, getAuditStats, filterAuditLogs, clearAuditLogs, exportAuditLogs, initializeAuditLogs, AuditAction, AuditLevel } from '../../utils/auditLogger';
import { getEffectiveCompanyLogo, loadDefaultCompanyLogoDataUrl } from '../../utils/companyLogo';
import { QAWAEM_SETTINGS_KEY } from '../../config/storageKeys';
import { usePermissions, SystemSections, PermissionLevels } from '../../../core/contexts/PermissionsContext';
import licensingService from '../../../core/services/licensingService';
import featureService from '../../../core/services/featureService';
import { getEnabledModules, MODULE_NAMES, LICENSE_CATALOG_MODULE_COUNT, resolveModuleDisplayName } from '../../../core/config/licenseFeatures';
import { moduleStructure } from '../../../core/config/moduleStructure';
// import VortexInvoicePreview from '../../../pages/facturation/invoice/templates/VortexInvoicePreview'; // DELETED
// Facturation.css removed - was from deleted components folder
import { clientService, productService, employeeService, categoryService, documentService } from '../../utils/serviceProvider';
import CustomSelect from '../../components/custom/CustomSelect';
import CustomNumberInput from '../../components/custom/CustomNumberInput';
import CustomDatePicker from '../../components/custom/CustomDatePicker';
import { resolveUpdateUiPhase } from '../updates/updateStatusUtils';
import { API_BASE } from '../../utils/apiConfig';
import DatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import ar from 'date-fns/locale/ar-SA';
import 'react-datepicker/dist/react-datepicker.css';
import '../../../shared/styles/GPSTrackingDatePicker.css';
import { useGlobalTheme } from '../../hooks/useGlobalTheme';
import {
  normalizeSaudiPhone,
  isValidSaudiPhone,
  SAUDI_PHONE_PLACEHOLDER,
} from '../../utils/saudiPhoneValidation';
import { SAUDI_MODULE_KEYS } from '../../../core/config/saudiPermissionsConfig';
import { isSaudiBrand } from '../../../products/saudi/utils/isSaudiBrand';

const INDUSTRY_TABLE_TYPE_KEYS = [
  'standard', 'fabrication', 'negoce', 'dimensions', 'simplifiee',
  'textile', 'alimentaire', 'pharmaceutique', 'automobile', 'location',
  'energie', 'restauration', 'transport', 'impression', 'coiffure',
  'informatique', 'plomberie', 'formation', 'evenementiel', 'agriculture',
];

function getIndustryTableHeaders(tableType, showReferenceColumn, p, t) {
  const ic = (key) => p(`billing.industry_tables.columns.${key}`);
  switch (tableType) {
    case 'standard':
      return [ic('no'), ...(showReferenceColumn ? [ic('reference')] : []), ic('designation'), ic('unit'), ic('qty'), ic('unit_price_ht'), ic('amount')];
    case 'fabrication':
      return [ic('no'), ic('reference'), ic('designation'), ic('long'), ic('qty'), ic('note')];
    case 'negoce':
      return [ic('no'), ic('designation'), ic('qty'), ic('unit'), ic('palette'), ic('carton'), ic('pcs')];
    case 'dimensions':
      return [ic('no'), ic('designation'), ic('ln'), ic('lr'), ic('surf_u'), ic('qty_surf'), ic('price_m2'), ic('amount')];
    case 'simplifiee':
      return [ic('no'), ic('qty'), ic('unit'), ic('cts'), ic('pcs'), ic('designation'), ic('unit_price_ht'), ic('amount')];
    case 'textile':
      return [ic('no'), ic('reference'), ic('article'), ic('brand'), ic('size'), ic('color'), ic('qty'), ic('pu'), ic('discount'), ic('net')];
    case 'alimentaire':
      return [ic('no'), ic('code'), ic('product'), ic('dlc'), ic('lot'), ic('weight'), ic('qty'), ic('price_kg'), ic('tva'), ic('amount')];
    case 'pharmaceutique':
      return [ic('no'), ic('cip'), ic('medicament'), ic('dosage'), ic('form'), ic('qty'), ic('reimb'), ic('unit_price_ht'), ic('ticket'), ic('net')];
    case 'automobile':
      return [ic('no'), ic('reference'), ic('piece'), ic('brand'), ic('model'), ic('year'), ic('stock'), ic('qty'), ic('pu'), ic('amount')];
    case 'location':
      return [ic('no'), ic('article'), ic('designation'), ic('period'), ic('nb_days'), ic('rate_day'), ic('deposit'), ic('insurance'), ic('amount')];
    case 'energie':
      return [ic('no'), ic('type'), ic('period'), ic('index_old'), ic('index_new'), ic('consumption'), ic('rate'), ic('subscription'), ic('amount')];
    case 'restauration':
      return [ic('no'), t('common.date'), ic('service'), ic('designation'), ic('nb_persons'), ic('price_per'), ic('qty'), ic('amount'), ic('service_charge')];
    case 'transport':
      return [ic('no'), ic('destination'), ic('distance'), ic('weight'), ic('volume'), ic('rate'), ic('fuel'), ic('toll'), ic('amount')];
    case 'impression':
      return [ic('no'), ic('work'), ic('format'), ic('colors'), ic('paper'), ic('qty'), ic('pu'), ic('bat'), ic('finish'), ic('amount')];
    case 'coiffure':
      return [ic('no'), ic('service'), ic('duration'), ic('rate'), ic('products'), ic('qty'), ic('technician'), ic('tip'), ic('amount')];
    case 'informatique':
      return [ic('no'), ic('intervention'), t('common.date'), ic('duration'), ic('technician'), ic('rate_h'), ic('travel'), ic('equipment'), ic('amount')];
    case 'plomberie':
      return [ic('no'), ic('intervention'), ic('labor'), ic('time'), ic('materials'), ic('qty'), ic('pu'), ic('travel'), ic('amount')];
    case 'formation':
      return [ic('no'), ic('module'), ic('duration'), ic('nb_h'), ic('trainer'), ic('rate_h'), ic('support'), ic('certification'), ic('amount')];
    case 'evenementiel':
      return [ic('no'), ic('service'), t('common.date'), ic('location'), ic('nb_guests'), ic('price_per'), ic('options'), ic('equipment'), ic('amount')];
    case 'agriculture':
      return [ic('no'), ic('product'), ic('variety'), ic('caliber'), ic('origin'), ic('weight'), ic('price_kg'), ic('packaging'), ic('transport'), ic('amount')];
    default:
      return [ic('no'), ic('reference'), ic('designation'), ic('unit'), ic('qty'), ic('unit_price_ht'), ic('amount')];
  }
}

function getIndustryTablePreviewRow(tableType, showReferenceColumn, p, qawaem) {
  const s = (key) => p(`billing.industry_tables.samples.${key}`);
  switch (tableType) {
    case 'standard':
      return ['1', ...(showReferenceColumn ? ['REF001'] : []), s('demo_product'), 'u', '2', '1000.00', '2000.00'];
    case 'fabrication':
      return ['1', 'F001', s('metal_support'), '120', '80', '3', s('stainless_steel')];
    case 'negoce':
      return ['1', s('sample_article'), '24', 'pcs', '2', '4', '6'];
    case 'dimensions':
      return ['1', s('white_marble'), '80', '120', '0.96', '3', '1500.00', '4320.00'];
    case 'simplifiee':
      return ['1', '2', 'pcs', '4', '8', s('detail_article'), '500.00', '1000.00'];
    case 'textile':
      return ['1', 'TX001', s('tshirt'), s('brand_x'), 'M', s('black'), '2', '1200.00', '10%', '2160.00'];
    case 'alimentaire':
      return ['A001', s('fresh_product'), '10/08/2023', 'L123', '500g', '10', '1200.00', '9%', '6600.00'];
    case 'pharmaceutique':
      return ['3400', s('medicine_x'), '500mg', s('tablet'), '1', '70%', '1200.00', '360.00', '840.00'];
    case 'automobile':
      return ['P001', s('oil_filter'), s('brand_bosch'), s('model_renault_clio'), '2020', '5', '2', '800.00', '1600.00'];
    case 'location':
      return ['M001', s('pro_drill'), '01/07-03/07', '3', '500.00', '2000.00', '300.00', '3800.00'];
    case 'energie':
      return [s('electricity'), s('june_2023'), '12500', '13200', '700', '0.23', '900.00', '1061.00'];
    case 'restauration':
      return ['15/07/2023', s('dinner'), s('full_menu'), '20', '1500.00', '1', '30000.00', '15%'];
    case 'transport':
      return qawaem
        ? ['L001', s('transport_route_sa'), '400', '500kg', '2m³', '800.00', '200.00', '150.00', '1150.00']
        : ['L001', s('transport_route_dz'), '400', '500kg', '2m³', '8000.00', '2000.00', '1000.00', '11000.00'];
    case 'impression':
      return [s('brochure'), 'A4', '4c', '135g', '1000', '50.00', s('approved'), s('lamination'), '55000.00'];
    case 'coiffure':
      return [s('cut_color'), '2h', '3500.00', s('shampoo'), '1', s('technician_karim'), '500.00', '4000.00'];
    case 'informatique':
      return [s('pc_repair'), '12/07/2023', '2h', s('technician_ahmed'), '2500.00', '1000.00', '1500.00', '7500.00'];
    case 'plomberie':
      return [s('leak_repair'), '2h', '2', s('faucet'), '1', '3000.00', '1000.00', '6000.00'];
    case 'formation':
      return [s('excel_advanced'), s('two_days'), '16', s('mr_belkacem'), '1500.00', s('included'), s('yes'), '24000.00'];
    case 'evenementiel':
      return [s('seminar'), '20/09/2023', s('hotel_marriott'), '50', '3500.00', s('coffee_break'), s('projector'), '200000.00'];
    case 'agriculture':
      return qawaem
        ? ['A001', s('agriculture_product_sa'), s('agriculture_grade_sa'), s('agriculture_origin_sa'), '100kg', '25.00', s('agriculture_pack_sa'), '100.00', '2700.00']
        : ['A001', s('apple'), s('golden'), s('premium'), s('algeria'), '100kg', '250.00', s('crate'), '1000.00', '27000.00'];
    default:
      return ['1', 'REF001', s('sample_product'), 'u', '2', '1000.00', '2000.00'];
  }
}

function buildBackupRestoreConfirmMessage(backupData, dataAnalysis, totalItems, p) {
  const lines = [
    p('messages.backup_restore_confirm_title'),
    '',
    p('messages.backup_restore_confirm_created', { date: new Date(backupData.timestamp).toLocaleString('ar-SA') }),
    p('messages.backup_restore_confirm_version', { version: backupData.version || 'N/A' }),
    p('messages.backup_restore_confirm_app', { app: backupData.appName || 'Qawaem' }),
    '',
    p('messages.backup_restore_confirm_data_header'),
  ];
  if (dataAnalysis.settings > 0) lines.push(p('messages.backup_restore_confirm_settings', { count: dataAnalysis.settings }));
  if (dataAnalysis.documents > 0) lines.push(p('messages.backup_restore_confirm_documents', { count: dataAnalysis.documents }));
  if (dataAnalysis.clients > 0) lines.push(p('messages.backup_restore_confirm_clients', { count: dataAnalysis.clients }));
  if (dataAnalysis.employees > 0) lines.push(p('messages.backup_restore_confirm_employees', { count: dataAnalysis.employees }));
  if (dataAnalysis.categories > 0) lines.push(p('messages.backup_restore_confirm_categories', { count: dataAnalysis.categories }));
  if (dataAnalysis.products > 0) lines.push(p('messages.backup_restore_confirm_products', { count: dataAnalysis.products }));
  lines.push('', p('messages.backup_restore_confirm_total', { count: totalItems }), '', p('messages.backup_restore_confirm_warning'), '', p('messages.backup_restore_confirm_question'));
  return lines.join('\n');
}

registerLocale('ar-SA', ar);

function formatArSaDate(iso) {
  if (!iso) return '—';
  try {
    return new Intl.DateTimeFormat('ar-SA', { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(iso));
  } catch {
    return String(iso);
  }
}

function readJsonField(storageKey, field) {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return '';
    const parsed = JSON.parse(raw);
    return String(parsed?.[field] || '').trim();
  } catch {
    return '';
  }
}

function readSetupRegistrationPhone() {
  try {
    const raw = localStorage.getItem('setup_data');
    if (!raw) return '';
    const parsed = JSON.parse(raw);
    return String(parsed?.company?.phone || '').trim();
  } catch {
    return '';
  }
}

/** Phone from setup / settings / session — registration stores it on company.phone. */
function resolveProfilePhone({ storedUser, settingsBlob, permissionsUser }) {
  const candidates = [
    storedUser?.phone,
    settingsBlob?.adminUser?.phone,
    settingsBlob?.company?.phone,
    readSetupRegistrationPhone(),
    readJsonField('qawaem_admin_user', 'phone'),
    readJsonField('qawaem_user', 'phone'),
    permissionsUser?.phone,
  ];
  for (const value of candidates) {
    const trimmed = value != null ? String(value).trim() : '';
    if (trimmed) return trimmed;
  }
  return '';
}

const SettingsBody = () => {
  const { t, i18n } = useTranslation();
  const p = (key, opts) => t(`modules.shared.settingsBody.${key}`, opts);
  const datePickerLocale = getBrandDatePickerLocale();
  const qawaemBrand = isSaudiBrand();
  const tt = useCallback((key) => p(`billing.industry_tables.types.${key}`), [p]);
  const tc = useCallback((key) => p(`billing.industry_tables.columns.${key}`), [p]);
  const ts = useCallback((key) => p(`billing.industry_tables.samples.${key}`), [p]);
  const TABLE_TYPE_VALUES = useMemo(() => (["standard","fabrication","negoce","dimensions","simplifiee","textile","alimentaire","pharmaceutique","automobile","location","energie","restauration","transport","impression","coiffure","informatique","plomberie","formation","evenementiel","agriculture"]), []);
  const previewRows = useMemo(() => {
    const s = ts;
    return {
      standard: (showRef) => ['1', ...(showRef ? ['REF001'] : []), s('demo_product'), 'و', '2', '1000.00', '2000.00'],
      fabrication: ['1', 'F001', s('metal_support'), '120', '80', '3', s('stainless_steel')],
      negoce: ['1', s('sample_article'), '24', 'pcs', '2', '4', '6'],
      dimensions: ['1', s('white_marble'), '80', '120', '0.96', '3', '1500.00', '4320.00'],
      simplifiee: ['1', '2', 'pcs', '4', '8', s('detail_article'), '500.00', '1000.00'],
      textile: ['1', 'TX001', s('tshirt'), s('brand_x'), 'M', s('black'), '2', '1200.00', '10%', '2160.00'],
      alimentaire: ['A001', s('fresh_product'), '10/08/2023', 'L123', '500g', '10', '1200.00', '9%', '6600.00'],
      pharmaceutique: ['3400', s('medicine_x'), '500mg', s('tablet'), '1', '70%', '1200.00', '360.00', '840.00'],
      automobile: ['P001', s('oil_filter'), s('brand_bosch'), s('model_renault_clio'), '2020', '5', '2', '800.00', '1600.00'],
      location: ['M001', s('pro_drill'), '01/07-03/07', '3', '500.00', '2000.00', '300.00', '3800.00'],
      energie: [s('electricity'), s('june_2023'), '12500', '13200', '700', '0.23', '900.00', '1061.00'],
      restauration: ['15/07/2023', s('dinner'), s('full_menu'), '20', '1500.00', '1', '30000.00', '15%'],
      transport: qawaemBrand
        ? ['L001', s('transport_route_sa'), '400', '500kg', '2m³', '800.00', '200.00', '150.00', '1150.00']
        : ['L001', s('transport_route_dz'), '400', '500kg', '2m³', '8000.00', '2000.00', '1000.00', '11000.00'],
      impression: [s('brochure'), 'A4', '4c', '135g', '1000', '50.00', s('approved'), s('lamination'), '55000.00'],
      coiffure: [s('cut_color'), '2h', '3500.00', s('shampoo'), '1', s('technician_karim'), '500.00', '4000.00'],
      informatique: [s('pc_repair'), '12/07/2023', '2h', s('technician_ahmed'), '2500.00', '1000.00', '1500.00', '7500.00'],
      plomberie: [s('leak_repair'), '2h', '2', s('faucet'), '1', '3000.00', '1000.00', '6000.00'],
      formation: [s('excel_advanced'), s('two_days'), '16', s('mr_belkacem'), '1500.00', s('included'), s('yes'), '24000.00'],
      evenementiel: [s('seminar'), '20/09/2023', s('hotel_marriott'), '50', '3500.00', s('coffee_break'), s('projector'), '200000.00'],
      agriculture: qawaemBrand
        ? ['1', s('agriculture_product_sa'), s('agriculture_grade_sa'), s('premium'), s('agriculture_origin_sa'), '1T', '8500.00', s('agriculture_pack_sa'), '2000.00', '10500.00']
        : ['1', s('apple'), s('golden'), s('premium'), s('algeria'), '1T', '8500.00', s('crate'), '2000.00', '10500.00'],
      default: ['1', 'REF001', s('demo_product'), 'و', '2', '1000.00', '2000.00'],
    };
  }, [ts, qawaemBrand]);
  const renderTablePreviewHeaders = useCallback((tableType, showReferenceColumn) => {
    switch (tableType) {
      case 'standard':
        return [tc('no'), ...(showReferenceColumn ? [tc('reference')] : []), tc('designation'), tc('unit'), tc('qty'), tc('unit_price_ht'), tc('amount')];
      case 'fabrication':
        return [tc('no'), tc('reference'), tc('designation'), tc('long'), tc('qty'), tc('note')];
      case 'negoce':
        return [tc('no'), tc('designation'), tc('qty'), tc('unit'), tc('palette'), tc('carton'), tc('pcs')];
      case 'dimensions':
        return [tc('no'), tc('designation'), tc('ln'), tc('lr'), tc('surf_u'), tc('qty_surf'), tc('price_m2'), tc('amount')];
      case 'simplifiee':
        return [tc('no'), tc('qty'), tc('unit'), tc('cts'), tc('pcs'), tc('designation'), tc('unit_price_ht'), tc('amount')];
      case 'textile':
        return [tc('no'), tc('reference'), tc('article'), tc('brand'), tc('size'), tc('color'), tc('qty'), tc('pu'), tc('discount'), tc('net')];
      case 'alimentaire':
        return [tc('no'), tc('code'), tc('product'), tc('dlc'), tc('lot'), tc('weight'), tc('qty'), tc('price_kg'), tc('tva'), tc('amount')];
      case 'pharmaceutique':
        return [tc('no'), tc('cip'), tc('medicament'), tc('dosage'), tc('form'), tc('qty'), tc('reimb'), tc('pu'), tc('ticket'), tc('net')];
      case 'automobile':
        return [tc('no'), tc('reference'), tc('piece'), tc('brand'), tc('model'), tc('year'), tc('stock'), tc('qty'), tc('pu'), tc('amount')];
      case 'location':
        return [tc('no'), tc('article'), tc('designation'), tc('period'), tc('nb_days'), tc('rate_day'), tc('deposit'), tc('insurance'), tc('amount')];
      case 'energie':
        return [tc('no'), tc('type'), tc('period'), tc('index_old'), tc('index_new'), tc('consumption'), tc('rate'), tc('subscription'), tc('amount')];
      case 'restauration':
        return [tc('no'), t('common.date'), tc('service'), tc('designation'), tc('nb_persons'), tc('price_per'), tc('qty'), tc('amount'), tc('service_charge')];
      case 'transport':
        return [tc('no'), tc('destination'), tc('distance'), tc('weight'), tc('volume'), tc('rate'), tc('fuel'), tc('toll'), tc('amount')];
      case 'impression':
        return [tc('no'), tc('work'), tc('format'), tc('colors'), tc('paper'), tc('qty'), tc('pu'), tc('bat'), tc('finish'), tc('amount')];
      case 'coiffure':
        return [tc('no'), tc('service'), tc('duration'), tc('rate'), tc('products'), tc('qty'), tc('technician'), tc('tip'), tc('amount')];
      case 'informatique':
        return [tc('no'), tc('intervention'), t('common.date'), tc('duration'), tc('technician'), tc('rate_h'), tc('travel'), tc('equipment'), tc('amount')];
      case 'plomberie':
        return [tc('no'), tc('intervention'), tc('labor'), tc('time'), tc('materials'), tc('qty'), tc('pu'), tc('travel'), tc('amount')];
      case 'formation':
        return [tc('no'), tc('module'), tc('duration'), tc('nb_h'), tc('trainer'), tc('rate_h'), tc('support'), tc('certification'), tc('amount')];
      case 'evenementiel':
        return [tc('no'), tc('service'), t('common.date'), tc('location'), tc('nb_guests'), tc('price_per'), tc('options'), tc('equipment'), tc('amount')];
      case 'agriculture':
        return [tc('no'), tc('product'), tc('variety'), tc('caliber'), tc('origin'), tc('weight'), tc('price_kg'), tc('packaging'), tc('transport'), tc('amount')];
      default:
        return [tc('no'), tc('reference'), tc('designation'), tc('unit'), tc('qty'), tc('unit_price_ht'), tc('amount')];
    }
  }, [tc, t]);
  const { isDashboardLightMode } = useGlobalTheme();
  const settingsInkPrimary = isDashboardLightMode ? '#0f172a' : '#ffffff';
  const settingsInkMuted = isDashboardLightMode ? 'rgba(15, 23, 42, 0.62)' : 'rgba(255, 255, 255, 0.6)';
  const settingsInkBorder = isDashboardLightMode ? 'rgba(15, 23, 42, 0.1)' : 'rgba(255, 255, 255, 0.08)';
  const settingsCardGlass = {
    background: isDashboardLightMode ? '#ffffff' : 'rgba(255, 255, 255, 0.05)',
    backdropFilter: isDashboardLightMode ? 'none' : 'blur(10px)',
    border: isDashboardLightMode ? '1px solid rgba(15, 23, 42, 0.12)' : '1px solid rgba(255, 255, 255, 0.2)',
    borderRadius: '1.5rem',
    padding: '1.5rem',
    marginBottom: '1.5rem'
  };
  /** Cartes onglet Entité — surface séparée, sans bandeau bleu */
  const companySettingsCard = {
    borderRadius: '1rem',
    overflow: 'hidden',
    minWidth: 0,
    border: isDashboardLightMode ? '1px solid rgb(226 232 240)' : '1px solid rgba(255, 255, 255, 0.2)',
    background: isDashboardLightMode ? '#ffffff' : 'rgba(255, 255, 255, 0.06)',
    boxShadow: isDashboardLightMode
      ? '0 4px 6px -1px rgba(15, 23, 42, 0.08), 0 2px 4px -2px rgba(15, 23, 42, 0.05)'
      : 'none',
    backdropFilter: isDashboardLightMode ? 'none' : 'blur(10px)'
  };
  const companySettingsSectionTitleRow = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    padding: '1rem 1.25rem',
    borderBottom: isDashboardLightMode ? '1px solid rgb(226 232 240)' : '1px solid rgba(255, 255, 255, 0.12)',
    background: isDashboardLightMode ? '#f8fafc' : 'rgba(255, 255, 255, 0.05)',
    borderTopLeftRadius: '1rem',
    borderTopRightRadius: '1rem'
  };
  const companySettingsCardBody = {
    padding: '1.5rem',
    minWidth: 0
  };
  const currentLanguage = i18n.language || 'ar';
  const { settings, updateSettings } = useSettings();
  const { language, changeLanguage, availableLanguages } = useLanguage();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(() => {
    if (location.pathname === '/settings/users') return 'utilisateurs';
    return location.state?.activeTab || 'company';
  });

  useEffect(() => {
    if (location.pathname === '/settings/users') {
      setActiveTab('utilisateurs');
    }
  }, [location.pathname]);
  
  // Helper functions for audit log translations
  const translateAction = (action) => {
    if (!action || typeof action !== 'string') return action;
    const key = `audit.actions.${action}`;
    const translated = p(key);
    if (translated !== key) return translated;
    return action.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  };

  const translateLevel = (level) => {
    const key = `audit.levels.${level}`;
    const translated = p(key);
    return translated !== key ? translated : level;
  };

  const translateResource = (resource) => {
    if (!resource) return p('defaults.na');
    const map = {
      'Settings Page': 'audit.resources.settings_page',
      'User Permissions': 'audit.resources.user_permissions',
      'Permissions utilisateur': 'audit.resources.user_permissions',
      'user_permissions': 'audit.resources.user_permissions',
      'System settings': 'audit.resources.system_settings',
      'Profil utilisateur': 'audit.resources.user_profile',
      'user_profile': 'audit.resources.user_profile',
      'Sécurité utilisateur': 'audit.resources.user_security',
      'user_security': 'audit.resources.user_security',
      'System Config': 'audit.resources.system_config',
      'Backup': 'audit.resources.backup',
      'Database': 'audit.resources.database',
      'Documents': 'audit.resources.documents',
      'Users': 'audit.resources.users',
      'Reports': 'audit.resources.reports',
      'License': 'audit.resources.license'
    };
    const key = map[resource];
    if (key) return p(key);
    return resource;
  };

  const translateDetails = (details) => {
    if (!details) return p('audit.no_detail');

    const exactMap = {
      'User accessed the settings configuration page': 'audit.details.settings_access',
      'User permissions updated': 'audit.details.permissions_updated',
      'System configuration changed': 'audit.details.config_changed',
      'Backup created successfully': 'audit.details.backup_created',
      'User logged in': 'audit.details.user_logged_in',
      'User logged out': 'audit.details.user_logged_out',
      'Document created': 'audit.details.document_created',
      'Document updated': 'audit.details.document_updated',
      'Document deleted': 'audit.details.document_deleted',
      'Successful login to Qawaem system': 'audit.details.login_success',
      'Updated document prefixes configuration': 'audit.details.prefix_config_updated',
      'Automatic scheduled backup completed successfully': 'audit.details.backup_auto_success',
      'Downloaded PDF export of invoice': 'audit.details.invoice_pdf_download',
    };

    const mappedKey = exactMap[details];
    if (mappedKey) return p(mappedKey);

    if (details.startsWith('Changes: ')) {
      return p('audit.details.changes', { changes: details.slice('Changes: '.length) });
    }
    if (details.startsWith('Modifications:')) {
      return p('audit.details.changes', { changes: details.replace(/^Modifications:\s*/, '') });
    }
    if (details.startsWith('Save failed: ')) {
      return p('audit.details.save_failed', { message: details.slice('Save failed: '.length) });
    }
    if (details.startsWith('Backup created: ')) {
      const rest = details.slice('Backup created: '.length);
      const match = rest.match(/^(.+?) \((.+)\)$/);
      if (match) {
        return p('audit.details.backup_created_file', { fileName: match[1], size: match[2] });
      }
    }
    if (details.startsWith('Backup creation failed: ')) {
      return p('audit.details.backup_create_failed', { message: details.slice('Backup creation failed: '.length) });
    }
    if (details.startsWith('Created new invoice for ')) {
      return p('audit.details.invoice_created', { client: details.slice('Created new invoice for '.length) });
    }
    if (details.includes('Profil') && (details.includes('mis à jour') || details.includes('mises à jour'))) {
      const username = details.match(/Profil[^:]*:\s*(.+)/)?.[1]?.trim() || details;
      return p('audit_log.details.profile_updated', { username });
    }
    if (details.includes('Permissions de') || details.includes('Permissions utilisateur')) {
      return p('audit.details.permissions_updated');
    }

    return details;
  };
  const [facturationTab, setFacturationTab] = useState('tableaux');
  
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  
  // App Appearance Management
  const [appTheme, setAppTheme] = useState(() => {
    const saved = localStorage.getItem('qawaem_app_theme');
    return saved ? JSON.parse(saved) : {
      primaryColor: 'blue',
      darkIntensity: 'medium',
      customColor: null,
      density: 'normal',
      fontSize: 'normal',
      borderRadius: 'medium',
      background: 'gradient',
      customBackground: null
    };
  });

  // Save app theme to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('qawaem_app_theme', JSON.stringify(appTheme));
    window.dispatchEvent(new CustomEvent('appThemeChanged', { detail: appTheme }));
  }, [appTheme]);
  
  // User Management ({p('users.title')}) — isolated from Audit tab state
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [editingUserRecord, setEditingUserRecord] = useState(null);
  const [umShowViewUserModal, setUmShowViewUserModal] = useState(false);
  const [umViewingUser, setUmViewingUser] = useState(null);
  const [umViewMode, setUmViewMode] = useState('table');
  const [umSearchTerm, setUmSearchTerm] = useState('');
  const [umSortConfig, setUmSortConfig] = useState([]);
  const [umSelectedRecords, setUmSelectedRecords] = useState([]);
  const [umSelectAll, setUmSelectAll] = useState(false);
  const [umShowAdvancedOptions, setUmShowAdvancedOptions] = useState(false);
  const [umMainViewMode, setUmMainViewMode] = useState('all_users');
  const [umQuickFilter, setUmQuickFilter] = useState('all');
  const [umStatusFilter, setUmStatusFilter] = useState('all');
  const [umIsStatusFilterOpen, setUmIsStatusFilterOpen] = useState(false);
  const [umDateRange, setUmDateRange] = useState({ start: null, end: null });
  const [umIsDateRangeOpen, setUmIsDateRangeOpen] = useState(false);
  const [umShowImportDropdown, setUmShowImportDropdown] = useState(false);
  const [umShowExportDropdown, setUmShowExportDropdown] = useState(false);
  const [umActiveDistributionFilter, setUmActiveDistributionFilter] = useState(null);
  const [userFormData, setUserFormData] = useState({
    nameAr: '',
    nameEn: '',
    username: '',
    email: '',
    role: '',
    tempPassword: '',
    phone: '',
    department: '',
    position: '',
    nationalId: '',
    residencyType: 'saudi',
    status: 'active',
    notes: ''
  });
  const [userFormExpandedSections, setUserFormExpandedSections] = useState({
    identity: true,
    credentials: false,
    accessPreview: false,
    metadata: false
  });
  const umImportDropdownRef = useRef(null);
  const umExportDropdownRef = useRef(null);
  const umStatusFilterRef = useRef(null);
  const umDateRangeRef = useRef(null);
  
  // Audit Log States
  const [auditLogs, setAuditLogs] = useState([]);
  const [auditFilters, setAuditFilters] = useState({
    actionType: '',
    user: '',
    startDate: '',
    endDate: ''
  });
  const [auditStats, setAuditStats] = useState({});
  
  // Audit GPS-style states
  const [viewMode, setViewMode] = useState('table');
  const [selectedRecords, setSelectedRecords] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [sortConfig, setSortConfig] = useState([]);
  const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);
  const [mainViewMode, setMainViewMode] = useState('all_logs');
  const [quickFilter, setQuickFilter] = useState('all');
  const [isStatusFilterOpen, setIsStatusFilterOpen] = useState(false);
  const [isDateRangeOpen, setIsDateRangeOpen] = useState(false);
  const [showImportDropdown, setShowImportDropdown] = useState(false);
  const [showExportDropdown, setShowExportDropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  
  // Audit refs
  const statusFilterRef = useRef(null);
  const dateRangeRef = useRef(null);
  const importDropdownRef = useRef(null);
  const exportDropdownRef = useRef(null);
  
  const navigate = useNavigate();
  
  // Permissions management
  const permissions = usePermissions();
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [editingPermissions, setEditingPermissions] = useState({});

  // License display (profile)
  const [licenseData, setLicenseData] = useState(null);
  const [isOnlineLicense, setIsOnlineLicense] = useState(false);
  const [licenseModuleTick, setLicenseModuleTick] = useState(0);
  const [showModulesModal, setShowModulesModal] = useState(false);

  // Audit tab: defer heavy log load until user opens the tab (keeps /settings navigation instant).
  useEffect(() => {
    if (activeTab !== 'audit') return undefined;

    initializeAuditLogs();
    loadAuditData();

    const sessionKey = 'settings_page_accessed_' + new Date().toDateString();
    if (!sessionStorage.getItem(sessionKey)) {
      sessionStorage.setItem(sessionKey, 'true');
      logAuditEvent(
        AuditAction.SYSTEM_CONFIG_CHANGE,
        'Settings Page',
        'User accessed the settings configuration page',
        AuditLevel.INFO
      );
    }
  }, [activeTab]);

  // License display — load once on mount (lightweight localStorage read).
  useEffect(() => {
    loadLicenseData();
  }, []);

  // Load license data
  const loadLicenseData = () => {
    const license = JSON.parse(localStorage.getItem('qawaem_license') || '{}');
    setLicenseData(license);
    setIsOnlineLicense(license.licenseMode === 'ONLINE');
    try {
      featureService.clearCache();
    } catch (_) {
      /* ignore */
    }
    setLicenseModuleTick((n) => n + 1);
  };

  useEffect(() => {
    const onLicenseSynced = () => loadLicenseData();
    window.addEventListener('qawaem-license-synced', onLicenseSynced);
    return () => window.removeEventListener('qawaem-license-synced', onLicenseSynced);
  }, []);

  const enabledLicenseModuleCount = useMemo(() => {
    const license = licensingService.getLicense();
    if (!license?.appType && !license?.keyType) return 0;
    return getEnabledModules(license).length;
  }, [licenseData, licenseModuleTick]);

  const enabledModulesList = useMemo(() => {
    const license = licensingService.getLicense();
    const enabledKeys = new Set(getEnabledModules(license));
    if (enabledKeys.size === 0) return [];

    return moduleStructure
      .filter((m) => enabledKeys.has(m.key))
      .map((m, idx) => ({
        num: String(idx + 1).padStart(2, '0'),
        key: m.key,
        label: resolveModuleDisplayName(m.key, t) || m.name || m.key,
      }));
  }, [licenseData, licenseModuleTick]);

  const licensePackLabel = useMemo(() => {
    try {
      return featureService.getCurrentLicenseName();
    } catch {
      return p('license.default');
    }
  }, [licenseData, licenseModuleTick]);

  const productLicenseKey = useMemo(() => {
    const license = licensingService.getLicense();
    return license?.key || secureGetItem('qawaem_license_key') || '';
  }, [licenseData, licenseModuleTick]);

  const copyProductLicenseKey = () => {
    if (!productLicenseKey) return;
    navigator.clipboard.writeText(productLicenseKey);
    setProfileMessage({ type: 'success', text: p('messages.key_copied') });
    setTimeout(() => setProfileMessage({ type: '', text: '' }), 3000);
  };

  // Load audit data
  const loadAuditData = () => {
    const logs = getAuditLogs();
    const stats = getAuditStats('today');
    setAuditLogs(logs);
    setAuditStats(stats);
  };

  // Handle audit filter changes
  const handleAuditFilterChange = (filterKey, value) => {
    const newFilters = { ...auditFilters, [filterKey]: value };
    setAuditFilters(newFilters);
    
    // Apply filters
    const filteredLogs = filterAuditLogs(newFilters);
    setAuditLogs(filteredLogs);
  };

  // Handle clearing audit logs
  const handleClearAuditLogs = () => {
    if (window.confirm(p('messages.confirm_clear_audit'))) {
      clearAuditLogs();
      setTimeout(() => {
        loadAuditData();
      }, 200);
    }
  };

  // Handle exporting audit logs
  const handleExportAuditLogs = () => {
    exportAuditLogs(auditFilters);
  };

  // Audit GPS-style helper functions
  const getSortInfo = (key) => {
    const index = sortConfig.findIndex(sort => sort.key === key);
    if (index === -1) return null;
    return {
      direction: sortConfig[index].direction,
      order: index + 1,
      isMulti: sortConfig.length > 1
    };
  };

  const handleSort = (key, event) => {
    setSortConfig(prev => {
      const existingIndex = prev.findIndex(sort => sort.key === key);
      
      if (existingIndex !== -1) {
        const existing = prev[existingIndex];
        if (existing.direction === 'asc') {
          const updated = [...prev];
          updated[existingIndex] = { key, direction: 'desc' };
          return updated;
        } else {
          return prev.filter((_, i) => i !== existingIndex);
        }
      } else {
        return [...prev, { key, direction: 'asc' }];
      }
    });
  };

  const handleSelectAll = () => { 
    setSelectAll(!selectAll); 
    setSelectedRecords(selectAll ? [] : auditLogs.map(l => l.id)); 
  };
  
  const handleSelectRecord = (id) => { 
    setSelectedRecords(selectedRecords.includes(id) 
      ? selectedRecords.filter(rId => rId !== id) 
      : [...selectedRecords, id]
    ); 
  };

  const handleBulkDelete = async () => {
    if (window.confirm(p('messages.confirm_delete_logs', { count: selectedRecords.length }))) {
      try {
        // Implement bulk delete logic here
        setSelectedRecords([]);
        setSelectAll(false);
        loadAuditData();
      } catch (error) {
        console.error('Error deleting logs:', error);
      }
    }
  };

  const loadAuditLogs = () => {
    loadAuditData();
  };

  // Close dropdowns when clicking outside - Audit + User management
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (statusFilterRef.current && !statusFilterRef.current.contains(event.target)) {
        setIsStatusFilterOpen(false);
      }
      if (dateRangeRef.current && !dateRangeRef.current.contains(event.target)) {
        setIsDateRangeOpen(false);
      }
      if (importDropdownRef.current && !importDropdownRef.current.contains(event.target)) {
        setShowImportDropdown(false);
      }
      if (exportDropdownRef.current && !exportDropdownRef.current.contains(event.target)) {
        setShowExportDropdown(false);
      }
      if (umStatusFilterRef.current && !umStatusFilterRef.current.contains(event.target)) {
        setUmIsStatusFilterOpen(false);
      }
      if (umDateRangeRef.current && !umDateRangeRef.current.contains(event.target)) {
        setUmIsDateRangeOpen(false);
      }
      if (umImportDropdownRef.current && !umImportDropdownRef.current.contains(event.target)) {
        setUmShowImportDropdown(false);
      }
      if (umExportDropdownRef.current && !umExportDropdownRef.current.contains(event.target)) {
        setUmShowExportDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Permission management functions
  const handleEditUserPermissions = (userId) => {
    const userPermissions = permissions.getUserEffectivePermissions(userId);
    setEditingPermissions(userPermissions);
    setSelectedUserId(userId);
    setShowPermissionModal(true);
  };

  const handleSavePermissions = async () => {
    if (selectedUserId) {
      const currentUser = permissions.users.find(u => u.id === selectedUserId);
      const oldPermissions = permissions.getUserEffectivePermissions(selectedUserId) || {};

      const changes = [];
      Object.keys(editingPermissions).forEach(section => {
        if (editingPermissions[section] !== oldPermissions[section]) {
          const sectionNames = permissions.getSectionDisplayNames();
          const levelNames = {
            none: p('permissions.none'),
            view: p('permissions.view'),
            create: p('permissions.create'),
            edit: p('permissions.edit'),
            delete: p('permissions.delete'),
            full: p('permissions.full'),
          };
          const sectionName = sectionNames[section] || section;
          const oldLevel = levelNames[oldPermissions[section]] || p('permissions.none');
          const newLevel = levelNames[editingPermissions[section]] || p('permissions.none');
          changes.push(`${sectionName}: ${oldLevel} → ${newLevel}`);
        }
      });

      const success = await permissions.updateUserPermissions(selectedUserId, editingPermissions);
      if (success) {
        setShowPermissionModal(false);
        setSelectedUserId(null);
        setEditingPermissions({});

        const userName = currentUser?.nameEn || currentUser?.nameAr || currentUser?.name || currentUser?.username || p('defaults.user');
        logAuditEvent(
          AuditAction.USER_PERMISSION_CHANGE,
          p('audit.resources.user_permissions'),
          changes.length > 0
            ? p('messages.permissions_updated_detail', { name: userName, changes: changes.join(', ') })
            : p('messages.permissions_updated', { name: userName }),
          AuditLevel.SUCCESS,
          { userId: selectedUserId, userName, changes, permissionsCount: Object.keys(editingPermissions).length }
        );
      }
    }
  };

  const handlePermissionLevelChange = (section, level) => {
    setEditingPermissions(prev => ({
      ...prev,
      [section]: level,
    }));
  };

  const getTierInfo = (tierType) => {
    // Normalize the tier type to uppercase
    const normalizedType = tierType?.toUpperCase();
    
    // Get module count for this license
    const license = { appType: normalizedType };
    const enabledModules = getEnabledModules(license);
    
    // Determine display name
    let displayName = p('defaults.standard_account');
    if (normalizedType === 'ALL' || normalizedType === 'ALL_MODULES') {
      displayName = p('license.complete');
    } else if (MODULE_NAMES[normalizedType]) {
      displayName = `Qawaem ${resolveModuleDisplayName(normalizedType, t)}`;
    } else if (normalizedType && normalizedType.startsWith('CUSTOM:')) {
      displayName = p('license.custom');
    } else if (normalizedType === 'ENTERPRISE') {
      displayName = p('license.enterprise');
    }
    
    return {
      name: displayName,
      level: enabledModules.length,
      featureCount: enabledModules.length,
      totalFeatures: LICENSE_CATALOG_MODULE_COUNT
    };
  };

  const getPermissionLevel = (section) => editingPermissions[section] || PermissionLevels.NONE;

  const isSuperAdminUser = permissions.currentUser?.role === 'admin' || permissions.currentUser?.role === 'super_admin';

  const getUserSectionsCount = (userId) => {
    const eff = permissions.getUserEffectivePermissions(userId);
    return Object.keys(eff).filter((section) => eff[section] && eff[section] !== PermissionLevels.NONE).length;
  };

  const umGetSortInfo = (key) => {
    const index = umSortConfig.findIndex((sort) => sort.key === key);
    if (index === -1) return null;
    return {
      direction: umSortConfig[index].direction,
      order: index + 1,
      isMulti: umSortConfig.length > 1
    };
  };

  const umHandleSort = (key) => {
    setUmSortConfig((prev) => {
      const existingIndex = prev.findIndex((sort) => sort.key === key);
      if (existingIndex !== -1) {
        const existing = prev[existingIndex];
        if (existing.direction === 'asc') {
          const updated = [...prev];
          updated[existingIndex] = { key, direction: 'desc' };
          return updated;
        }
        return prev.filter((_, i) => i !== existingIndex);
      }
      return [...prev, { key, direction: 'asc' }];
    });
  };

  const openAddUserModal = () => {
    setEditingUserRecord(null);
    setUserFormData({
      nameAr: '', nameEn: '', username: '', email: '', role: '', tempPassword: '',
      phone: '', department: '', position: '', nationalId: '', residencyType: 'saudi',
      status: 'active', notes: '',
    });
    setUserFormExpandedSections({ identity: true, credentials: false, accessPreview: false, metadata: false });
    setShowAddUserModal(true);
  };

  const openEditUserModal = (user) => {
    setEditingUserRecord(user);
    setUserFormData({
      nameAr: user.nameAr || user.name_ar || '',
      nameEn: user.nameEn || user.name_en || user.name || '',
      username: user.username || user.name || '',
      email: user.email || '',
      role: user.role || '',
      tempPassword: '',
      phone: user.phone || '',
      department: user.department || '',
      position: user.position || '',
      nationalId: user.nationalId || user.national_id || '',
      residencyType: user.residencyType || user.residency_type || 'saudi',
      status: user.status || 'active',
      notes: user.notes || '',
    });
    setUserFormExpandedSections({ identity: true, credentials: false, accessPreview: false, metadata: false });
    setShowAddUserModal(true);
  };

  const buildUserPayload = () => ({
    name_ar: userFormData.nameAr.trim(),
    name_en: userFormData.nameEn.trim(),
    username: (userFormData.username || userFormData.nameEn || userFormData.nameAr).trim(),
    name: (userFormData.nameAr || userFormData.nameEn).trim(),
    email: userFormData.email.trim(),
    role: userFormData.role,
    phone: userFormData.phone ? normalizeSaudiPhone(userFormData.phone) : '',
    department: userFormData.department.trim(),
    position: userFormData.position.trim(),
    national_id: userFormData.nationalId.trim(),
    residency_type: userFormData.residencyType,
    status: userFormData.status,
    notes: userFormData.notes.trim(),
  });

  const handleUserFormSubmit = async (e) => {
    e.preventDefault();
    const displayName = userFormData.nameAr?.trim() || userFormData.nameEn?.trim();
    if (!displayName || !userFormData.email?.trim() || !userFormData.role) {
      window.alert(p('messages.user_fields_required'));
      return;
    }
    if (userFormData.phone && !isValidSaudiPhone(userFormData.phone)) {
      window.alert(p('messages.invalid_phone'));
      return;
    }
    try {
      const payload = buildUserPayload();
      if (editingUserRecord) {
        await permissions.updateUser(editingUserRecord.id, {
          ...payload,
          nameAr: payload.name_ar,
          nameEn: payload.name_en,
          nationalId: payload.national_id,
          residencyType: payload.residency_type,
        });
        try {
          await fetch(`${API_BASE}/users/${editingUserRecord.id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });
        } catch (_) { /* local-first */ }
      } else {
        const localUser = {
          ...payload,
          nameAr: payload.name_ar,
          nameEn: payload.name_en,
          nationalId: payload.national_id,
          residencyType: payload.residency_type,
        };
        await permissions.addUser(localUser);
        try {
          await fetch(`${API_BASE}/users`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...payload, password: userFormData.tempPassword || undefined }),
          });
        } catch (_) { /* local-first */ }
      }
      setShowAddUserModal(false);
      setEditingUserRecord(null);
      setUserFormData({
        nameAr: '', nameEn: '', username: '', email: '', role: '', tempPassword: '',
        phone: '', department: '', position: '', nationalId: '', residencyType: 'saudi',
        status: 'active', notes: '',
      });
      if (permissions.loadPermissionsData) await permissions.loadPermissionsData();
    } catch (err) {
      console.error(err);
      window.alert(p('messages.user_save_error'));
    }
  };

  const handleUmBulkDelete = async () => {
    if (!window.confirm(p('messages.confirm_delete_users', { count: umSelectedRecords.length }))) return;
    try {
      for (const id of umSelectedRecords) {
        if (id === permissions.currentUser?.id) continue;
        await permissions.deleteUser(id);
      }
      setUmSelectedRecords([]);
      setUmSelectAll(false);
      if (permissions.loadPermissionsData) await permissions.loadPermissionsData();
    } catch (e) {
      console.error(e);
    }
  };

  const handleUmDeleteOne = async (userId) => {
    if (userId === permissions.currentUser?.id) return;
    if (!window.confirm(p('messages.confirm_delete_user'))) return;
    try {
      await permissions.deleteUser(userId);
      if (permissions.loadPermissionsData) await permissions.loadPermissionsData();
    } catch (e) {
      console.error(e);
    }
  };

  const umStats = useMemo(() => {
    const users = permissions.users || [];
    const total = users.length;
    const active = users.filter((u) => u.status === 'active').length;
    const inactive = users.filter((u) => u.status !== 'active').length;
    const superC = users.filter((u) => u.role === 'super_admin' || u.role === 'admin').length;
    const avgSec =
      total > 0 ? (users.reduce((s, u) => s + getUserSectionsCount(u.id), 0) / total).toFixed(1) : '0';
    return { total, active, inactive, superC, avgSec };
  }, [permissions.users]);

  const filteredSortedUmUsers = useMemo(() => {
    const list = [...(permissions.users || [])];
    let base = list;
    const q = umSearchTerm.trim().toLowerCase();
    if (q) {
      base = base.filter(
        (u) =>
          (u.name || '').toLowerCase().includes(q) ||
          (u.email || '').toLowerCase().includes(q) ||
          String(u.id || '').toLowerCase().includes(q)
      );
    }
    if (umStatusFilter !== 'all') {
      base = base.filter((u) => u.status === umStatusFilter);
    }
    if (umQuickFilter === 'active') base = base.filter((u) => u.status === 'active');
    else if (umQuickFilter === 'inactive') base = base.filter((u) => u.status !== 'active');
    else if (umQuickFilter === 'super_admins') base = base.filter((u) => u.role === 'super_admin' || u.role === 'admin');
    if (umActiveDistributionFilter) {
      base = base.filter((u) => {
        const roleName = permissions.roles?.[u.role]?.name || u.role;
        return roleName === umActiveDistributionFilter;
      });
    }

    const compare = (a, b, key) => {
      let va; let vb;
      switch (key) {
        case 'id':
          va = String(a.id);
          vb = String(b.id);
          break;
        case 'name':
          va = (a.name || '').toLowerCase();
          vb = (b.name || '').toLowerCase();
          break;
        case 'email':
          va = (a.email || '').toLowerCase();
          vb = (b.email || '').toLowerCase();
          break;
        case 'role':
          va = (a.role || '').toLowerCase();
          vb = (b.role || '').toLowerCase();
          break;
        case 'sections':
          va = getUserSectionsCount(a.id);
          vb = getUserSectionsCount(b.id);
          break;
        case 'status':
          va = a.status || '';
          vb = b.status || '';
          break;
        default:
          return 0;
      }
      if (va < vb) return -1;
      if (va > vb) return 1;
      return 0;
    };

    const sorted = [...base];
    if (umSortConfig.length > 0) {
      sorted.sort((a, b) => {
        for (const { key, direction } of umSortConfig) {
          const c = compare(a, b, key);
          if (c !== 0) return direction === 'asc' ? c : -c;
        }
        return 0;
      });
    }
    return sorted;
  }, [
    permissions.users,
    permissions.roles,
    umSearchTerm,
    umStatusFilter,
    umQuickFilter,
    umActiveDistributionFilter,
    umSortConfig
  ]);

  const umDistributionInfo = useMemo(() => {
    const users = permissions.users || [];
    const totalSections = SAUDI_MODULE_KEYS.length;
    if (umMainViewMode === 'par_role') {
      const data = Object.keys(permissions.roles || {}).map((roleId) => ({
        name: permissions.roles[roleId].name,
        count: users.filter((u) => u.role === roleId).length,
        color:
          roleId === 'admin'
            ? 'bg-gradient-to-r from-red-500 to-red-600'
            : roleId === 'manager'
              ? 'bg-gradient-to-r from-green-500 to-green-600'
              : roleId === 'accountant'
                ? 'bg-gradient-to-r from-blue-500 to-blue-600'
                : 'bg-gradient-to-r from-yellow-500 to-yellow-600'
      }));
      return { title: p('users.chart_by_role'), data };
    }
    if (umMainViewMode === 'par_statut') {
      const act = users.filter((u) => u.status === 'active').length;
      const inact = users.filter((u) => u.status !== 'active').length;
      return {
        title: p('users.chart_by_status'),
        data: [
          { name: p('users_extra.active_label'), count: act, color: 'bg-gradient-to-r from-green-500 to-green-600' },
          { name: p('users_extra.inactive_label'), count: inact, color: 'bg-gradient-to-r from-gray-500 to-gray-600' }
        ]
      };
    }
    if (umMainViewMode === 'par_acces') {
      const high = users.filter((u) => getUserSectionsCount(u.id) >= Math.ceil(totalSections * 0.75)).length;
      const mid = users.filter((u) => {
        const n = getUserSectionsCount(u.id);
        return n >= Math.ceil(totalSections * 0.35) && n < Math.ceil(totalSections * 0.75);
      }).length;
      const low = users.filter((u) => getUserSectionsCount(u.id) < Math.ceil(totalSections * 0.35)).length;
      return {
        title: p('users.chart_access_load'),
        data: [
          { name: p('users.access_high'), count: high, color: 'bg-gradient-to-r from-green-500 to-green-600' },
          { name: p('users.access_medium'), count: mid, color: 'bg-gradient-to-r from-blue-500 to-blue-600' },
          { name: p('users.access_limited'), count: low, color: 'bg-gradient-to-r from-orange-500 to-orange-600' }
        ]
      };
    }
    const data = Object.keys(permissions.roles || {}).map((roleId) => ({
      name: permissions.roles[roleId].name,
      count: users.filter((u) => u.role === roleId).length,
      color:
        roleId === 'super_admin'
          ? 'bg-gradient-to-r from-red-500 to-red-600'
          : roleId === 'admin'
            ? 'bg-gradient-to-r from-blue-500 to-blue-600'
            : roleId === 'manager'
              ? 'bg-gradient-to-r from-green-500 to-green-600'
              : 'bg-gradient-to-r from-yellow-500 to-yellow-600'
    }));
    return { title: p('users.chart_overview'), data };
  }, [umMainViewMode, permissions.users, permissions.roles]);

  const toggleUserFormSection = (section) => {
    setUserFormExpandedSections((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  const exportUmUsers = (kind) => {
    const rows = filteredSortedUmUsers.map((u) => ({
      id: u.id,
      name: u.name,
      email: u.email,
      role: u.role,
      status: u.status,
      sections: getUserSectionsCount(u.id)
    }));
    const esc = (s) => `"${String(s).replace(/"/g, '""')}"`;
    if (kind === 'csv' || kind === 'excel') {
      const header = 'id,name,email,role,status,sections';
      const body = rows
        .map((r) => [r.id, r.name, r.email, r.role, r.status, r.sections].map(esc).join(','))
        .join('\n');
      const blob = new Blob([header + '\n' + body], { type: 'text/csv;charset=utf-8;' });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = kind === 'excel' ? p('users.export_filename_excel') : p('users.export_filename_csv');
      a.click();
    }
  };

  const handleUmSelectAllRows = () => {
    const ids = filteredSortedUmUsers.map((u) => u.id);
    setUmSelectAll(!umSelectAll);
    setUmSelectedRecords(umSelectAll ? [] : ids);
  };

  const handleUmSelectOneRow = (id) => {
    setUmSelectedRecords((prev) => (prev.includes(id) ? prev.filter((r) => r !== id) : [...prev, id]));
  };

  const getRoleLabel = (roleKey) => p(`roles.${roleKey}`, { defaultValue: roleKey });

  const umRoleSelectOptions = Object.entries(permissions.roles || {})
    .filter(([value]) => value !== 'super_admin')
    .map(([value]) => ({
      value,
      label: getRoleLabel(value),
      isDefault: true,
    }));
  
  // Profile component state
  const [showModelPreview, setShowModelPreview] = useState(false);
  
  // User Profile state (for Utilisateurs tab)
  const [profileUser, setProfileUser] = useState(null);
  const [profileFormData, setProfileFormData] = useState({
    name: '',
    email: '',
    jobTitle: '',
    phone: '',
    department: '',
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    resetCode: '',
  });
  const [profileMessage, setProfileMessage] = useState({ type: '', text: '' });
  const [securityMessage, setSecurityMessage] = useState({ type: '', text: '' });
  const [isEditingProfile, setIsEditingProfile] = useState(false);
  const [isChangingPassword, setIsChangingPassword] = useState(false);
  const [isResettingWithCode, setIsResettingWithCode] = useState(false);
  const [showProfileSection, setShowProfileSection] = useState(false); // Collapsed by default for admins
  const [showLicenseKey, setShowLicenseKey] = useState(false);
  const [appUpdateStatus, setAppUpdateStatus] = useState(null);
  const [appUpdateChecking, setAppUpdateChecking] = useState(false);
  const appUpdateUiPhase = useMemo(() => resolveUpdateUiPhase(appUpdateStatus), [appUpdateStatus]);
  
  // Lock body scroll when modal is open
  useEffect(() => {
    if (showModelPreview) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [showModelPreview]);
  
  // Function to check if a model is premium
  const isModelPremium = (modelName) => {
    const freeModels = ['classic', 'modern'];
    return !freeModels.includes(modelName);
  };
  const [extractingColors, setExtractingColors] = useState(false);
  
  // Backup functionality state
  const [backupSettings, setBackupSettings] = useState({
    autoBackup: true,
    frequency: 'daily', // daily, weekly, monthly
    cloudSync: false,
    maxBackups: 10,
    includeDocuments: true,
    includeSettings: true,
    includeClients: true,
    includeEmployees: true,
    includeProducts: true,
    includeCategories: true,
    backupLocation: 'local', // local, cloud
    lastBackup: null,
    nextScheduledBackup: null // Add next backup time
  });
  const [backupHistory, setBackupHistory] = useState([]);
  const [isBackupInProgress, setIsBackupInProgress] = useState(false);
  const [backupMessage, setBackupMessage] = useState({ type: '', text: '' });
  const [autoBackupStatus, setAutoBackupStatus] = useState('inactive'); // inactive, active, pending

  // Sauvegarde tab — ~80% Facturiers / FuelPurchases layout patterns
  const [backupShowAdvancedOptions, setBackupShowAdvancedOptions] = useState(false);
  const [backupViewMode, setBackupViewMode] = useState('table');
  const [backupSearchTerm, setBackupSearchTerm] = useState('');
  const [backupTypeFilterOpen, setBackupTypeFilterOpen] = useState(false);
  const [backupTypeFilter, setBackupTypeFilter] = useState('all');
  const [backupMainViewMode, setBackupMainViewMode] = useState('all_backups');
  const [backupQuickFilter, setBackupQuickFilter] = useState('all');
  const [backupActiveDistributionFilter, setBackupActiveDistributionFilter] = useState(null);
  const [selectedBackupForView, setSelectedBackupForView] = useState(null);
  const [showBackupDetailsModal, setShowBackupDetailsModal] = useState(false);
  const [selectedAuditLogForView, setSelectedAuditLogForView] = useState(null);
  const [showAuditDetailsModal, setShowAuditDetailsModal] = useState(false);
  const [backupExpandedConfig, setBackupExpandedConfig] = useState({ autoConfig: true, storage: false, quickActions: false });
  const [backupExportDropdownOpen, setBackupExportDropdownOpen] = useState(false);

  const backupFolderDisplay = useMemo(() => {
    if (typeof process !== 'undefined' && process.env && process.env.APPDATA) {
      return `${process.env.APPDATA}\\Qawaem\\Backups\\`;
    }
    return 'C:\\Users\\[USER]\\AppData\\Local\\Qawaem\\Backups\\';
  }, []);

  const backupManualCount = useMemo(
    () => backupHistory.filter((b) => b.type === 'manual').length,
    [backupHistory]
  );
  const backupAutoCount = useMemo(
    () => backupHistory.filter((b) => b.type === 'auto' || b.type === 'automatic').length,
    [backupHistory]
  );
  const backupTotalSizeBytes = useMemo(
    () => backupHistory.reduce((acc, b) => acc + (b.size || 0), 0),
    [backupHistory]
  );

  const filteredBackupHistoryView = useMemo(() => {
    let list = [...backupHistory].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
    if (backupSearchTerm.trim()) {
      const q = backupSearchTerm.toLowerCase();
      list = list.filter((b) => (b.fileName || '').toLowerCase().includes(q));
    }
    const effectiveType = backupTypeFilter !== 'all' ? backupTypeFilter : backupQuickFilter;
    if (effectiveType === 'manual') list = list.filter((b) => b.type === 'manual');
    if (effectiveType === 'auto') list = list.filter((b) => b.type === 'auto' || b.type === 'automatic');
    if (backupActiveDistributionFilter === 'manual') list = list.filter((b) => b.type === 'manual');
    if (backupActiveDistributionFilter === 'auto') list = list.filter((b) => b.type === 'auto' || b.type === 'automatic');
    return list;
  }, [backupHistory, backupSearchTerm, backupTypeFilter, backupQuickFilter, backupActiveDistributionFilter]);

  const backupDistributionData = useMemo(() => {
    const pairTotal = Math.max(backupManualCount + backupAutoCount, 1);
    return [
      {
        id: 'manual',
        name: p('billing.backup.distribution_manual'),
        count: backupManualCount,
        pct: pairTotal > 0 ? ((backupManualCount / pairTotal) * 100).toFixed(1) : '0',
        color: 'bg-blue-500'
      },
      {
        id: 'auto',
        name: p('billing.backup.distribution_auto'),
        count: backupAutoCount,
        pct: pairTotal > 0 ? ((backupAutoCount / pairTotal) * 100).toFixed(1) : '0',
        color: 'bg-emerald-500'
      },
      {
        id: 'all',
        name: p('billing.backup.distribution_all'),
        count: backupHistory.length,
        pct: backupHistory.length > 0 ? '100' : '0',
        color: 'bg-purple-500'
      }
    ];
  }, [backupHistory.length, backupManualCount, backupAutoCount, p]);
  
  // RE-ADD color picker states to avoid reference errors
  const [isColorPickerActive, setIsColorPickerActive] = useState(false);
  const [activeColorTarget, setActiveColorTarget] = useState(null); // 'primary' or 'secondary'
  const logoRef = useRef(null);
  
  // Enhanced function to get color at a specific point in an image
  const getPixelColor = (img, x, y) => {
    try {
      console.log(`Getting color at coordinates: x=${x}, y=${y}`);
      console.log(`Image dimensions: width=${img.width || img.naturalWidth}, height=${img.height || img.naturalHeight}`);
      
      // Create a canvas element
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      // Get actual displayed dimensions (accounting for object-fit: contain)
      const imgRect = img.getBoundingClientRect();
      const displayWidth = imgRect.width;
      const displayHeight = imgRect.height;
      
      // Get natural dimensions
      const naturalWidth = img.naturalWidth;
      const naturalHeight = img.naturalHeight;
      
      console.log(`Display dimensions: width=${displayWidth}, height=${displayHeight}`);
      console.log(`Natural dimensions: width=${naturalWidth}, height=${naturalHeight}`);
      
      // Calculate the scaling factor
      let scaleX = naturalWidth / displayWidth;
      let scaleY = naturalHeight / displayHeight;
      
      // Adjust for object-fit: contain (which preserves aspect ratio)
      // This means the image might not fill the entire container
      const aspectRatio = naturalWidth / naturalHeight;
      const containerAspectRatio = displayWidth / displayHeight;
      
      let offsetX = 0;
      let offsetY = 0;
      
      if (aspectRatio > containerAspectRatio) {
        // Image is wider than container (has horizontal margins)
        const actualHeight = displayWidth / aspectRatio;
        offsetY = (displayHeight - actualHeight) / 2;
        scaleY = naturalHeight / actualHeight;
      } else {
        // Image is taller than container (has vertical margins)
        const actualWidth = displayHeight * aspectRatio;
        offsetX = (displayWidth - actualWidth) / 2;
        scaleX = naturalWidth / actualWidth;
      }
      
      // Adjust click coordinates to account for margins
      if (x < offsetX || y < offsetY || 
          x > displayWidth - offsetX || 
          y > displayHeight - offsetY) {
        console.log("Click outside actual image bounds");
        return null;
      }
      
      // Convert display coordinates to actual image coordinates
      const adjustedX = (x - offsetX) * scaleX;
      const adjustedY = (y - offsetY) * scaleY;
      
      console.log(`Adjusted coordinates: x=${adjustedX}, y=${adjustedY}`);
      
      // Set canvas to natural image size
      canvas.width = naturalWidth;
      canvas.height = naturalHeight;
      
      // Draw the image to the canvas at full size
      ctx.drawImage(img, 0, 0);
      
      // Get the pixel data at the calculated coordinates
      // Make sure coordinates are integers within bounds
      const pixelX = Math.min(Math.max(Math.round(adjustedX), 0), naturalWidth - 1);
      const pixelY = Math.min(Math.max(Math.round(adjustedY), 0), naturalHeight - 1);
      
      const pixelData = ctx.getImageData(pixelX, pixelY, 1, 1).data;
      
      console.log(`Pixel data at (${pixelX}, ${pixelY}):`, 
                  `R: ${pixelData[0]}, G: ${pixelData[1]}, B: ${pixelData[2]}`);
      
      // Convert RGB to hex
      const hex = '#' + 
        ('0' + pixelData[0].toString(16)).slice(-2) + 
        ('0' + pixelData[1].toString(16)).slice(-2) + 
        ('0' + pixelData[2].toString(16)).slice(-2);
      
      console.log(`Selected color: ${hex}`);
      return hex;
    } catch (e) {
      console.error("Error picking color:", e);
      return null;
    }
  };

  // Helper function to convert RGB to HEX
  const rgbToHex = (r, g, b) => {
    return '#' + [r, g, b].map(x => {
      const hex = x.toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    }).join('');
  };

  // Pure JavaScript function to extract dominant colors from an image
  const extractColorsFromImage = (img) => {
    return new Promise((resolve, reject) => {
      try {
        // Create a canvas to analyze the image
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        // Set canvas dimensions - limit size for performance
        const maxDim = 100; // Small enough for performance
        let width = img.width || img.naturalWidth;
        let height = img.height || img.naturalHeight;
        
        // Calculate aspect ratio for resizing
        if (width > height) {
          if (width > maxDim) {
            height = Math.floor(height * (maxDim / width));
            width = maxDim;
          }
        } else {
          if (height > maxDim) {
            width = Math.floor(width * (maxDim / height));
            height = maxDim;
          }
        }
        
        canvas.width = width;
        canvas.height = height;
        
        // Draw the image onto the canvas
        ctx.drawImage(img, 0, 0, width, height);
        
        // Get pixel data
        let imageData;
        try {
          imageData = ctx.getImageData(0, 0, width, height);
        } catch (e) {
          console.error("Error getting image data:", e);
          throw new Error("Cannot access image data: CORS issue or invalid image");
        }
        
        const pixels = imageData.data;
        const pixelCount = width * height;
        const colorCounts = {};
        const distinctColors = [];
        
        // Sample pixels (skip some pixels for performance)
        const sampleStep = Math.max(1, Math.floor(pixelCount / 1000));
        
        for (let i = 0; i < pixels.length; i += 4 * sampleStep) {
          const r = pixels[i];
          const g = pixels[i + 1];
          const b = pixels[i + 2];
          const a = pixels[i + 3];
          
          // Skip transparent pixels
          if (a < 128) continue;
          
          // Skip very dark and very light pixels
          const brightness = (r * 299 + g * 587 + b * 114) / 1000;
          if (brightness < 20 || brightness > 235) continue;
          
          // Create a simple color key (reduces similar colors)
          const colorKey = Math.floor(r/10)*1000000 + Math.floor(g/10)*1000 + Math.floor(b/10);
          
          if (!colorCounts[colorKey]) {
            colorCounts[colorKey] = {
              count: 1,
              r, g, b,
              // Calculate saturation
              saturation: (() => {
                const max = Math.max(r, g, b);
                const min = Math.min(r, g, b);
                return max === 0 ? 0 : (max - min) / max;
              })()
            };
            distinctColors.push(colorCounts[colorKey]);
          } else {
            colorCounts[colorKey].count++;
          }
        }
        
        // No colors found
        if (distinctColors.length === 0) {
          throw new Error("No colors could be extracted from the image");
        }
        
        // Sort colors by frequency
        distinctColors.sort((a, b) => b.count - a.count);
        
        // Get top colors (most frequent)
        const topColors = distinctColors.slice(0, Math.min(10, distinctColors.length));
        
        // For primary color, prefer saturated colors among the top colors
        topColors.sort((a, b) => b.saturation - a.saturation);
        
        // Primary color is the most saturated among top colors
        const primaryColor = rgbToHex(topColors[0].r, topColors[0].g, topColors[0].b);
        
        // For secondary color, find a contrasting color
        let secondaryColor;
        
        // Look for a dark color first
        const darkColors = distinctColors.filter(c => {
          const brightness = (c.r * 299 + c.g * 587 + c.b * 114) / 1000;
          return brightness < 60; // Dark enough
        });
        
        if (darkColors.length > 0) {
          // Use the most frequent dark color
          darkColors.sort((a, b) => b.count - a.count);
          secondaryColor = rgbToHex(darkColors[0].r, darkColors[0].g, darkColors[0].b);
        } else {
          // Otherwise find a contrasting color
          const mainColorRGB = topColors[0];
          
          // Calculate contrast with the primary color
          distinctColors.forEach(color => {
            color.contrast = Math.sqrt(
              Math.pow(color.r - mainColorRGB.r, 2) + 
              Math.pow(color.g - mainColorRGB.g, 2) + 
              Math.pow(color.b - mainColorRGB.b, 2)
            );
          });
          
          // Sort by contrast
          distinctColors.sort((a, b) => b.contrast - a.contrast);
          
          // Choose the most contrasting color
          secondaryColor = rgbToHex(distinctColors[0].r, distinctColors[0].g, distinctColors[0].b);
        }
        
        console.log("Extracted colors:", { primaryColor, secondaryColor });
        
        resolve({ primaryColor, secondaryColor });
      } catch (error) {
        console.error('Error extracting colors:', error);
        reject(error);
      }
    });
  };

  const saudiRegionOptions = SAUDI_REGION_OPTIONS;
  const saudiCityOptions = SAUDI_CITY_OPTIONS;
  const saudiBanks = SAUDI_BANKS;

  const parseBankAccount = (record) => normalizeBankAccountRecord(record);

  // Ensure settings objects exist with defaults
  const company = settings?.company || {};
  const design = settings?.design || {};
  const invoicing = settings?.invoicing || {};
  const taxes = settings?.taxes || {};
  const notifications = settings?.notifications || {};

  const [bankAccounts, setBankAccounts] = useState(() => {
    if (company.bankAccountsArray && Array.isArray(company.bankAccountsArray) && company.bankAccountsArray.length > 0) {
      return company.bankAccountsArray.map(parseBankAccount);
    }
    const accounts = [];
    if (company.bankAccount1) accounts.push(parseBankAccount(company.bankAccount1));
    if (company.bankAccount2) accounts.push(parseBankAccount(company.bankAccount2));
    if (company.bankAccount3) accounts.push(parseBankAccount(company.bankAccount3));
    if (accounts.length === 0) accounts.push(defaultSaudiBankSlot());
    return accounts;
  });

  const [phoneError, setPhoneError] = useState('');
  const [mobileError, setMobileError] = useState('');
  const [vatError, setVatError] = useState('');
  const [postalError, setPostalError] = useState('');

  useEffect(() => {
    if (company.bankAccountsArray && Array.isArray(company.bankAccountsArray) && company.bankAccountsArray.length > 0) {
      setBankAccounts(company.bankAccountsArray.map(parseBankAccount));
      return;
    }
    const accounts = [];
    if (company.bankAccount1) accounts.push(parseBankAccount(company.bankAccount1));
    if (company.bankAccount2) accounts.push(parseBankAccount(company.bankAccount2));
    if (company.bankAccount3) accounts.push(parseBankAccount(company.bankAccount3));
    if (accounts.length === 0) accounts.push(defaultSaudiBankSlot());
    setBankAccounts(accounts);
  }, [company.bankAccount1, company.bankAccount2, company.bankAccount3, company.bankAccountsArray]);

  const syncBankAccountsToSettings = (accounts) => {
    updateSettings('company', 'bankAccount1', formatBankAccountLegacyString(accounts[0]));
    updateSettings('company', 'bankAccount2', formatBankAccountLegacyString(accounts[1]));
    updateSettings('company', 'bankAccount3', formatBankAccountLegacyString(accounts[2]));
    updateSettings('company', 'bankAccountsArray', accounts);
  };

  const addBankAccount = () => {
    const next = [...bankAccounts, defaultSaudiBankSlot()];
    setBankAccounts(next);
    syncBankAccountsToSettings(next);
  };

  const removeBankAccount = (index) => {
    if (bankAccounts.length <= 1) return;
    const newAccounts = bankAccounts.filter((_, i) => i !== index);
    setBankAccounts(newAccounts);
    syncBankAccountsToSettings(newAccounts);
  };

  const handleBankAccountChange = (index, field, value) => {
    let nextValue = value;
    if (field === 'iban') {
      nextValue = normalizeSaudiIban(value);
    }
    if (field === 'bank') {
      const bankMeta = SAUDI_BANKS.find((b) => b.code === value);
      const newAccounts = [...bankAccounts];
      newAccounts[index] = {
        ...defaultSaudiBankSlot(),
        ...(newAccounts[index] || {}),
        bank: value,
        swift: bankMeta?.swift || newAccounts[index]?.swift || '',
      };
      setBankAccounts(newAccounts);
      syncBankAccountsToSettings(newAccounts);
      return;
    }
    const newAccounts = [...bankAccounts];
    newAccounts[index] = { ...defaultSaudiBankSlot(), ...(newAccounts[index] || {}), [field]: nextValue };
    setBankAccounts(newAccounts);
    syncBankAccountsToSettings(newAccounts);
  };

  const handleCompanyPhoneBlur = (field, rawValue) => {
    const normalized = normalizeBrandPhone(rawValue);
    updateSettings('company', field, normalized);
    const valid = isBrandPhoneValid(normalized);
    if (field === 'phone') setPhoneError(valid || !normalized ? '' : p('validation.phone_invalid'));
    if (field === 'mobile') setMobileError(valid || !normalized ? '' : p('validation.phone_invalid'));
  };

  const handleVatBlur = (rawValue) => {
    const result = validateSaudiVatNumber(rawValue);
    if (result.valid && result.value != null) {
      updateSettings('company', 'vatNumber', result.value);
      setVatError('');
    } else if (!rawValue) {
      setVatError('');
    } else {
      setVatError(p(`validation.${result.message}`));
    }
  };

  const handlePostalBlur = (rawValue) => {
    const result = validateSaudiPostalCode(rawValue);
    if (result.valid && result.value != null) {
      updateSettings('company', 'postalCode', result.value);
      setPostalError('');
    } else if (!rawValue) {
      setPostalError('');
    } else {
      setPostalError(p('validation.postal_invalid'));
    }
  };

  const handleSave = async () => {
    try {
      // Save all settings at once to ensure they're properly persisted
      console.log('Saving all settings:', settings);
      
      // Capture what was changed for audit log
      const changedFields = [];
      const oldSettings = await settingsService.get();
      
      // Check company info changes
      if (settings.company?.name !== oldSettings.company?.name) {
        changedFields.push(p('audit.changes.name', { old: oldSettings.company?.name, new: settings.company?.name }));
      }
      if (settings.company?.address !== oldSettings.company?.address) changedFields.push(p('audit.changes.address'));
      if (settings.company?.phone !== oldSettings.company?.phone) changedFields.push(p('audit.changes.phone', { value: settings.company?.phone }));
      if (settings.company?.email !== oldSettings.company?.email) changedFields.push(p('audit.changes.email', { value: settings.company?.email }));
      
      // Check tax changes
      if (settings.taxes?.tva !== oldSettings.taxes?.tva) changedFields.push(p('audit.changes.vat', { value: settings.taxes?.tva }));
      if (settings.taxes?.tap !== oldSettings.taxes?.tap) changedFields.push(p('audit.changes.withholding', { value: settings.taxes?.tap }));
      
      // Check currency changes
      if (settings.currency !== oldSettings.currency) changedFields.push(p('audit.changes.currency', { value: settings.currency }));
      
      await settingsService.update(settings);
      console.log('Settings saved successfully');
      
      // Log the specific changes
      if (changedFields.length > 0) {
        logAuditEvent(
          AuditAction.SETTINGS_UPDATE,
          'System settings',
          `Changes: ${changedFields.join(', ')}`,
          AuditLevel.SUCCESS,
          { changesCount: changedFields.length, fields: changedFields }
        );
      }
      
      setUnsavedChanges(false);
      alert(p('messages.save_success'));
    } catch (error) {
      console.error('Error saving settings:', error);
      logAuditEvent(
        AuditAction.SETTINGS_UPDATE,
        'System settings',
        `Save failed: ${error.message}`,
        AuditLevel.ERROR
      );
      alert(p('messages.save_error'));
    }
  };

  // Function to reset setup and go to setup page
  const handleResetSetup = () => {
    if (window.confirm(p('messages.confirm_reset_config'))) {
      // Navigate to the reset page
      navigate('/reset');
    }
  };

  // Backup functionality functions
  const generateBackupData = async () => {
    const backupData = {
      timestamp: new Date().toISOString(),
      version: '1.0.0',
      appName: 'Qawaem',
      data: {},
      metadata: {
        userAgent: navigator.userAgent,
        language: navigator.language,
        totalItems: 0
      }
    };

    let totalItems = 0;
    
    console.log('🔄 Starting backup process - fetching data from DATABASE...');

    try {
      if (backupSettings.includeSettings) {
        // Include current settings from context and localStorage
        const localStorageSettings = JSON.parse(localStorage.getItem(QAWAEM_SETTINGS_KEY) || '{}');
        backupData.data.settings = { 
          ...localStorageSettings, 
          ...settings // Current context settings take priority
        };
        if (Object.keys(backupData.data.settings).length > 0) {
          totalItems++;
          console.log('✅ Application settings:', Object.keys(backupData.data.settings).length, 'settings found');
        } else {
          console.log('⚠️ Application settings: No settings data found');
        }
      }

      if (backupSettings.includeDocuments) {
        // Get documents from DATABASE via service
        try {
          const documents = await documentService.getDocuments();
          if (Array.isArray(documents) && documents.length > 0) {
            backupData.data.documents = documents;
            totalItems += documents.length;
            console.log('✅ Archives:', documents.length, 'documents found from DATABASE');
          } else {
            console.log('⚠️ Archives: No documents found in DATABASE');
          }
        } catch (error) {
          console.warn('❌ Archives: Could not retrieve documents from database:', error);
          backupData.data.documents = [];
        }
      }

      if (backupSettings.includeClients) {
        try {
          let clientsFound = 0;
          // Get clients from DATABASE via service
          const clients = await clientService.getClients();
          if (Array.isArray(clients) && clients.length > 0) {
            backupData.data.clients = clients;
            totalItems += clients.length;
            clientsFound += clients.length;
          }
          
          // Note: Suppliers and partners are typically handled within clients in most systems
          // If they're separate, you would need specific services for them
          
          if (clientsFound > 0) {
            console.log('✅ Clients & Fournisseurs:', clientsFound, 'contacts found from DATABASE');
          } else {
            console.log('⚠️ Clients & Fournisseurs: No contacts found in DATABASE');
          }
        } catch (error) {
          console.warn('❌ Clients & Fournisseurs: Could not retrieve clients from database:', error);
          backupData.data.clients = [];
        }
      }

      if (backupSettings.includeProducts) {
        try {
          // Get products from DATABASE via service
          const products = await productService.getProducts();
          if (Array.isArray(products) && products.length > 0) {
            backupData.data.products = products;
            totalItems += products.length;
            console.log('✅ Produits et services:', products.length, 'products found from DATABASE');
          } else {
            console.log('⚠️ Produits et services: No products found in DATABASE');
          }
        } catch (error) {
          console.warn('❌ Produits et services: Could not retrieve products from database:', error);
          backupData.data.products = [];
        }
      }

      if (backupSettings.includeEmployees) {
        try {
          // Get employees from DATABASE via service
          const employees = await employeeService.getEmployees();
          if (Array.isArray(employees) && employees.length > 0) {
            backupData.data.employees = employees;
            totalItems += employees.length;
            console.log('✅ Employees:', employees.length, 'employees found from DATABASE');
          } else {
            console.log('⚠️ Employees: No employees found in DATABASE');
          }
        } catch (error) {
          console.warn('❌ Employees: Could not retrieve employees from database:', error);
          backupData.data.employees = [];
        }
      }

      if (backupSettings.includeCategories) {
        try {
          // Get categories from DATABASE via service
          const categories = await categoryService.getCategories();
          if (Array.isArray(categories) && categories.length > 0) {
            backupData.data.categories = categories;
            totalItems += categories.length;
            console.log('✅ Categories:', categories.length, 'categories found from DATABASE');
          } else {
            console.log('⚠️ Categories: No categories found in DATABASE');
          }
        } catch (error) {
          console.warn('❌ Categories: Could not retrieve categories from database:', error);
          backupData.data.categories = [];
        }
      }

      // Also backup other important data
      try {
        const backupHistoryData = JSON.parse(localStorage.getItem('backupHistory') || '[]');
        if (Array.isArray(backupHistoryData) && backupHistoryData.length > 0) {
          backupData.data.backupHistory = backupHistoryData;
        }
      } catch (error) {
        console.warn('Could not retrieve backup history:', error);
      }

    } catch (error) {
      console.error('Error generating backup data:', error);
      throw new Error(p('messages.backup_gen_error'));
    }

    backupData.metadata.totalItems = totalItems;
    return backupData;
  };

  const createBackup = async (options = {}) => {
    const isScheduled = !!options.scheduled;
    setIsBackupInProgress(true);
    setBackupMessage({ type: '', text: '' });

    try {
      // Call the desktop backup service
      const backup = await backupService.createBackup();

      // Reload backup stats and list
      const [stats, backups] = await Promise.all([
        backupService.getBackupStats(),
        backupService.getBackups()
      ]);

      // Stats are computed automatically via useMemo from backupHistory
      // Update backup history with new data
      
      // Convert backups to history format
      const convertedBackups = backups.map(b => ({
        id: b.id,
        fileName: b.fileName,
        timestamp: b.date,
        dateFormatted: b.dateFormatted,
        size: b.size,
        sizeFormatted: b.sizeFormatted,
        type: b.type
      }));
      
      setBackupHistory(convertedBackups);

      // Update last backup time
      const updatedBackupSettings = { ...backupSettings, lastBackup: backup.date };
      setBackupSettings(updatedBackupSettings);
      localStorage.setItem('backupSettings', JSON.stringify(updatedBackupSettings));

      setBackupMessage({
        type: 'success',
        text: isScheduled 
          ? p('messages.backup_auto_created') 
          : p('messages.backup_manual_created')
      });
      
      logAuditEvent({
        action: AuditAction.BACKUP_CREATE,
        level: AuditLevel.INFO,
        details: `Backup created: ${backup.fileName} (${backup.sizeFormatted})`,
        user: permissions.currentUser?.username || 'System'
      });
    } catch (error) {
      console.error('Backup creation error:', error);
      setBackupMessage({
        type: 'error',
        text: error.message || p('messages.backup_create_error')
      });
      
      logAuditEvent({
        action: AuditAction.BACKUP_CREATE,
        level: AuditLevel.ERROR,
        details: `Backup creation failed: ${error.message}`,
        user: permissions.currentUser?.username || 'System'
      });
    } finally {
      setIsBackupInProgress(false);
    }
  };

  const importBackup = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setBackupMessage({ type: '', text: '' });

    // Validate file
    if (!file.name.endsWith('.json')) {
      setBackupMessage({ 
        type: 'error', 
        text: p('messages_extra.invalid_json_file') 
      });
      event.target.value = '';
      return;
    }

    // Check file size (max 50MB)
    if (file.size > 50 * 1024 * 1024) {
      setBackupMessage({ 
        type: 'error', 
        text: p('messages.backup_file_too_large') 
      });
      event.target.value = '';
      return;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        // Parse JSON with error handling
        let backupData;
        try {
          backupData = JSON.parse(e.target.result);
        } catch (parseError) {
          throw new Error(p('messages.backup_invalid_json'));
        }
        
        // Validate backup structure
        if (!backupData || typeof backupData !== 'object') {
          throw new Error(p('messages.backup_invalid_structure'));
        }

        if (!backupData.data || !backupData.timestamp) {
          throw new Error(p('messages.backup_invalid_format'));
        }

        // Validate data types
        if (typeof backupData.data !== 'object') {
          throw new Error(p('messages.backup_corrupt_data'));
        }

        // Count data to import with detailed validation
        const dataTypes = Object.keys(backupData.data);
        const dataCount = dataTypes.length;
        
        if (dataCount === 0) {
          throw new Error(p('messages.backup_empty'));
        }

        // Detailed data analysis
        const dataAnalysis = {
          settings: backupData.data.settings ? Object.keys(backupData.data.settings).length : 0,
          documents: Array.isArray(backupData.data.documents) ? backupData.data.documents.length : 0,
          clients: Array.isArray(backupData.data.clients) ? backupData.data.clients.length : 0,
          employees: Array.isArray(backupData.data.employees) ? backupData.data.employees.length : 0,
          categories: Array.isArray(backupData.data.categories) ? backupData.data.categories.length : 0,
          products: Array.isArray(backupData.data.products) ? backupData.data.products.length : 0,
        };

        const totalItems = Object.values(dataAnalysis).reduce((sum, count) => sum + count, 0);
        
        const confirmMessage = buildBackupRestoreConfirmMessage(backupData, dataAnalysis, totalItems, p);

        if (!window.confirm(confirmMessage)) {
          event.target.value = '';
          setBackupMessage({ 
            type: 'info', 
            text: p('messages.backup_import_cancelled') 
          });
          setTimeout(() => setBackupMessage({ type: '', text: '' }), 3000);
          return;
        }

        // Validate localStorage availability
        if (typeof Storage === 'undefined') {
          throw new Error(p('messages.backup_storage_unavailable'));
        }

        let importedCount = 0;

        // Import data with validation - RESTORE TO DATABASE (REPLACE MODE)
        try {
          console.log('🔄 Starting comprehensive database restore process...');
          console.log(`📊 Restoring ${totalItems} total items across ${dataCount} categories`);
          console.log('⚠️  REPLACE MODE: All existing data will be cleared first!');
          
          let restoredItems = {
            settings: 0,
            documents: 0,
            clients: 0,
            employees: 0,
            categories: 0,
            products: 0,
            errors: 0
          };
          
          // PHASE 1: CLEAR EXISTING DATA
          console.log('\n🧹 PHASE 1: Clearing existing data...');
          
          // Clear existing documents if we're restoring documents
          if (backupData.data.documents && Array.isArray(backupData.data.documents)) {
            try {
              console.log('🗑️ Clearing existing documents...');
              const existingDocs = await documentService.getDocuments();
              if (existingDocs && existingDocs.length > 0) {
                for (const doc of existingDocs) {
                  try {
                    await documentService.deleteDocument(doc.id);
                  } catch (delError) {
                    console.warn(`⚠️ Could not delete existing document ${doc.id}:`, delError);
                  }
                }
                console.log(`✅ Cleared ${existingDocs.length} existing documents`);
              }
            } catch (error) {
              console.warn('⚠️ Error clearing existing documents:', error);
            }
          }
          
          // Clear existing clients if we're restoring clients
          if (backupData.data.clients && Array.isArray(backupData.data.clients)) {
            try {
              console.log('🗑️ Clearing existing clients...');
              const existingClients = await clientService.getClients();
              if (existingClients && existingClients.length > 0) {
                for (const client of existingClients) {
                  try {
                    await clientService.deleteClient(client.id);
                  } catch (delError) {
                    console.warn(`⚠️ Could not delete existing client ${client.id}:`, delError);
                  }
                }
                console.log(`✅ Cleared ${existingClients.length} existing clients`);
              }
            } catch (error) {
              console.warn('⚠️ Error clearing existing clients:', error);
            }
          }
          
          // Clear existing employees if we're restoring employees
          if (backupData.data.employees && Array.isArray(backupData.data.employees)) {
            try {
              console.log('🗑️ Clearing existing employees...');
              const existingEmployees = await employeeService.getEmployees();
              if (existingEmployees && existingEmployees.length > 0) {
                for (const emp of existingEmployees) {
                  try {
                    await employeeService.deleteEmployee(emp.id);
                  } catch (delError) {
                    console.warn(`⚠️ Could not delete existing employee ${emp.id}:`, delError);
                  }
                }
                console.log(`✅ Cleared ${existingEmployees.length} existing employees`);
              }
            } catch (error) {
              console.warn('⚠️ Error clearing existing employees:', error);
            }
          }
          
          // Clear existing categories if we're restoring categories
          if (backupData.data.categories && Array.isArray(backupData.data.categories)) {
            try {
              console.log('🗑️ Clearing existing categories...');
              const existingCategories = await categoryService.getCategories();
              if (existingCategories && existingCategories.length > 0) {
                for (const cat of existingCategories) {
                  try {
                    await categoryService.deleteCategory(cat.id);
                  } catch (delError) {
                    console.warn(`⚠️ Could not delete existing category ${cat.id}:`, delError);
                  }
                }
                console.log(`✅ Cleared ${existingCategories.length} existing categories`);
              }
            } catch (error) {
              console.warn('⚠️ Error clearing existing categories:', error);
            }
          }
          
          // Clear existing products if we're restoring products
          if (backupData.data.products && Array.isArray(backupData.data.products)) {
            try {
              console.log('🗑️ Clearing existing products...');
              const existingProducts = await productService.getProducts();
              if (existingProducts && existingProducts.length > 0) {
                for (const prod of existingProducts) {
                  try {
                    await productService.deleteProduct(prod.id);
                  } catch (delError) {
                    console.warn(`⚠️ Could not delete existing product ${prod.id}:`, delError);
                  }
                }
                console.log(`✅ Cleared ${existingProducts.length} existing products`);
              }
            } catch (error) {
              console.warn('⚠️ Error clearing existing products:', error);
            }
          }
          
          console.log('✅ PHASE 1 COMPLETED: All existing data cleared');
          console.log('\n📥 PHASE 2: Restoring backup data...');
          
          // PHASE 2: RESTORE BACKUP DATA
          
          // Restore settings (keep in localStorage as they're app configuration)
          if (backupData.data.settings) {
            localStorage.setItem(QAWAEM_SETTINGS_KEY, JSON.stringify(backupData.data.settings));
            window.dispatchEvent(new CustomEvent('refresh-settings'));
            restoredItems.settings = Object.keys(backupData.data.settings).length;
            importedCount++;
            console.log(`✅ Settings restored: ${restoredItems.settings} configurations`);
          }
          
          // Restore documents to database
          if (backupData.data.documents && Array.isArray(backupData.data.documents)) {
            console.log(`📄 Restoring ${backupData.data.documents.length} documents...`);
            for (const document of backupData.data.documents) {
              try {
                // Create new document in database (let the service handle ID generation)
                const docToCreate = { ...document };
                delete docToCreate.id; // Remove ID to let database generate new one
                await documentService.createDocument(docToCreate);
                restoredItems.documents++;
              } catch (docError) {
                console.warn(`⚠️ Could not restore document ${document.number || 'N/A'}:`, docError);
                restoredItems.errors++;
              }
            }
            importedCount++;
            console.log(`✅ Documents restored: ${restoredItems.documents}/${backupData.data.documents.length} (${restoredItems.errors} errors)`);
          }
          
          // Restore clients to database
          if (backupData.data.clients && Array.isArray(backupData.data.clients)) {
            console.log(`👥 Restoring ${backupData.data.clients.length} clients...`);
            for (const client of backupData.data.clients) {
              try {
                // Create new client in database
                const clientToCreate = { ...client };
                delete clientToCreate.id; // Remove ID to let database generate new one
                await clientService.createClient(clientToCreate);
                restoredItems.clients++;
              } catch (clientError) {
                console.warn(`⚠️ Could not restore client ${client.name || 'N/A'}:`, clientError);
                restoredItems.errors++;
              }
            }
            importedCount++;
            console.log(`✅ Clients restored: ${restoredItems.clients}/${backupData.data.clients.length} (${restoredItems.errors} errors so far)`);
          }
          
          // Restore employees to database
          if (backupData.data.employees && Array.isArray(backupData.data.employees)) {
            console.log(`👨‍💼 Restoring ${backupData.data.employees.length} employees...`);
            for (const employee of backupData.data.employees) {
              try {
                // Create new employee in database
                const empToCreate = { ...employee };
                delete empToCreate.id; // Remove ID to let database generate new one
                await employeeService.createEmployee(empToCreate);
                restoredItems.employees++;
              } catch (empError) {
                console.warn(`⚠️ Could not restore employee ${employee.firstName || employee.name || 'N/A'}:`, empError);
                restoredItems.errors++;
              }
            }
            importedCount++;
            console.log(`✅ Employees restored: ${restoredItems.employees}/${backupData.data.employees.length} (${restoredItems.errors} errors so far)`);
          }
          
          // Restore categories to database
          if (backupData.data.categories && Array.isArray(backupData.data.categories)) {
            console.log(`🏷️ Restoring ${backupData.data.categories.length} categories...`);
            for (const category of backupData.data.categories) {
              try {
                // Create new category in database
                const catToCreate = { ...category };
                delete catToCreate.id; // Remove ID to let database generate new one
                await categoryService.createCategory(catToCreate);
                restoredItems.categories++;
              } catch (catError) {
                console.warn(`⚠️ Could not restore category ${category.name || 'N/A'}:`, catError);
                restoredItems.errors++;
              }
            }
            importedCount++;
            console.log(`✅ Categories restored: ${restoredItems.categories}/${backupData.data.categories.length} (${restoredItems.errors} errors so far)`);
          }
          
          // Restore products to database
          if (backupData.data.products && Array.isArray(backupData.data.products)) {
            console.log(`📦 Restoring ${backupData.data.products.length} products...`);
            for (const product of backupData.data.products) {
              try {
                // Create new product in database
                const prodToCreate = { ...product };
                delete prodToCreate.id; // Remove ID to let database generate new one
                await productService.createProduct(prodToCreate);
                restoredItems.products++;
              } catch (prodError) {
                console.warn(`⚠️ Could not restore product ${product.name || 'N/A'}:`, prodError);
                restoredItems.errors++;
              }
            }
            importedCount++;
            console.log(`✅ Products restored: ${restoredItems.products}/${backupData.data.products.length} (${restoredItems.errors} errors so far)`);
          }
          
          // Restore backup history (keep in localStorage)
          if (backupData.data.backupHistory) {
            localStorage.setItem('backupHistory', JSON.stringify(backupData.data.backupHistory));
            importedCount++;
            console.log('✅ Backup history restored to localStorage');
          }
          
          // Final restoration summary
          const totalRestored = Object.values(restoredItems).filter(val => typeof val === 'number').reduce((sum, val) => sum + val, 0) - restoredItems.errors;
          const successRate = totalItems > 0 ? ((totalRestored / totalItems) * 100).toFixed(1) : '100.0';
          
          console.log('\n🎉 RESTORATION COMPLETED!');
          console.log('='.repeat(50));
          console.log(`📊 FINAL SUMMARY:`);
          console.log(`• Settings: ${restoredItems.settings} configurations`);
          console.log(`• Documents: ${restoredItems.documents} documents`);
          console.log(`• Clients: ${restoredItems.clients} clients`);
          console.log(`• Employees: ${restoredItems.employees} employees`);
          console.log(`• Categories: ${restoredItems.categories} categories`);
          console.log(`• Products: ${restoredItems.products} products`);
          console.log(`• Errors: ${restoredItems.errors} failed items`);
          console.log(`✅ SUCCESS RATE: ${successRate}% (${totalRestored}/${totalItems} items)`);
          console.log('='.repeat(50));
          
          // Set success message with detailed results
        setBackupMessage({ 
          type: 'success', 
            text: p('messages.backup_restore_success', {
              restored: totalRestored,
              total: totalItems,
              rate: successRate,
              errors: restoredItems.errors > 0 ? p('messages.backup_restore_errors_suffix', { count: restoredItems.errors }) : '',
            })
          });
          
        } catch (storageError) {
          throw new Error(p('messages.backup_restore_error', { message: storageError.message }));
        }

        // Auto-refresh the page after restore to reload all contexts
        setTimeout(() => {
          window.location.reload();
        }, 3000);

        // Auto-hide success message after 10 seconds
        setTimeout(() => {
          setBackupMessage({ type: '', text: '' });
        }, 10000);

      } catch (error) {
        console.error('Error importing backup:', error);
        setBackupMessage({ 
          type: 'error', 
          text: p('messages.backup_import_error', { message: error.message }) 
        });

        // Auto-hide error message after 8 seconds
        setTimeout(() => {
          setBackupMessage({ type: '', text: '' });
        }, 8000);
      }
    };

    reader.onerror = () => {
      setBackupMessage({ 
        type: 'error', 
        text: p('messages.backup_read_error') 
      });
    };

    reader.readAsText(file);
    
    // Reset file input
    event.target.value = '';
  };

  const deleteBackup = async (fileName) => {
    if (window.confirm(p('messages.confirm_delete_backup'))) {
      try {
        // Delete via service using fileName
        await backupService.deleteBackup(fileName);

        // Reload backup list
        const backups = await backupService.getBackups();
        const convertedBackups = backups.map(b => ({
          id: b.id,
          fileName: b.fileName,
          timestamp: b.date,
          dateFormatted: b.dateFormatted,
          size: b.size,
          sizeFormatted: b.sizeFormatted,
          type: b.type
        }));
        
        setBackupHistory(convertedBackups);
        
        setBackupMessage({ 
          type: 'success', 
          text: p('messages.backup_deleted') 
        });

        // Auto-hide message
        setTimeout(() => setBackupMessage({ type: '', text: '' }), 3000);
      } catch (error) {
        console.error('Error deleting backup:', error);
        setBackupMessage({ 
          type: 'error', 
          text: p('messages.backup_delete_error', { message: error.message }) 
        });
      }
    }
  };

  // Verify backup integrity
  const verifyBackupIntegrity = async (backupId) => {
    try {
      // Find backup by ID
      const backup = backupHistory.find(b => b.id === backupId);
      if (!backup) {
        throw new Error('Backup not found');
      }

      // Verify via service
      const result = await backupService.verifyBackup(backup.fileName);

      setBackupMessage({ 
        type: result.valid ? 'success' : 'error', 
        text: result.message
      });

      // Auto-hide message
      setTimeout(() => setBackupMessage({ type: '', text: '' }), 3000);
    } catch (error) {
      console.error('Error verifying backup:', error);
      setBackupMessage({ 
        type: 'error', 
        text: p('messages.backup_verify_error', { message: error.message }) 
      });
    }
  };

  // Export backup to external drive (manual JSON export for user control)
  const exportToExternalDrive = async () => {
    try {
      if (backupHistory.length === 0) {
        setBackupMessage({ 
          type: 'info', 
          text: p('messages.no_backup_for_export') 
        });
        return;
      }

      // Get the most recent backup
      const latestBackup = backupHistory[0];
      
      setBackupMessage({ 
        type: 'info', 
        text: p('messages.backup_export_hint') 
      });

      // In a real desktop app, this would open a folder picker dialog
      // For now, we'll show a message
      setTimeout(() => setBackupMessage({ type: '', text: '' }), 5000);
    } catch (error) {
      console.error('Error exporting backup:', error);
      setBackupMessage({ 
        type: 'error', 
        text: p('messages.backup_export_error', { message: error.message }) 
      });
    }
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return `0 ${t('common.file_sizes.bytes')}`;
    const k = 1024;
    const sizeKeys = ['bytes', 'kb', 'mb', 'gb'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${t(`common.file_sizes.${sizeKeys[i]}`)}`;
  };

  // Load backup history on component mount
  useEffect(() => {
    const savedHistory = localStorage.getItem('backupHistory');
    if (savedHistory) {
      setBackupHistory(JSON.parse(savedHistory));
    }
    
    const savedBackupSettings = localStorage.getItem('backupSettings');
    if (savedBackupSettings) {
      setBackupSettings(JSON.parse(savedBackupSettings));
    }
  }, []);

  // Save backup settings when changed
  useEffect(() => {
    localStorage.setItem('backupSettings', JSON.stringify(backupSettings));
  }, [backupSettings]);

  // Automatic backup scheduler
  useEffect(() => {
    let backupInterval;
    
    if (backupSettings.autoBackup) {
      const getIntervalMs = () => {
        switch (backupSettings.frequency) {
          case 'daily': return 24 * 60 * 60 * 1000; // 24 hours
          case 'weekly': return 7 * 24 * 60 * 60 * 1000; // 7 days
          case 'monthly': return 30 * 24 * 60 * 60 * 1000; // 30 days
          default: return 24 * 60 * 60 * 1000; // Default to daily
        }
      };
      
      const calculateNextBackupTime = () => {
        if (!backupSettings.lastBackup) {
          return new Date().getTime() + getIntervalMs();
        }
        const lastBackupTime = new Date(backupSettings.lastBackup).getTime();
        return lastBackupTime + getIntervalMs();
      };
      
      const shouldCreateAutoBackup = () => {
        if (!backupSettings.lastBackup) return true;
        
        const lastBackupTime = new Date(backupSettings.lastBackup).getTime();
        const now = new Date().getTime();
        const interval = getIntervalMs();
        
        return (now - lastBackupTime) >= interval;
      };
      
      // Update next backup time and status
      const nextBackup = calculateNextBackupTime();
      setBackupSettings(prev => ({ ...prev, nextScheduledBackup: new Date(nextBackup).toISOString() }));
      setAutoBackupStatus('active');
      
      console.log('🔄 Automatic backup enabled - Next check in 1 hour');
      console.log(`📅 Next scheduled backup: ${new Date(nextBackup).toLocaleString(getBrandLocale(i18n.language))}`);
      
      // NOTE: Pas de vérification immédiate - les sauvegardes automatiques 
      // se déclencheront seulement via l'intervalle programmé
      
      // Set up interval for future automatic backups
      backupInterval = setInterval(() => {
        if (shouldCreateAutoBackup()) {
          console.log('📅 Triggering scheduled automatic backup...');
          setAutoBackupStatus('pending');
          createBackup({ scheduled: true }).then(() => {
            console.log('✅ Scheduled automatic backup created successfully');
            setAutoBackupStatus('active');
            // Update next backup time after successful backup
            const newNextBackup = new Date().getTime() + getIntervalMs();
            setBackupSettings(prev => ({ ...prev, nextScheduledBackup: new Date(newNextBackup).toISOString() }));
          }).catch(err => {
            console.error('❌ Error during scheduled automatic backup:', err);
            setAutoBackupStatus('active');
          });
        }
      }, 60 * 60 * 1000); // Check every hour
      
    } else {
      setAutoBackupStatus('inactive');
      setBackupSettings(prev => ({ ...prev, nextScheduledBackup: null }));
    }
    
    return () => {
      if (backupInterval) {
        clearInterval(backupInterval);
        console.log('🛑 Automatic backup disabled');
      }
    };
  }, [backupSettings.autoBackup, backupSettings.frequency, backupSettings.lastBackup]);

  const tabs = [
    { id: 'company', label: p('tabs.company'), icon: Building },
    // { id: 'apparence', label: 'Apparence', icon: Palette }, // REMOVED - Not needed
    // { id: 'facturation', label: 'Facturation', icon: FileText }, // Moved to dedicated /billing/config page
    { id: 'profil', label: p('tabs.profile'), icon: User },
    { id: 'utilisateurs', label: p('tabs.users'), icon: Users },
    { id: 'audit', label: p('tabs.audit'), icon: ClipboardList }
  ];

  // Debug: Log settings on component mount
  useEffect(() => {
    console.log("Settings component mounted with settings:", settings);
    console.log("Company data:", settings.company);
    
    // If settings are loaded but company data is missing, try to fetch from setup_data
    if (settings && (!settings.company || Object.keys(settings.company).length === 0)) {
      console.log("Company data missing, attempting to load from setup_data");
      const setupDataStr = localStorage.getItem('setup_data');
      if (setupDataStr) {
        try {
          const setupData = JSON.parse(setupDataStr);
          if (setupData && setupData.company) {
            console.log("Found company data in setup_data:", setupData.company);
            // Update settings with company data
            Object.keys(setupData.company).forEach(key => {
              if (setupData.company[key]) {
                updateSettings('company', key, setupData.company[key]);
              }
            });
          }
        } catch (error) {
          console.error("Error parsing setup_data:", error);
        }
      }
    }
  }, []);
  
  // Load user data from secure storage for profile section (same as TopBar)
  useEffect(() => {
    const loadProfileData = async () => {
      try {
        const storedUser = secureGetItem('qawaem_user');
        console.log('📦 Settings loading user from secure storage:', storedUser);
        
        // Also try to load from settings service (global_settings adminUser + company)
        let settingsBlob = null;
        try {
          settingsBlob = await settingsService.get();
        } catch (e) {
          console.warn('Could not load settings for profile:', e);
        }
        const settingsAdmin = settingsBlob?.adminUser || null;
        const resolvedPhone = resolveProfilePhone({
          storedUser,
          settingsBlob,
          permissionsUser: permissions.currentUser,
        });
        
        if (storedUser) {
          console.log('✅ Settings setting profile user:', storedUser);
          const profile = {
            name: storedUser.username || p('defaults.user'),
            email: storedUser.email || settingsAdmin?.email || permissions.currentUser?.email || '',
            phone: resolvedPhone,
            jobTitle: storedUser.jobTitle || settingsAdmin?.jobTitle || '',
            department: storedUser.department || settingsAdmin?.department || '',
            createdAt: storedUser.createdAt || storedUser.joinedAt || new Date().toISOString(),
            expiresAt: storedUser.expiresAt || storedUser.licenseExpiry || null,
            role: storedUser.role || p('defaults.standard_account')
          };
          setProfileUser(profile);
          if (resolvedPhone && !storedUser.phone) {
            try {
              secureSetItem('qawaem_user', { ...storedUser, phone: resolvedPhone });
            } catch (_) {
              /* ignore */
            }
          }
        } else {
          console.warn('⚠️ No user data in Settings');
          setProfileUser({ 
            name: settingsAdmin?.username || p('defaults.user'),
            email: settingsAdmin?.email || '', 
            phone: resolvedPhone, 
            jobTitle: settingsAdmin?.jobTitle || '',
            department: settingsAdmin?.department || '',
            createdAt: new Date().toISOString(), 
            role: p('defaults.standard_account')
          });
        }
      } catch (error) {
        console.error('❌ Error loading user from secure storage:', error);
        setProfileUser({ name: p('defaults.user'), email: '', phone: '', createdAt: new Date().toISOString(), expiresAt: null, role: p('defaults.standard_account') });
      }
    };
    
    loadProfileData();
  }, [permissions]);

  // Update profile form data when user changes
  useEffect(() => {
    if (profileUser) {
      console.log('📝 Updating profile form data from profileUser:', profileUser);
      setProfileFormData(prevState => ({
        ...prevState,
        name: profileUser.name || '',
        email: profileUser.email || '',
        phone: profileUser.phone || '',
        jobTitle: profileUser.jobTitle || '',
        department: profileUser.department || ''
      }));
    }
  }, [profileUser]);

  useEffect(() => {
    if (activeTab !== 'profil') return undefined;

    const updates = window.electronAPI?.updates;
    if (!updates) {
      setAppUpdateStatus({ desktopOnly: true });
      return undefined;
    }

    const applyStatus = (payload) => {
      if (!payload || typeof payload !== 'object') return;

      const phase = payload.phase;
      if (phase === 'checking' || phase === 'dismissed') return;

      setAppUpdateStatus((prev) => {
        if (phase === 'idle' && prev?.phase && prev.phase !== 'idle') {
          return prev;
        }

        const nextKey = `${phase}|${payload.downloadProgress}|${payload.version}|${payload.isDownloading}|${payload.currentVersion || ''}`;
        const prevKey = `${prev?.phase}|${prev?.downloadProgress}|${prev?.version}|${prev?.isDownloading}|${prev?.currentVersion || ''}`;
        if (nextKey === prevKey) return prev;
        return { ...(prev || {}), ...payload };
      });
    };

    let unsub = () => {};
    updates.getStatus().then(applyStatus).catch(() => {});
    unsub = updates.onStatus(applyStatus) || (() => {});

    setAppUpdateChecking(true);
    updates
      .checkNow()
      .then((payload) => {
        if (payload && typeof payload === 'object') {
          setAppUpdateStatus((prev) => ({ ...(prev || {}), ...payload }));
        }
      })
      .catch(() =>
        setAppUpdateStatus((prev) => ({
          ...(prev || {}),
          phase: 'error',
          message: p('app_update.check_error'),
        })),
      )
      .finally(() => setAppUpdateChecking(false));

    return () => {
      if (typeof unsub === 'function') unsub();
    };
  }, [activeTab]);
  
  // Profile form handlers
  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setProfileFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleProfileLanguageChange = async (lang) => {
    if (!lang || lang === language) return;
    changeLanguage(lang);
    await updateSettings('invoicing', 'language', lang);
    localStorage.setItem('language', lang);
    if (lang === 'ar') {
      document.documentElement.dir = 'rtl';
      document.documentElement.lang = 'ar';
    } else {
      document.documentElement.dir = 'ltr';
      document.documentElement.lang = lang;
    }
    setTimeout(() => window.location.reload(), 100);
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();

    const trimmedUsername = profileFormData.name?.trim() || '';
    if (!trimmedUsername) {
      setProfileMessage({ type: 'error', text: p('messages.profile_username_required') });
      return;
    }

    console.log('💾 Saving profile data:', profileFormData);

    const syncLocalProfile = () => {
      try {
        const userJson = localStorage.getItem('qawaem_user');
        if (userJson) {
          const userData = JSON.parse(userJson);
          userData.username = trimmedUsername;
          userData.email = profileFormData.email;
          userData.jobTitle = profileFormData.jobTitle;
          userData.phone = profileFormData.phone;
          userData.department = profileFormData.department;
          localStorage.setItem('qawaem_user', JSON.stringify(userData));
        }

        const adminJson = localStorage.getItem('qawaem_admin_user');
        if (adminJson) {
          const adminData = JSON.parse(adminJson);
          adminData.username = trimmedUsername;
          adminData.email = profileFormData.email;
          adminData.jobTitle = profileFormData.jobTitle;
          adminData.phone = profileFormData.phone;
          adminData.department = profileFormData.department;
          localStorage.setItem('qawaem_admin_user', JSON.stringify(adminData));
        }

        const secureUser = secureGetItem('qawaem_user');
        if (secureUser) {
          secureUser.username = trimmedUsername;
          secureUser.email = profileFormData.email;
          secureUser.jobTitle = profileFormData.jobTitle;
          secureUser.phone = profileFormData.phone;
          secureUser.department = profileFormData.department;
          secureSetItem('qawaem_user', secureUser);
        }
      } catch (storageErr) {
        console.warn('Error updating localStorage user data:', storageErr);
      }
    };

    try {
      const profileResult = await updateAdminProfile({
        currentUsername: profileUser?.name || trimmedUsername,
        username: trimmedUsername,
        email: profileFormData.email,
        jobTitle: profileFormData.jobTitle,
        phone: profileFormData.phone,
        department: profileFormData.department,
      });

      if (!profileResult.success) {
        setProfileMessage({
          type: 'error',
          text: profileResult.error || p('messages.profile_update_error'),
        });
        return;
      }

      syncLocalProfile();

      try {
        const settingsSvc = (await import('../../../core/services/settingsService')).default;
        const current = await settingsSvc.get();
        if (current?.adminUser) {
          await settingsSvc.update({
            ...current,
            hasAdminUser: true,
            adminUser: {
              ...current.adminUser,
              username: trimmedUsername,
              email: profileFormData.email,
              jobTitle: profileFormData.jobTitle,
              phone: profileFormData.phone,
              department: profileFormData.department,
            },
          });
        }
      } catch (settingsErr) {
        console.warn('Settings cache sync after profile update:', settingsErr);
      }

      setProfileUser((prev) => ({
        ...prev,
        name: trimmedUsername,
        email: profileFormData.email || prev.email,
        phone: profileFormData.phone || prev.phone,
        jobTitle: profileFormData.jobTitle || prev.jobTitle,
        department: profileFormData.department || prev.department,
      }));

      setProfileMessage({ type: 'success', text: p('messages.profile_updated') });
      setIsEditingProfile(false);

      logAuditEvent(
        AuditAction.USER_UPDATE,
        'user_profile',
        p('audit_log.details.profile_updated', { username: trimmedUsername }),
        AuditLevel.SUCCESS,
        { action: 'profile_update' },
      );
    } catch (error) {
      console.error('Profile update error:', error);
      setProfileMessage({
        type: 'error',
        text: error?.message || p('messages.profile_update_error'),
      });
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    
    if (profileFormData.newPassword !== profileFormData.confirmPassword) {
      setSecurityMessage({
        type: 'error',
        text: p('messages.password_mismatch')
      });
      return;
    }

    const username =
      profileUser?.name?.trim() ||
      profileFormData.name?.trim() ||
      permissions?.currentUser?.username?.trim() ||
      '';

    if (!username) {
      setSecurityMessage({ type: 'error', text: p('messages.username_not_found') });
      return;
    }
    
    try {
      const result = await changePasswordWithCurrent({
        username,
        currentPassword: profileFormData.currentPassword,
        newPassword: profileFormData.newPassword,
      });

      if (!result.success) {
        setSecurityMessage({
          type: 'error',
          text: result.error || p('messages.password_update_failed'),
        });
        return;
      }

      try {
        const adminJson = localStorage.getItem('qawaem_admin_user');
        if (adminJson) {
          const adminData = JSON.parse(adminJson);
          adminData.password = profileFormData.newPassword;
          localStorage.setItem('qawaem_admin_user', JSON.stringify(adminData));
        }

        const settingsSvc = (await import('../../../core/services/settingsService')).default;
        const current = await settingsSvc.get();
        if (current?.adminUser) {
          await settingsSvc.update({
            ...current,
            hasAdminUser: true,
            adminUser: {
              ...current.adminUser,
              password: profileFormData.newPassword,
            },
          });
        }
      } catch (storageErr) {
        console.warn('Local password cache sync:', storageErr);
      }

      setSecurityMessage({ type: 'success', text: p('messages.password_updated') });
      setProfileFormData((prevState) => ({
        ...prevState,
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      }));
      setIsChangingPassword(false);
      setTimeout(() => setSecurityMessage({ type: '', text: '' }), 6000);

      logAuditEvent(
        AuditAction.USER_UPDATE,
        'user_security',
        p('audit_log.details.password_changed'),
        AuditLevel.SUCCESS,
        { action: 'password_change' },
      );
    } catch (error) {
      console.error('Error updating password:', error);
      setSecurityMessage({
        type: 'error',
        text: (error && error.message) || p('messages.password_update_error'),
      });
    }
  };

  const handleForgotPassword = async () => {
    const email =
      profileFormData.email?.trim() ||
      profileUser?.email?.trim() ||
      '';
    if (!email) {
      setSecurityMessage({
        type: 'error',
        text: p('messages.add_email_before_reset'),
      });
      setTimeout(() => setSecurityMessage({ type: '', text: '' }), 6000);
      return;
    }
    setSecurityMessage({ type: 'info', text: p('messages.sending_code') });
    try {
      const result = await requestPasswordReset(email);
      if (result.success) {
        setIsChangingPassword(true);
        setIsResettingWithCode(true);
        setProfileFormData((prev) => ({
          ...prev,
          currentPassword: '',
          newPassword: '',
          confirmPassword: '',
          resetCode: '',
        }));
        setSecurityMessage({
          type: 'success',
          text: result.message || p('messages.code_sent_to_email', { email }),
        });
      } else {
        setSecurityMessage({
          type: 'error',
          text:
            result.error ||
            p('messages.email_send_failed'),
        });
      }
    } catch (err) {
      setSecurityMessage({
        type: 'error',
        text: err?.message || p('messages.email_send_error'),
      });
    }
    setTimeout(() => setSecurityMessage({ type: '', text: '' }), 8000);
  };

  const handleCodePasswordReset = async (e) => {
    e.preventDefault();
    setSecurityMessage({ type: '', text: '' });

    const email =
      profileFormData.email?.trim() ||
      profileUser?.email?.trim() ||
      '';
    const code = String(profileFormData.resetCode || '').trim();
    const { newPassword, confirmPassword } = profileFormData;

    if (!email) {
      setSecurityMessage({ type: 'error', text: p('messages.add_profile_email') });
      return;
    }
    if (!/^\d{6}$/.test(code)) {
      setSecurityMessage({ type: 'error', text: p('messages.code_must_be_6_digits') });
      return;
    }
    if (!newPassword || newPassword.length < 6) {
      setSecurityMessage({ type: 'error', text: p('messages.password_min_6') });
      return;
    }
    if (newPassword !== confirmPassword) {
      setSecurityMessage({ type: 'error', text: p('messages.password_mismatch') });
      return;
    }

    try {
      const result = await resetPasswordWithCode({
        email,
        code,
        newPassword,
      });

      if (!result.success) {
        setSecurityMessage({
          type: 'error',
          text: result.error || p('messages.invalid_or_expired_code'),
        });
        return;
      }

      try {
        const adminJson = localStorage.getItem('qawaem_admin_user');
        if (adminJson) {
          const adminData = JSON.parse(adminJson);
          adminData.password = newPassword;
          localStorage.setItem('qawaem_admin_user', JSON.stringify(adminData));
        }

        const settingsSvc = (await import('../../../core/services/settingsService')).default;
        const current = await settingsSvc.get();
        if (current?.adminUser) {
          await settingsSvc.update({
            ...current,
            hasAdminUser: true,
            adminUser: { ...current.adminUser, password: newPassword },
          });
        }
      } catch (storageErr) {
        console.warn('Local password sync after reset:', storageErr);
      }

      setProfileFormData((prev) => ({
        ...prev,
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
        resetCode: '',
      }));
      setIsResettingWithCode(false);
      setIsChangingPassword(false);
      setSecurityMessage({ type: 'success', text: p('messages.password_reset_success') });
      setTimeout(() => setSecurityMessage({ type: '', text: '' }), 6000);

      logAuditEvent(
        AuditAction.USER_UPDATE,
        'user_security',
        p('audit_log.details.password_reset_code'),
        AuditLevel.SUCCESS,
        { action: 'password_reset_code' },
      );
    } catch (error) {
      console.error('Code password reset error:', error);
      setSecurityMessage({
        type: 'error',
        text: error?.message || p('messages.password_reset_error'),
      });
    }
  };

  const handleLogout = () => {
    try { 
      logout(); 
    } catch (error) {
      console.error('Error during logout:', error);
    }
    navigate('/login', { replace: true });
  };

  return (
    <>
    <div className="settings-container mx-auto max-w-full min-w-0 space-y-6">
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h1 style={{ fontSize: '1.875rem', fontWeight: '700', color: settingsInkPrimary, margin: 0, display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <SettingsIcon size={32} className={isDashboardLightMode ? 'text-blue-600' : 'text-blue-400'} />
            {t('settings.title')}
          </h1>
          <p style={{ color: settingsInkMuted, marginTop: '0.5rem', margin: 0 }}>
            {t('settings.subtitle')}
          </p>
        </div>
      </div>

      {/* Sticky Tabs Navigation with Save Button — horizontal scroll on narrow viewports (no flex-shrink overlap) */}
      <div 
        className="sticky top-0 z-50 min-w-0 rounded-xl p-3 sm:p-5 border shadow-lg"
        style={{
          background: isDashboardLightMode ? '#ffffff' : 'rgba(15, 23, 42, 0.92)',
          borderColor: isDashboardLightMode ? 'rgba(15, 23, 42, 0.12)' : 'rgba(255, 255, 255, 0.2)',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
        }}
      >
        <div className="flex min-w-0 flex-col gap-3 md:flex-row md:items-stretch md:gap-3">
          <div
            className="grid w-full grid-cols-4 gap-1.5 min-h-[3rem] min-w-0 pb-1 sm:gap-2 md:flex md:min-h-0 md:flex-1 md:flex-nowrap md:gap-2 md:overflow-x-auto"
            style={{ WebkitOverflowScrolling: 'touch', scrollbarWidth: 'thin', alignItems: 'stretch' }}
          >
          {tabs.map((tab) => {
            const IconComponent = tab.icon;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                aria-label={tab.label}
                title={tab.label}
                onClick={() => setActiveTab(tab.id)}
                className="w-full min-w-0 justify-center gap-0 px-1 py-3 sm:px-2 md:w-auto md:min-w-fit md:flex-shrink-0 md:gap-2 md:px-4 md:py-3"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  whiteSpace: 'nowrap',
                  borderRadius: '1rem',
                  fontWeight: '500',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s',
                  background: isActive ? 'linear-gradient(to right, rgb(59, 130, 246), rgb(29, 78, 216))' : 'transparent',
                  color: isActive ? 'white' : (isDashboardLightMode ? '#334155' : 'rgba(255,255,255,0.8)'),
                  boxShadow: isActive ? '0 10px 15px -3px rgba(59, 130, 246, 0.3), 0 4px 6px -4px rgba(59, 130, 246, 0.3)' : 'none'
                }}
                onMouseOver={(e) => {
                  if (!isActive) {
                    e.currentTarget.style.background = isDashboardLightMode ? '#f1f5f9' : 'rgba(255,255,255,0.1)';
                    e.currentTarget.style.color = isDashboardLightMode ? '#0f172a' : 'white';
                  }
                }}
                onMouseOut={(e) => {
                  if (!isActive) {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = isDashboardLightMode ? '#334155' : 'rgba(255,255,255,0.8)';
                  }
                }}
              >
                <IconComponent size={20} className={`shrink-0 ${isActive ? 'text-white' : (isDashboardLightMode ? 'text-blue-600' : 'text-blue-400')}`} />
                <span className="hidden md:inline">{tab.label}</span>
              </button>
            );
          })}
          </div>
          
          {/* Save — same soft-tint pattern as list Import/Export; theme.css light remaps to dark ink */}
          <button
            type="button"
            onClick={handleSave}
            className="w-full shrink-0 px-5 py-2.5 rounded-xl font-medium md:w-auto md:self-center flex items-center justify-center gap-2 transition-all duration-300 border bg-green-500/20 hover:bg-green-500/30 text-green-200 border-green-500/30 hover:scale-[1.02] shadow-lg min-w-fit"
          >
            <Save className="h-5 w-5 shrink-0" aria-hidden />
            <span>{p('save_button')}</span>
          </button>
        </div>
      </div>
        
        {/* Content */}
          {/* Company Settings */}
          {activeTab === 'company' && (
            <div className="min-w-0 max-w-full" style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              <div style={companySettingsCard}>
                <div style={companySettingsSectionTitleRow}>
                  <Building className={`h-8 w-8 shrink-0 ${isDashboardLightMode ? 'text-blue-600' : 'text-blue-400'}`} />
                  <div>
                    <h1 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 700, color: settingsInkPrimary, letterSpacing: '-0.02em', lineHeight: 1.2 }}>
                      {p('company.entity_info_title')}
                    </h1>
                    <p style={{ margin: '0.4rem 0 0', fontSize: '0.875rem', fontWeight: 500, color: settingsInkMuted }}>
                      {p('company.entity_info_subtitle')}
                    </p>
                  </div>
                </div>
              </div>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              
              {/* 📋 Section 1 : Identité & Branding */}
              <div style={companySettingsCard}>
                <div style={companySettingsSectionTitleRow}>
                  <Building size={20} className={isDashboardLightMode ? 'text-blue-600 shrink-0' : 'text-blue-400 shrink-0'} />
                  <h3 style={{
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: settingsInkPrimary,
                    margin: 0
                  }}>{p('company.identity_branding')}</h3>
                </div>
                <div style={companySettingsCardBody}>
                <div className="grid min-w-0 grid-cols-1 gap-4 sm:gap-6 md:grid-cols-2 xl:grid-cols-4">
                
                {/* 1. Raison sociale (Latin & Arabe) */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>
                    {p('company.company_name')}
                  </label>
                  <input
                    type="text"
                    value={settings.company.name}
                    onChange={(e) => updateSettings('company', 'name', e.target.value)}
                    placeholder={p("company.name_placeholder")}
                    style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                </div>

                {/* 2. Logo */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>
                    {p('company.logo')}
                  </label>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '0.75rem', background: 'rgba(255,255,255,0.05)', borderRadius: '0.75rem', border: '1px solid rgba(255,255,255,0.1)' }}>
                      <img
                        src={getEffectiveCompanyLogo(settings.company.logo)}
                        alt={p('company.logo')}
                        style={{ maxHeight: '60px', maxWidth: '120px', objectFit: 'contain' }}
                      />
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <p style={{ fontSize: '0.8125rem', color: settingsInkPrimary, margin: 0 }}>
                          {settings.company.logo
                            ? p('company.custom_logo_active', { defaultValue: 'شعار مخصص — يُستخدم في الفواتير والتصدير' })
                            : p('company.default_logo_active', { defaultValue: 'الشعار الافتراضي لـ Qawaem ERP — يُستخدم تلقائياً في الفواتير والتصدير' })}
                        </p>
                      </div>
                      {settings.company.logo ? (
                        <button
                          type="button"
                          onClick={() => updateSettings('company', 'logo', null)}
                          style={{
                            padding: '0.5rem 1rem',
                            background: 'rgba(239, 68, 68, 0.2)',
                            border: '1px solid rgba(239, 68, 68, 0.3)',
                            borderRadius: '0.5rem',
                            color: 'rgb(248, 113, 113)',
                            fontSize: '0.875rem',
                            cursor: 'pointer',
                            transition: 'all 0.3s',
                          }}
                        >
                          {p('common.delete')}
                        </button>
                      ) : (
                        <button
                          type="button"
                          onClick={async () => {
                            try {
                              const dataUrl = await loadDefaultCompanyLogoDataUrl(window.location.origin);
                              if (dataUrl) updateSettings('company', 'logo', dataUrl);
                            } catch {
                              alert(p('messages_extra.logo_load_error', { defaultValue: 'تعذّر تحميل الشعار' }));
                            }
                          }}
                          style={{
                            padding: '0.5rem 1rem',
                            background: 'rgba(110, 155, 110, 0.18)',
                            border: '1px solid rgba(110, 155, 110, 0.35)',
                            borderRadius: '0.5rem',
                            color: settingsInkPrimary,
                            fontSize: '0.875rem',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {p('company.save_default_logo', { defaultValue: 'حفظ الشعار الافتراضي' })}
                        </button>
                      )}
                    </div>
                    <label style={{
                      display: 'inline-block',
                      padding: '0.625rem 1rem',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      cursor: 'pointer',
                      textAlign: 'center',
                      transition: 'all 0.3s'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.background = 'rgba(255,255,255,0.15)';
                      e.currentTarget.style.borderColor = 'rgba(59, 130, 246, 0.5)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                      e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)';
                    }}
                    >
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            const reader = new FileReader();
                            reader.onloadend = () => {
                              updateSettings('company', 'logo', reader.result);
                            };
                            reader.readAsDataURL(file);
                          }
                        }}
                        style={{ display: 'none' }}
                      />
                      {settings.company.logo ? p('company.change_logo') : p('company.upload_logo')}
                    </label>
                    <p style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)', marginTop: '0.25rem' }}>
                      {p('company.logo_format_hint')}
                    </p>
                  </div>
                </div>
                
                {/* 3. Cachet */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>{p('company.stamp')}</label>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                    {settings.company.cachet && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '0.75rem', background: 'rgba(255,255,255,0.05)', borderRadius: '0.75rem', border: '1px solid rgba(255,255,255,0.1)' }}>
                        <img 
                          src={settings.company.cachet} 
                          alt={p("company.stamp")} 
                          style={{ maxHeight: '60px', maxWidth: '120px', objectFit: 'contain' }}
                        />
                        <button 
                          type="button" 
                          onClick={() => updateSettings('company', 'cachet', null)}
                          style={{
                            padding: '0.5rem 1rem',
                            background: 'rgba(239, 68, 68, 0.2)',
                            border: '1px solid rgba(239, 68, 68, 0.3)',
                            borderRadius: '0.5rem',
                            color: 'rgb(248, 113, 113)',
                            fontSize: '0.875rem',
                            cursor: 'pointer',
                            transition: 'all 0.3s'
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.background = 'rgba(239, 68, 68, 0.3)';
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.background = 'rgba(239, 68, 68, 0.2)';
                          }}
                        >
                          {p('common.delete')}
                        </button>
                      </div>
                    )}
                    <label style={{
                      display: 'inline-block',
                      padding: '0.625rem 1rem',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      cursor: 'pointer',
                      textAlign: 'center',
                      transition: 'all 0.3s'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.background = 'rgba(255,255,255,0.15)';
                      e.currentTarget.style.borderColor = 'rgba(59, 130, 246, 0.5)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                      e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)';
                    }}
                    >
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            const reader = new FileReader();
                            reader.onloadend = () => {
                              updateSettings('company', 'cachet', reader.result);
                            };
                            reader.readAsDataURL(file);
                          }
                        }}
                        style={{ display: 'none' }}
                      />
                      {settings.company.cachet ? p('company.change_stamp') : p('company.upload_stamp')}
                    </label>
                    <p style={{
                      fontSize: '0.75rem',
                      color: 'rgba(255, 255, 255, 0.5)',
                      marginTop: '0.5rem',
                      marginBottom: '0'
                    }}>
                      {p('company.stamp_format_hint')}
                    </p>
                  </div>
                </div>
                
                {/* 4. Signature */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>{p('company.signature')}</label>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                    {settings.company.signature && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '0.75rem', background: 'rgba(255,255,255,0.05)', borderRadius: '0.75rem', border: '1px solid rgba(255,255,255,0.1)' }}>
                        <img 
                          src={settings.company.signature} 
                          alt={p('company.signature')} 
                          style={{ maxHeight: '60px', maxWidth: '120px', objectFit: 'contain' }}
                        />
                        <button 
                          type="button" 
                          onClick={() => updateSettings('company', 'signature', null)}
                          style={{
                            padding: '0.5rem 1rem',
                            background: 'rgba(239, 68, 68, 0.2)',
                            border: '1px solid rgba(239, 68, 68, 0.3)',
                            borderRadius: '0.5rem',
                            color: 'rgb(248, 113, 113)',
                            fontSize: '0.875rem',
                            cursor: 'pointer',
                            transition: 'all 0.3s'
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.background = 'rgba(239, 68, 68, 0.3)';
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.background = 'rgba(239, 68, 68, 0.2)';
                          }}
                        >
                          {p('common.delete')}
                        </button>
                      </div>
                    )}
                    <label style={{
                      display: 'inline-block',
                      padding: '0.625rem 1rem',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      cursor: 'pointer',
                      textAlign: 'center',
                      transition: 'all 0.3s'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.background = 'rgba(255,255,255,0.15)';
                      e.currentTarget.style.borderColor = 'rgba(59, 130, 246, 0.5)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                      e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)';
                    }}
                    >
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            const reader = new FileReader();
                            reader.onloadend = () => {
                              updateSettings('company', 'signature', reader.result);
                            };
                            reader.readAsDataURL(file);
                          }
                        }}
                        style={{ display: 'none' }}
                      />
                      {settings.company.signature ? p('company.change_signature') : p('company.upload_signature')}
                    </label>
                    <p style={{
                      fontSize: '0.75rem',
                      color: 'rgba(255, 255, 255, 0.5)',
                      marginTop: '0.5rem',
                      marginBottom: '0'
                    }}>
                      {p('company.signature_format_hint')}
                    </p>
                  </div>
                </div>

                </div>
                </div>
                </div>

              {/* 📜 Section 2 : Informations Légales & Fiscales */}
              <div style={companySettingsCard}>
                <div style={companySettingsSectionTitleRow}>
                  <FileText size={20} className={isDashboardLightMode ? 'text-blue-600 shrink-0' : 'text-blue-400 shrink-0'} />
                  <h3 style={{
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: settingsInkPrimary,
                    margin: 0
                  }}>{p('company.legal_fiscal')}</h3>
                </div>
                <div style={companySettingsCardBody}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 280px), 1fr))', gap: '1.5rem', minWidth: 0 }}>
                
                {/* Legal form — Saudi */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', gridColumn: '1 / -1', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>
                    {p('company.legal_form')}
                  </label>
                  <CustomSelect
                    value={settings.company.legalForm || ''}
                    onChange={(value) => updateSettings('company', 'legalForm', value)}
                    options={SAUDI_LEGAL_FORMS}
                    placeholder={p('company.select_legal_form')}
                    searchable={true}
                    creatable={false}
                    className="custom-select-dark"
                  />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', gridColumn: '1 / -1', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>
                    {p('company.main_activity')}
                  </label>
                  <input
                    type="text"
                    value={settings.company.activity || ''}
                    onChange={(e) => updateSettings('company', 'activity', e.target.value)}
                    placeholder={p('company.activity_placeholder')}
                    style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', gridColumn: '1 / -1', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>
                    {p('company.services')}
                  </label>
                  <input
                    type="text"
                    value={settings.company.services || ''}
                    onChange={(e) => updateSettings('company', 'services', e.target.value)}
                    placeholder={p('company.services_placeholder')}
                    style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>
                    {p('company.commercial_registration')}
                  </label>
                  <input
                    type="text"
                    value={resolveCompanyField(settings.company, 'commercialRegistration', ['rc'])}
                    onChange={(e) => updateSettings('company', 'commercialRegistration', e.target.value)}
                    placeholder={p('company.cr_placeholder')}
                    style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>
                    {p('company.unified_national_number')}
                  </label>
                  <input
                    type="text"
                    value={resolveCompanyField(settings.company, 'unifiedNationalNumber', ['nis', 'articleNumber'])}
                    onChange={(e) => updateSettings('company', 'unifiedNationalNumber', e.target.value)}
                    placeholder="700123456789012"
                    style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>
                    {p('company.vat_number')}
                  </label>
                  <input
                    type="text"
                    maxLength={15}
                    value={formatTRN(resolveCompanyField(settings.company, 'vatNumber', ['nif']))}
                    onChange={(e) => updateSettings('company', 'vatNumber', e.target.value.replace(/\D/g, '').slice(0, 15))}
                    onBlur={(e) => handleVatBlur(e.target.value)}
                    placeholder="3XXXXXXXXXXXXXX"
                    style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                  {vatError ? <span style={{ fontSize: '0.75rem', color: 'rgb(248, 113, 113)' }}>{vatError}</span> : null}
                  <span style={{ fontSize: '0.75rem', color: settingsInkMuted }}>{p('company.vat_hint')}</span>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>
                    {p('company.gosi_number')}
                  </label>
                  <input
                    type="text"
                    value={settings.company.gosiEstablishmentNumber || ''}
                    onChange={(e) => updateSettings('company', 'gosiEstablishmentNumber', e.target.value)}
                    placeholder={p('company.gosi_placeholder')}
                    style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>
                    {p('company.chamber_number')}
                  </label>
                  <input
                    type="text"
                    value={settings.company.chamberOfCommerceNumber || ''}
                    onChange={(e) => updateSettings('company', 'chamberOfCommerceNumber', e.target.value)}
                    placeholder={p('company.chamber_placeholder')}
                    style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>
                    {p('company.municipality_license')}
                  </label>
                  <input
                    type="text"
                    value={settings.company.municipalityLicenseNumber || ''}
                    onChange={(e) => updateSettings('company', 'municipalityLicenseNumber', e.target.value)}
                    placeholder={p('company.municipality_placeholder')}
                    style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>
                    {p('company.zakat_number')}
                  </label>
                  <input
                    type="text"
                    value={settings.company.zakatNumber || ''}
                    onChange={(e) => updateSettings('company', 'zakatNumber', e.target.value)}
                    placeholder={p('company.zakat_placeholder')}
                    style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>
                    {p('company.establishment_date')}
                  </label>
                  <CustomDatePicker
                    value={settings.company.establishmentDate || ''}
                    onChange={(value) => updateSettings('company', 'establishmentDate', value)}
                  />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>
                    {p('company.vat_registration_date')}
                  </label>
                  <CustomDatePicker
                    value={settings.company.vatRegistrationDate || ''}
                    onChange={(value) => updateSettings('company', 'vatRegistrationDate', value)}
                  />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>
                    {p('company.license_expiry_date')}
                  </label>
                  <CustomDatePicker
                    value={settings.company.licenseExpiryDate || ''}
                    onChange={(value) => updateSettings('company', 'licenseExpiryDate', value)}
                  />
                </div>

                    </div>
                  </div>
              </div>

              {/* VAT, currency & fiscal year — Saudi */}
              <div style={companySettingsCard}>
                <div style={companySettingsSectionTitleRow}>
                  <Percent size={20} className={isDashboardLightMode ? 'text-blue-600 shrink-0' : 'text-blue-400 shrink-0'} />
                  <h3 style={{ fontSize: '1rem', fontWeight: '600', color: settingsInkPrimary, margin: 0 }}>
                    {p('company.vat_currency_title')}
                  </h3>
                </div>
                <div style={companySettingsCardBody}>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 280px), 1fr))', gap: '1.5rem', minWidth: 0 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                      <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary }}>{p('company.default_vat_rate')}</label>
                      <input
                        type="number"
                        min="0"
                        max="100"
                        step="0.01"
                        value={settings.taxes?.tva ?? SAUDI_VAT_RATE}
                        onChange={(e) => updateSettings('taxes', 'tva', parseFloat(e.target.value) || SAUDI_VAT_RATE)}
                        style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }}
                        onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }}
                      />
                      <span style={{ fontSize: '0.75rem', color: settingsInkMuted }}>{p('company.vat_standard_hint', { rate: SAUDI_VAT_RATE })}</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                      <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary }}>{p('company.default_currency')}</label>
                      <input
                        type="text"
                        value={`${getBrandDefaultCurrency()} (${SAUDI_CURRENCY_SYMBOL})`}
                        readOnly
                        disabled
                        style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }}
                      />
                      <span style={{ fontSize: '0.75rem', color: settingsInkMuted }}>{p('company.currency_locked_sar', { symbol: SAUDI_CURRENCY_SYMBOL })}</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                      <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary }}>{p('company.fiscal_year_type')}</label>
                      <CustomSelect
                        value={settings.company.fiscalYearType || 'gregorian'}
                        onChange={(value) => updateSettings('company', 'fiscalYearType', value)}
                        options={SAUDI_FISCAL_YEAR_OPTIONS.map((o) => ({ value: o.value, label: p(`company.${o.labelKey}`) }))}
                      />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', gridColumn: '1 / -1', minWidth: 0 }}>
                      <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary }}>{p('company.vat_categories')}</label>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                        {SAUDI_VAT_CATEGORIES.map((cat) => (
                          <span key={cat.value} style={{ fontSize: '0.8125rem', padding: '0.35rem 0.75rem', borderRadius: '999px', background: 'rgba(59,130,246,0.15)', color: settingsInkPrimary, border: '1px solid rgba(59,130,246,0.25)' }}>
                            {p(`company.${cat.labelKey}`)}{cat.rate != null ? `: ${cat.rate}%` : ''}
                          </span>
                        ))}
                      </div>
                      <span style={{ fontSize: '0.75rem', color: settingsInkMuted }}>
                        {p('company.vat_threshold_hint', { amount: formatBrandMoney(SAUDI_VAT_REGISTRATION_THRESHOLD) })}
                      </span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                      <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: settingsInkPrimary, fontSize: '0.875rem' }}>
                        <input
                          type="checkbox"
                          checked={settings.taxes?.taxIncluded || false}
                          onChange={(e) => updateSettings('taxes', 'taxIncluded', e.target.checked)}
                        />
                        {p('company.prices_include_vat')}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

                            {/* 📍 Section 3 : Coordonnées & Contact */}
              <div style={companySettingsCard}>
                <div style={companySettingsSectionTitleRow}>
                  <MapPin size={20} className={isDashboardLightMode ? 'text-blue-600 shrink-0' : 'text-blue-400 shrink-0'} />
                  <h3 style={{
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: settingsInkPrimary,
                    margin: 0
                  }}>{p('company.contact')}</h3>
                </div>
                <div style={companySettingsCardBody}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 280px), 1fr))', gap: '1.5rem', minWidth: 0 }}>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', gridColumn: '1 / -1', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>
                    {p('company.full_address')}
                  </label>
                  <input
                    type="text"
                    value={settings.company.address || ''}
                    onChange={(e) => updateSettings('company', 'address', e.target.value)}
                    placeholder={p('company.address_placeholder')}
                    style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>{p('company.street')}</label>
                  <input type="text" value={settings.company.street || ''} onChange={(e) => updateSettings('company', 'street', e.target.value)} placeholder={p('company.street_placeholder')} style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }} onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }} />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>{p('company.building_number')}</label>
                  <input type="text" value={settings.company.buildingNumber || ''} onChange={(e) => updateSettings('company', 'buildingNumber', e.target.value)} placeholder="1234" style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }} onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }} />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>{p('company.district')}</label>
                  <input type="text" value={settings.company.district || ''} onChange={(e) => updateSettings('company', 'district', e.target.value)} placeholder={p('company.district_placeholder')} style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }} onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }} />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>{p('company.region')}</label>
                  <CustomSelect
                    value={settings.company.region || ''}
                    onChange={(value) => updateSettings('company', 'region', value)}
                    options={saudiRegionOptions}
                    placeholder={p('geo.select_region')}
                  />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>{p('company.city')}</label>
                  <CustomSelect
                    value={settings.company.city || ''}
                    onChange={(value) => updateSettings('company', 'city', value)}
                    options={saudiCityOptions}
                    placeholder={p('geo.select_city')}
                    searchable={true}
                  />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>{p('company.postal_code')}</label>
                  <input
                    type="text"
                    maxLength={5}
                    value={settings.company.postalCode || ''}
                    onChange={(e) => updateSettings('company', 'postalCode', e.target.value.replace(/\D/g, '').slice(0, 5))}
                    onBlur={(e) => handlePostalBlur(e.target.value)}
                    placeholder="12345"
                    style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                  {postalError ? <span style={{ fontSize: '0.75rem', color: 'rgb(248, 113, 113)' }}>{postalError}</span> : null}
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>{p('company.phone')}</label>
                  <input
                    type="tel"
                    value={settings.company.phone || ''}
                    onChange={(e) => updateSettings('company', 'phone', e.target.value)}
                    onBlur={(e) => handleCompanyPhoneBlur('phone', e.target.value)}
                    placeholder={getBrandPhonePlaceholder()}
                    style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                  {phoneError ? <span style={{ fontSize: '0.75rem', color: 'rgb(248, 113, 113)' }}>{phoneError}</span> : null}
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>{p('company.mobile')}</label>
                  <input
                    type="tel"
                    value={settings.company.mobile || ''}
                    onChange={(e) => updateSettings('company', 'mobile', e.target.value)}
                    onBlur={(e) => handleCompanyPhoneBlur('mobile', e.target.value)}
                    placeholder={getBrandPhonePlaceholder()}
                    style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                  {mobileError ? <span style={{ fontSize: '0.75rem', color: 'rgb(248, 113, 113)' }}>{mobileError}</span> : null}
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>{p('company.email')}</label>
                  <input type="email" value={settings.company.email || ''} onChange={(e) => updateSettings('company', 'email', e.target.value)} placeholder={p('company.email_placeholder')} style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }} onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }} />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: 0 }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkPrimary, marginBottom: '0.25rem' }}>{p('company.website')}</label>
                  <input type="url" value={settings.company.website || ''} onChange={(e) => updateSettings('company', 'website', e.target.value)} placeholder={p('company.website_placeholder')} style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }} onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }} />
                </div>

                </div>
              </div>
              </div>

                            {/* Banking — Saudi IBAN / WPS */}
              <div style={companySettingsCard}>
                <div style={companySettingsSectionTitleRow}>
                  <DollarSign size={20} className={isDashboardLightMode ? 'text-blue-600 shrink-0' : 'text-blue-400 shrink-0'} />
                  <h3 style={{ fontSize: '1rem', fontWeight: '600', color: settingsInkPrimary, margin: 0 }}>{p('company.banking')}</h3>
                </div>
                <div style={companySettingsCardBody}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                <p style={{ fontSize: '0.8125rem', color: settingsInkMuted, margin: 0 }}>{p('company.banking_hint')}</p>

                {bankAccounts.map((ba, index) => (
                  <div key={`bank-acc-${index}`} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.5rem' }}>
                      <label style={{ fontSize: '0.875rem', fontWeight: '600', color: settingsInkPrimary, marginBottom: '0.25rem' }}>
                        {p('company.bank_account_n', { n: index + 1 })}
                      </label>
                      {bankAccounts.length > 1 && (
                        <button type="button" onClick={() => removeBankAccount(index)} style={{ fontSize: '0.8125rem', fontWeight: '600', color: 'rgb(254, 202, 202)', background: 'rgba(239, 68, 68, 0.15)', border: '1px solid rgba(239, 68, 68, 0.35)', borderRadius: '0.5rem', padding: '0.35rem 0.65rem', cursor: 'pointer' }}>
                          {p('common.remove')}
                        </button>
                      )}
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 220px), 1fr))', gap: '0.75rem' }}>
                      <input
                        type="text"
                        value={formatSaudiIbanDisplay(ba.iban || '')}
                        onChange={(e) => handleBankAccountChange(index, 'iban', e.target.value)}
                        placeholder={SAUDI_IBAN_PLACEHOLDER}
                        style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }}
                        onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }}
                      />
                      <CustomSelect
                        value={ba.bank || ''}
                        onChange={(value) => handleBankAccountChange(index, 'bank', value)}
                        options={saudiBanks.map((bank) => ({ value: bank.code, label: bank.name }))}
                        placeholder={p('geo.select_bank')}
                      />
                      <input type="text" value={ba.branch || ''} onChange={(e) => handleBankAccountChange(index, 'branch', e.target.value)} placeholder={p('company.bank_branch')} style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }} onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }} />
                      <input type="text" value={ba.swift || ''} onChange={(e) => handleBankAccountChange(index, 'swift', e.target.value)} placeholder={p('company.swift_code')} style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '0.75rem',
                      padding: '0.625rem 1rem',
                      color: 'white',
                      fontSize: '0.875rem',
                      outline: 'none',
                      transition: 'all 0.3s'
                    }} onFocus={(e) => {
                      e.target.style.borderColor = 'rgb(59, 130, 246)';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                      e.target.style.boxShadow = 'none';
                    }} />
                      <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: settingsInkPrimary, fontSize: '0.875rem' }}>
                        <input type="checkbox" checked={Boolean(ba.wpsEnabled)} onChange={(e) => handleBankAccountChange(index, 'wpsEnabled', e.target.checked)} />
                        {p('company.wps_enabled')}
                      </label>
                    </div>
                  </div>
                ))}

                <div>
                  <button type="button" onMouseDown={(e) => { e.preventDefault(); addBankAccount(); }} style={{ fontSize: '0.875rem', fontWeight: '600', color: 'white', background: 'linear-gradient(135deg, rgb(59, 130, 246) 0%, rgb(37, 99, 235) 100%)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '0.75rem', padding: '0.5rem 1rem', cursor: 'pointer', boxShadow: '0 4px 12px rgba(59, 130, 246, 0.25)' }}>
                    {p('company.add_bank_account')}
                  </button>
                </div>
                </div>
                </div>
              </div>

              </div>
            </div>
          )}

                    {/* Facturation Settings - Moved to dedicated /billing/config page */}
          {/* Tab removed from navigation - content kept for reference but won't render */}
          {activeTab === 'facturation' && (
            <div className="space-y-6">
              <h2 className="text-xl font-bold text-white pb-3 border-b border-white/20 mb-6">{p('billing.title')}</h2>
              
              {/* Facturation Sub-Tabs Navigation */}
              <div className="bg-white/5 backdrop-blur-lg rounded-2xl p-1.5 border border-white/10">
                <div className="grid grid-cols-5 gap-1.5">
                  <button
                    className={`py-3.5 px-4 rounded-xl font-medium text-sm transition-all duration-200 ${
                      facturationTab === 'tableaux' 
                        ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg' 
                        : 'text-white/70 hover:text-white hover:bg-white/10'
                    }`}
                    onClick={() => setFacturationTab('tableaux')}
                  >
                    {p('billing.sub_tabs.tables')}
                  </button>
                  <button
                    className={`py-3.5 px-4 rounded-xl font-medium text-sm transition-all duration-200 ${
                      facturationTab === 'modeles' 
                        ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg' 
                        : 'text-white/70 hover:text-white hover:bg-white/10'
                    }`}
                    onClick={() => setFacturationTab('modeles')}
                  >
                    {p('billing.sub_tabs.templates')}
                  </button>
                  <button
                    className={`py-3.5 px-4 rounded-xl font-medium text-sm transition-all duration-200 ${
                      facturationTab === 'apparence' 
                        ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg' 
                        : 'text-white/70 hover:text-white hover:bg-white/10'
                    }`}
                    onClick={() => setFacturationTab('apparence')}
                  >
                    {p('billing.sub_tabs.appearance')}
                  </button>
                  <button
                    className={`py-3.5 px-4 rounded-xl font-medium text-sm transition-all duration-200 ${
                      facturationTab === 'taxes' 
                        ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg' 
                        : 'text-white/70 hover:text-white hover:bg-white/10'
                    }`}
                    onClick={() => setFacturationTab('taxes')}
                  >
                    {p('billing.sub_tabs.taxes')}
                  </button>
                  <button
                    className={`py-3.5 px-4 rounded-xl font-medium text-sm transition-all duration-200 ${
                      facturationTab === 'clients' 
                        ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg' 
                        : 'text-white/70 hover:text-white hover:bg-white/10'
                    }`}
                    onClick={() => setFacturationTab('clients')}
                  >
                    {p('billing.sub_tabs.clients')}
                  </button>
                  <button
                    className={`py-3.5 px-4 rounded-xl font-medium text-sm transition-all duration-200 ${
                      facturationTab === 'notifications' 
                        ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg' 
                        : 'text-white/70 hover:text-white hover:bg-white/10'
                    }`}
                    onClick={() => setFacturationTab('notifications')}
                  >
                    {p('billing.sub_tabs.notifications')}
                  </button>
                </div>
              </div>
              
              {/* Tableaux Tab */}
              {facturationTab === 'tableaux' && (
              <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-6 border border-white/20">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <h3 className="text-xl font-bold text-white force-white" style={{ color: '#ffffff' }}>{p('billing.tables.title')}</h3>
                    <p className="text-white/70 mt-1 force-white" style={{ color: 'rgba(255, 255, 255, 0.8)' }}>{p('billing.tables.subtitle')}</p>
                  </div>
                  <div className="p-3 rounded-2xl bg-gradient-to-r from-blue-500 to-blue-600">
                    <FileText className="h-6 w-6 text-white" />
                  </div>
                </div>
                
                <div className="form-group mb-6">
                  <label className="text-white mb-2 block force-white">{p('billing.tables.reference_column')}</label>
                  <div className="flex items-center gap-2">
                    <div className={`flex items-center justify-center w-16 h-8 rounded-full p-1 cursor-pointer ${settings.invoicing?.showReferenceColumn !== false ? 'bg-blue-600' : 'bg-white/20'}`}
                         onClick={() => updateSettings('invoicing', 'showReferenceColumn', settings.invoicing?.showReferenceColumn === false ? true : false)}>
                      <div className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform duration-300 ${settings.invoicing?.showReferenceColumn !== false ? 'translate-x-8' : 'translate-x-0'}`}></div>
                    </div>
                    <span className="text-white/80 force-white" style={{ color: '#ffffff' }}>{settings.invoicing?.showReferenceColumn !== false ? p('billing.tables.show_reference') : p('billing.tables.hide_reference')}</span>
                  </div>
                  <p className="text-white/50 text-sm mt-2 force-white" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>{p('billing.tables.reference_help')}</p>
                </div>
                
                <div className="form-group mb-6">
                  <label className="text-white mb-2 block force-white" style={{ color: '#ffffff' }}>{p('billing.tables.table_type')}</label>
                  <select 
                    className="w-full p-3 bg-white/10 border border-white/20 rounded-lg text-white"
                    value={settings.invoicing?.tableType || 'standard'}
                    onChange={(e) => updateSettings('invoicing', 'tableType', e.target.value)}
                  >
                    {INDUSTRY_TABLE_TYPE_KEYS.map((typeKey) => (
                      <option key={typeKey} value={typeKey}>{p(`billing.industry_tables.types.${typeKey}`)}</option>
                    ))}
                  </select>
                </div>
                
                <div className="bg-white/5 p-4 rounded-lg mb-4">
                  <h4 className="text-white mb-3 font-semibold">{p('billing.tables.preview_title')}</h4>
                  <div className="overflow-x-auto">
                    <table className="w-full text-white/90 text-sm">
                      <thead className="bg-white/10 text-xs uppercase">
                        <tr>
                          {(() => {
                            const tableType = settings.invoicing?.tableType || 'standard';
                            const showReferenceColumn = settings.invoicing?.showReferenceColumn !== false;
                            return getIndustryTableHeaders(tableType, showReferenceColumn, p, t).map(header => 
                              <th key={header} className="px-3 py-2 text-left">{header}</th>
                            );
                          })()}
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="border-b border-white/10">
                          {(() => {
                            const tableType = settings.invoicing?.tableType || 'standard';
                            const showReferenceColumn = settings.invoicing?.showReferenceColumn !== false;
                            return getIndustryTablePreviewRow(tableType, showReferenceColumn, p, qawaemBrand).map((cell, idx) => 
                              <td key={idx} className="px-3 py-2">{cell}</td>
                            );
                          })()}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                
                <div className="text-white/70 text-sm bg-blue-500/10 p-3 rounded-lg border border-blue-500/20">
                  <p className="force-white" style={{ color: 'rgba(255, 255, 255, 0.8)' }}>{p('billing.tables.structure_note')}</p>
                </div>
              </div>
              )}
              
              {/* Apparence & Couleurs Tab - INLINE CODE */}
              {facturationTab === 'apparence' && (
                <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-6 border border-white/20">
                  <div className="flex items-center justify-between mb-4">
                    <div>
                      <h3 className="text-xl font-bold text-white">{p('billing.appearance.title')}</h3>
                      <p className="text-white/70 mt-1">{p('billing.appearance.subtitle')}</p>
                    </div>
                    <div className="p-3 rounded-2xl bg-gradient-to-r from-purple-500 to-indigo-600">
                      <Palette className="h-6 w-6 text-white" />
                    </div>
                  </div>
                  
                  {/* Colors Section */}
                  <div className="mb-6">
                    <h4 className="text-white font-semibold mb-4">{p('billing.appearance.colors')}</h4>
                    
                    {/* Color extraction from logo */}
                    <div className="p-4 bg-white/5 rounded-xl mb-5">
                      <h5 className="text-white font-medium mb-2">{p('billing.appearance.extract_colors')}</h5>
                      <div className="flex flex-wrap items-center gap-3">
                        <div 
                          className="relative h-16 w-16 bg-white/10 rounded-lg flex items-center justify-center overflow-hidden"
                          onClick={() => {
                            if (isColorPickerActive) {
                              return;
                            }
                          }}
                        >
                          {settings.company?.logo ? (
                            <img 
                              ref={logoRef}
                              src={settings.company?.logo} 
                              alt={p('company.logo')} 
                              className="max-h-14 max-w-14 object-contain"
                              crossOrigin="anonymous"
                              onError={(e) => {
                                console.error("Logo failed to load properly");
                                e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Crect width='100' height='100' fill='%23f0f0f0'/%3E%3Ctext x='50' y='50' font-family='Arial' font-size='12' text-anchor='middle' alignment-baseline='middle' fill='%23999999'%3ELogo%3C/text%3E%3C/svg%3E";
                              }}
                            />
                          ) : (
                            <div className="text-white/30 text-xs text-center">{p('common.no_logo')}</div>
                          )}
                        </div>
                        
                        <div className="flex flex-col gap-2">
                          <button 
                            onClick={() => {
                              if (settings.company?.logo) {
                                setExtractingColors(true);
                                
                                try {
                                  const companyName = settings.company?.name?.toLowerCase() || '';
                                  if (companyName.includes('sitek') || (logoRef.current && logoRef.current.src.includes('sitek'))) {
                                    setTimeout(() => {
                                      updateSettings('design', 'primaryColor', '#3b82f6');
                                      updateSettings('design', 'secondaryColor', '#000000');
                                      setExtractingColors(false);
                                      alert(p('messages_extra.colors_extracted'));
                                    }, 800);
                                    return;
                                  }
                                  
                                  if (logoRef.current) {
                                    try {
                                      extractColorsFromImage(logoRef.current)
                                        .then(({ primaryColor, secondaryColor }) => {
                                          console.log("Extracted colors:", { primaryColor, secondaryColor });
                                          
                                          primaryColor = primaryColor || '#3b82f6';
                                          secondaryColor = secondaryColor || '#000000';
                                          
                                          updateSettings('design', 'primaryColor', primaryColor);
                                          updateSettings('design', 'secondaryColor', secondaryColor);
                                          
                                          setExtractingColors(false);
                                          alert(p('messages_extra.colors_extracted'));
                                        })
                                        .catch(err => {
                                          console.error("Error extracting colors:", err);
                                          
                                          updateSettings('design', 'primaryColor', '#3b82f6');
                                          updateSettings('design', 'secondaryColor', '#000000');
                                          
                                          setExtractingColors(false);
                                          alert(p('messages_extra.colors_extract_error'));
                                        });
                                    } catch (err) {
                                      console.error("Error in extraction setup:", err);
                                      setTimeout(() => {
                                        updateSettings('design', 'primaryColor', '#3b82f6');
                                        updateSettings('design', 'secondaryColor', '#000000');
                                        setExtractingColors(false);
                                        alert(p('messages_extra.colors_extract_error'));
                                      }, 800);
                                    }
                                  } else {
                                    setTimeout(() => {
                                      updateSettings('design', 'primaryColor', '#3b82f6');
                                      updateSettings('design', 'secondaryColor', '#000000');
                                      setExtractingColors(false);
                                      alert(p('messages_extra.logo_load_error'));
                                    }, 800);
                                  }
                                } catch (err) {
                                  console.error("Error in color extraction process:", err);
                                  
                                  setTimeout(() => {
                                    updateSettings('design', 'primaryColor', '#3b82f6');
                                    updateSettings('design', 'secondaryColor', '#000000');
                                    setExtractingColors(false);
                                    alert(p('messages_extra.colors_extract_error'));
                                  }, 800);
                                }
                              } else {
                                alert(p('messages_extra.add_logo_first'));
                              }
                            }}
                            disabled={extractingColors || isColorPickerActive}
                            className={`${extractingColors ? 'bg-gray-500' : 'bg-blue-600 hover:bg-blue-700'} text-white px-4 py-2 rounded-lg flex items-center`}
                          >
                            {extractingColors ? (
                              <>
                                <div className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                                {p('billing.appearance.extracting')}
                              </>
                            ) : (
                              <>
                                <RefreshCw className="h-4 w-4 mr-2" />
                                {p('billing.appearance.auto_extract')}
                              </>
                            )}
                          </button>
                          
                          <div className="flex gap-2">
                            <button 
                              onClick={() => {
                                document.getElementById('primary-color-input').click();
                              }}
                              disabled={extractingColors}
                              className="bg-indigo-600 hover:bg-indigo-700 text-white px-3 py-1 rounded-lg flex items-center text-xs"
                            >
                              <Pipette className="h-3 w-3 mr-1" />
                              {p('billing.appearance.primary_pipette')}
                            </button>
                            
                            <button 
                              onClick={() => {
                                document.getElementById('secondary-color-input').click();
                              }}
                              disabled={extractingColors}
                              className="bg-gray-600 hover:bg-gray-700 text-white px-3 py-1 rounded-lg flex items-center text-xs"
                            >
                              <Pipette className="h-3 w-3 mr-1" />
                              {p('billing.appearance.secondary_pipette')}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    {/* Color picker section */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-3">
                      <div className="form-group">
                        <label className="field-label">{p('billing.appearance.primary_pipette')}</label>
                        <div className="flex items-center">
                          <input
                            id="primary-color-input"
                            type="color"
                            value={settings.design?.primaryColor || '#3b82f6'}
                            onChange={(e) => updateSettings('design', 'primaryColor', e.target.value)}
                            className="w-10 h-10 rounded-lg border-0 mr-3 cursor-pointer"
                          />
                          <input
                            type="text"
                            value={settings.design?.primaryColor || '#3b82f6'}
                            onChange={(e) => updateSettings('design', 'primaryColor', e.target.value)}
                            placeholder="#3b82f6"
                            className="w-full"
                          />
                        </div>
                      </div>
                      
                      <div className="form-group">
                        <label className="field-label">{p('billing.appearance.secondary_pipette')}</label>
                        <div className="flex items-center">
                          <input
                            id="secondary-color-input"
                            type="color"
                            value={settings.design?.secondaryColor || '#10b981'}
                            onChange={(e) => updateSettings('design', 'secondaryColor', e.target.value)}
                            className="w-10 h-10 rounded-lg border-0 mr-3 cursor-pointer"
                          />
                          <input
                            type="text"
                            value={settings.design?.secondaryColor || '#10b981'}
                            onChange={(e) => updateSettings('design', 'secondaryColor', e.target.value)}
                            placeholder="#10b981"
                            className="w-full"
                          />
                        </div>
                      </div>
                    </div>
                    
                    {/* Preset color palettes */}
                    <div className="mt-4 p-4 bg-white/5 rounded-xl">
                      <h5 className="text-white font-medium mb-3">{p('billing.appearance.preset_palettes')}</h5>
                      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-3">
                        {[
                          { nameKey: 'palette_blue', primary: '#3b82f6', secondary: '#60a5fa' },
                          { nameKey: 'palette_green', primary: '#10b981', secondary: '#34d399' },
                          { nameKey: 'palette_red', primary: '#ef4444', secondary: '#f87171' },
                          { nameKey: 'palette_purple', primary: '#8b5cf6', secondary: '#a78bfa' },
                          { nameKey: 'palette_orange', primary: '#f97316', secondary: '#fb923c' },
                          { nameKey: 'palette_yellow', primary: '#eab308', secondary: '#facc15' },
                          { nameKey: 'palette_indigo', primary: '#6366f1', secondary: '#818cf8' },
                          { nameKey: 'palette_pink', primary: '#ec4899', secondary: '#f472b6' },
                          { nameKey: 'palette_gray', primary: '#4b5563', secondary: '#9ca3af' },
                          { nameKey: 'palette_corporate', primary: '#1e40af', secondary: '#3b82f6' },
                        ].map((palette) => (
                          <button 
                            key={palette.nameKey}
                            onClick={() => {
                              updateSettings('design', 'primaryColor', palette.primary);
                              updateSettings('design', 'secondaryColor', palette.secondary);
                            }}
                            className="text-center p-2 bg-white/10 hover:bg-white/20 rounded-lg transition-all"
                          >
                            <div className="flex justify-center mb-1">
                              <div 
                                className="w-5 h-5 rounded-full mr-1" 
                                style={{backgroundColor: palette.primary}}
                              ></div>
                              <div 
                                className="w-5 h-5 rounded-full" 
                                style={{backgroundColor: palette.secondary}}
                              ></div>
                            </div>
                            <span className="text-xs text-white/70">{p(`billing.appearance.${palette.nameKey}`)}</span>
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                  
                  {/* Typography Section */}
                  <div>
                    <h4 className="text-white font-semibold mb-4">{p('billing.appearance.typography')}</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="form-group">
                        <label className="field-label">{p('billing.appearance.primary_font')}</label>
                        <select 
                          value={settings.design?.primaryFont || 'Inter'} 
                          onChange={(e) => updateSettings('design', 'primaryFont', e.target.value)}
                          className="w-full"
                        >
                          <option value="Inter">Inter</option>
                          <option value="Roboto">Roboto</option>
                          <option value="Open Sans">Open Sans</option>
                          <option value="Montserrat">Montserrat</option>
                          <option value="Raleway">Raleway</option>
                          <option value="Poppins">Poppins</option>
                        </select>
                      </div>
                      
                      <div className="form-group">
                        <label className="field-label">{p('billing.appearance.font_size')}</label>
                        <select 
                          value={settings.design?.fontSize || 'medium'} 
                          onChange={(e) => updateSettings('design', 'fontSize', e.target.value)}
                          className="w-full"
                        >
                          <option value="small">{p('billing.appearance.font_small')}</option>
                          <option value="medium">{p('billing.appearance.font_medium')}</option>
                          <option value="large">{p('billing.appearance.font_large')}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  
                  <div className="mt-6 flex justify-center">
                    <button
                      onClick={() => setShowModelPreview(true)}
                      className="px-4 py-2 bg-gradient-to-r from-blue-500 to-blue-700 text-white rounded-lg flex items-center"
                    >
                      <Eye className="h-4 w-4 mr-2" />
                      {p('common.preview')}
                    </button>
                  </div>
                </div>
              )}
              
              {/* Modèles de documents Tab */}
              {facturationTab === 'modeles' && (
              <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-6 border border-white/20">
                <h3 className="text-xl font-bold text-white pb-3 border-b border-white/20 mb-6">{p('billing.templates.title')}</h3>
              
                {/* Models Content - Direct display without sub-navigation */}
                <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-6 border border-white/20">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <h3 className="text-xl font-bold text-white">{p('billing.templates.selection_title')}</h3>
                    <p className="text-white/70 mt-1">{p('billing.templates.selection_subtitle')}</p>
                  </div>
                  <div className="p-3 rounded-2xl bg-gradient-to-r from-blue-500 to-blue-600">
                    <FileText className="h-6 w-6 text-white" />
                  </div>
                </div>

                {/* Models selection grid */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4 mb-6">
                  {/* Model 1 - Classic */}
                  <div 
                    className={`document-model-card ${!settings.design?.selectedModel || settings.design?.selectedModel === 'classic' ? 'selected' : ''}`}
                    onClick={() => updateSettings('design', 'selectedModel', 'classic')}
                  >
                    <div className="document-model-card-header">
                      <h4>{p('billing.templates.models.classic')}</h4>
                      {(!settings.design?.selectedModel || settings.design?.selectedModel === 'classic') && (
                        <div className="document-model-selected-badge">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="document-model-thumbnail">
                      <div style={{
                        background: "white",
                        position: "relative",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column"
                      }}>
                        {/* Company header */}
                        <div style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "8px 5px",
                          borderBottom: "2px solid #3b82f6"
                        }}>
                          <div style={{
                            display: "flex",
                            alignItems: "center"
                          }}>
                            <div style={{
                              width: "20px",
                              height: "20px",
                              backgroundColor: "#3b82f6",
                              marginRight: "5px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: "2px"
                            }}>
                              <div style={{
                                width: "10px",
                                height: "10px",
                                border: "1px solid white",
                                borderRadius: "1px"
                              }}></div>
                        </div>
                            <div style={{fontSize: "9px", fontWeight: "bold"}}>Qawaem</div>
                          </div>
                          <div style={{
                            fontSize: "7px",
                            color: "#666",
                            maxWidth: "60%",
                            textAlign: "right"
                          }}>
                            {p('billing.templates_ui.preview_address_sample')}<br />
                            {p('billing.templates_ui.preview_phone_sample')}
                        </div>
                      </div>
                      
                        {/* Document title */}
                        <div style={{
                          padding: "5px 0 8px",
                          textAlign: "center",
                          borderBottom: "1px solid #e5e7eb"
                        }}>
                          <div style={{
                            fontSize: "12px",
                            fontWeight: "bold",
                            color: "#3b82f6"
                          }}>
                            {p('billing.templates_ui.preview_invoice')}
                          </div>
                          <div style={{
                            fontSize: "7px",
                            color: "#666",
                            marginTop: "2px"
                          }}>
                            {p('billing.templates_ui.preview_number_demo')}
                          </div>
                      </div>
                      
                        {/* Table section */}
                        <div style={{padding: "5px"}}>
                          <div style={{
                            backgroundColor: "#f3f4f6",
                            padding: "3px",
                            display: "flex",
                            marginBottom: "2px"
                          }}>
                            <div style={{width: "15%", fontSize: "6px", color: "#3b82f6", fontWeight: "bold"}}>{p('billing.templates_ui.preview_ref')}</div>
                            <div style={{width: "60%", fontSize: "6px", color: "#3b82f6", fontWeight: "bold"}}>{p('billing.templates_ui.preview_description')}</div>
                            <div style={{width: "25%", fontSize: "6px", color: "#3b82f6", fontWeight: "bold", textAlign: "right"}}>{p('billing.templates_ui.preview_amount')}</div>
                          </div>
                          <div style={{
                            padding: "3px",
                            display: "flex",
                            borderBottom: "1px solid #f3f4f6"
                          }}>
                            <div style={{width: "15%", fontSize: "6px", color: "#666"}}>P-001</div>
                            <div style={{width: "60%", fontSize: "6px", color: "#666"}}>{p('billing.templates_ui.preview_service_consultation')}</div>
                            <div style={{width: "25%", fontSize: "6px", color: "#666", textAlign: "right"}}>{p('billing.templates_ui.preview_amount_sample_da')}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="document-model-card-footer">
                      <button 
                        className="document-model-view-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          updateSettings('design', 'selectedModel', 'classic');
                          setShowModelPreview(true);
                        }}
                      >
                        <Eye className="h-4 w-4 mr-1" />
                        {p('billing.templates_ui.preview_button')}
                      </button>
                    </div>
                  </div>

                  {/* Model 2 - Modern */}
                  <div 
                    className={`document-model-card ${settings.design?.selectedModel === 'modern' ? 'selected' : ''}`}
                    onClick={() => updateSettings('design', 'selectedModel', 'modern')}
                  >
                    <div className="document-model-card-header">
                      <h4>{p('billing.templates.models.modern')}</h4>
                      {settings.design?.selectedModel === 'modern' && (
                        <div className="document-model-selected-badge">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="document-model-thumbnail">
                      <div style={{
                        background: "white",
                        position: "relative",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column"
                      }}>
                        {/* Modern header with accent color */}
                        <div style={{
                          backgroundColor: "#1e40af",
                          padding: "8px 5px",
                          display: "flex",
                          justifyContent: "space-between",
                          color: "white"
                        }}>
                          <div style={{
                            display: "flex",
                            alignItems: "center"
                          }}>
                            <div style={{
                              width: "22px",
                              height: "22px",
                              backgroundColor: "white",
                              borderRadius: "50%",
                              marginRight: "5px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}>
                              <div style={{
                                width: "14px",
                                height: "14px",
                                backgroundColor: "#1e40af",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                              }}>
                                <div style={{
                                  width: "8px",
                                  height: "8px",
                                  backgroundColor: "white",
                                  borderRadius: "50%"
                                }}></div>
                              </div>
                            </div>
                            <div>
                              <div style={{fontSize: "9px", fontWeight: "bold", letterSpacing: "0.5px"}}>Qawaem</div>
                              <div style={{fontSize: "6px", opacity: 0.8}}>{p('billing.templates_ui.preview_management_software')}</div>
                            </div>
                          </div>
                          <div style={{
                            fontSize: "6px",
                            opacity: 0.8,
                            alignSelf: "flex-end"
                          }}>
                            info@qawaem.sa
                          </div>
                        </div>
                        
                        {/* Document info bar */}
                        <div style={{
                          padding: "4px 5px",
                          backgroundColor: "#f1f5f9",
                          borderBottom: "2px solid #e2e8f0",
                          display: "flex",
                          justifyContent: "space-between"
                        }}>
                          <div style={{fontSize: "6px", color: "#475569"}}>{p('billing.templates_ui.preview_ref_sample')}</div>
                          <div style={{fontSize: "6px", color: "#475569"}}>{p('billing.templates_ui.preview_date_sample')}</div>
                        </div>
                        
                        {/* Document title */}
                        <div style={{
                          padding: "8px 0",
                          textAlign: "center"
                        }}>
                          <div style={{
                            fontSize: "11px",
                            fontWeight: "bold",
                            color: "#1e40af"
                          }}>
                            {p('billing.templates_ui.preview_invoice')}
                          </div>
                        </div>
                        
                        {/* Table section */}
                        <div style={{padding: "3px 5px"}}>
                          <div style={{
                            backgroundColor: "#dbeafe",
                            padding: "4px",
                            display: "flex",
                            marginBottom: "2px",
                            borderRadius: "3px"
                          }}>
                            <div style={{width: "15%", fontSize: "6px", color: "#1e40af", fontWeight: "bold"}}>{p('billing.templates_ui.preview_code')}</div>
                            <div style={{width: "65%", fontSize: "6px", color: "#1e40af", fontWeight: "bold"}}>{p('billing.industry_tables.columns.designation')}</div>
                            <div style={{width: "20%", fontSize: "6px", color: "#1e40af", fontWeight: "bold", textAlign: "right"}}>{p('billing.templates_ui.preview_price')}</div>
                          </div>
                          <div style={{
                            padding: "4px",
                            display: "flex",
                            borderBottom: "1px solid #f1f5f9"
                          }}>
                            <div style={{width: "15%", fontSize: "6px", color: "#4b5563"}}>PRO-42</div>
                            <div style={{width: "65%", fontSize: "6px", color: "#4b5563"}}>{p('billing.templates_ui.preview_app_development')}</div>
                            <div style={{width: "20%", fontSize: "6px", color: "#4b5563", textAlign: "right"}}>45.000,00</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="document-model-card-footer">
                      <button 
                        className="document-model-view-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          updateSettings('design', 'selectedModel', 'modern');
                          setShowModelPreview(true);
                        }}
                      >
                        <Eye className="h-4 w-4 mr-1" />
                        {p('billing.templates_ui.preview_button')}
                      </button>
                    </div>
                  </div>



                      
                  {/* Model 5 - Professionnel */}
                  <div 
                    className={`document-model-card premium-model ${settings.design?.selectedModel === 'arabic2' ? 'selected' : ''}`}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    <div className="document-model-card-header">
                      <div className="premium-badge">
                        <Lock className="h-3 w-3 text-yellow-500" style={{ color: '#f59e0b' }} />
                        <span className="text-xs font-semibold text-yellow-500" style={{ color: '#f59e0b' }}>
                          {p('billing.templates_ui.premium_paid')}
                        </span>
                      </div>
                      <h4>{p('billing.templates.models.professional')}</h4>
                      {settings.design?.selectedModel === 'arabic2' && (
                        <div className="document-model-selected-badge">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="document-model-thumbnail">
                      <div style={{display: "flex", backgroundColor: "#1e3a5c", color: "white", padding: "10px", borderTopRightRadius: "20px"}}>
                        <div style={{width: "70%", textAlign: "left", direction: "ltr"}}>
                          <div style={{fontSize: "14px", fontWeight: "bold"}}>{p('billing.templates_ui.preview_invoice_pro')}</div>
                        </div>
                        <div style={{width: "30%", backgroundColor: "#e63946", height: "30px", borderRadius: "5px"}}></div>
                      </div>
                      <div className="model-section table-section mini" style={{backgroundColor: "white", color: "#333"}}>
                        <div className="model-table-header" style={{backgroundColor: "#e63946", color: "white"}}>
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                        <div className="model-table-row">
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                      </div>
                    </div>
                    <div className="document-model-card-footer">
                      <button 
                        className="document-model-view-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          updateSettings('design', 'selectedModel', 'arabic2');
                          setShowModelPreview(true);
                        }}
                      >
                        <Eye className="h-4 w-4 mr-1" />
                        {p('billing.templates_ui.preview_button')}
                      </button>
                    </div>
                  </div>

                  {/* Model 6 - Élégant */}
                  <div 
                    className={`document-model-card premium-model ${settings.design?.selectedModel === 'arabic3' ? 'selected' : ''}`}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    <div className="document-model-card-header">
                      <div className="premium-badge">
                        <Lock className="h-3 w-3 text-yellow-500" style={{ color: '#f59e0b' }} />
                        <span className="text-xs font-semibold text-yellow-500" style={{ color: '#f59e0b' }}>
                          {p('billing.templates_ui.premium_paid')}
                        </span>
                      </div>
                      <h4>{p('billing.templates.models.elegant')}</h4>
                      {settings.design?.selectedModel === 'arabic3' && (
                        <div className="document-model-selected-badge">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="document-model-thumbnail" style={{backgroundColor: "#6c5ce7", color: "white", textAlign: "center", direction: "ltr"}}>
                      <div style={{display: "flex", justifyContent: "space-between", padding: "10px 0"}}>
                        <div style={{width: "30%", height: "30px", backgroundColor: "rgba(255,255,255,0.2)", borderRadius: "50%"}}></div>
                        <div style={{width: "40%", textAlign: "center"}}>
                          <div style={{fontSize: "14px", fontWeight: "bold"}}>{p('billing.templates_ui.preview_invoice_premium')}</div>
                        </div>
                      </div>
                      <div className="model-section table-section mini" style={{backgroundColor: "white", color: "#333", borderRadius: "4px"}}>
                        <div className="model-table-header" style={{backgroundColor: "#6c5ce7", color: "white"}}>
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                        <div className="model-table-row">
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                      </div>
                    </div>
                    <div className="document-model-card-footer">
                      <button 
                        className="document-model-view-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          updateSettings('design', 'selectedModel', 'arabic3');
                          setShowModelPreview(true);
                        }}
                      >
                        <Eye className="h-4 w-4 mr-1" />
                        {p('billing.templates_ui.preview_button')}
                      </button>
                    </div>
                  </div>

                  {/* Model 7 - Contemporain */}
                  <div 
                    className={`document-model-card premium-model ${settings.design?.selectedModel === 'moderne' ? 'selected' : ''}`}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    <div className="document-model-card-header">
                      <div className="premium-badge">
                        <Lock className="h-3 w-3 text-yellow-500" style={{ color: '#f59e0b' }} />
                        <span className="text-xs font-semibold text-yellow-500" style={{ color: '#f59e0b' }}>
                          {p('billing.templates_ui.premium_paid')}
                        </span>
                      </div>
                      <h4>{p('billing.templates.models.contemporary')}</h4>
                      {settings.design?.selectedModel === 'moderne' && (
                        <div className="document-model-selected-badge">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="document-model-thumbnail">
                      <div style={{backgroundColor: "#2c3e50", color: "white", padding: "10px 5px", display: "flex", justifyContent: "space-between"}}>
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div style={{
                            width: "15px",
                            height: "15px",
                            backgroundColor: "rgba(255,255,255,0.1)",
                            border: "1px solid rgba(255,255,255,0.2)",
                            borderRadius: "2px",
                            marginRight: "5px"
                          }}></div>
                          <div style={{fontSize: "9px", fontWeight: "bold"}}>Qawaem</div>
                        </div>
                        <div style={{fontSize: "9px", fontWeight: "bold"}}>{p('billing.templates_ui.preview_invoice')}</div>
                      </div>
                      <div style={{backgroundColor: "#f9f9f9", padding: "4px 5px", fontSize: "7px", display: "flex", justifyContent: "space-between"}}>
                        <span>{p('billing.templates_ui.preview_ref_demo')}</span>
                        <span>{p('billing.templates_ui.preview_date_demo')}</span>
                      </div>
                      <div className="model-section table-section mini" style={{backgroundColor: "white", color: "#333"}}>
                        <div className="model-table-header" style={{backgroundColor: "#f2f2f2", borderBottom: "1px solid #2c3e50"}}>
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                        <div className="model-table-row">
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                      </div>
                    </div>
                    <div className="document-model-card-footer">
                      <button 
                        className="document-model-view-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          updateSettings('design', 'selectedModel', 'moderne');
                          setShowModelPreview(true);
                        }}
                      >
                        <Eye className="h-4 w-4 mr-1" />
                        {p('billing.templates_ui.preview_button')}
                      </button>
                    </div>
                      </div>



                      
                  {/* Model 16 - Organic */}
                  <div 
                    className={`document-model-card ${settings.design?.selectedModel === 'organic' ? 'selected' : ''}`}
                    onClick={() => updateSettings('design', 'selectedModel', 'organic')}
                  >
                    <div className="document-model-card-header">
                      <h4>{p('billing.templates.models.organic')}</h4>
                      {settings.design?.selectedModel === 'organic' && (
                        <div className="document-model-selected-badge">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="document-model-thumbnail">
                      <div style={{
                        backgroundColor: "white", 
                        padding: "10px 5px", 
                        display: "flex", 
                        justifyContent: "space-between", 
                        alignItems: "center",
                        position: "relative"
                      }}>
                        <div style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          width: "15px",
                          height: "15px",
                          borderRadius: "50%",
                          border: "1px solid #e8ecd9",
                          opacity: "0.5",
                          zIndex: "0"
                        }}></div>
                        <div style={{display: "flex", alignItems: "center", zIndex: "1"}}>
                          <div style={{
                            width: "12px",
                            height: "12px",
                            backgroundColor: "#739e53",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "4px",
                            position: "relative",
                            overflow: "hidden"
                          }}>
                            <div style={{
                              width: "6px",
                              height: "6px",
                              backgroundColor: "white",
                              borderRadius: "50%"
                            }}></div>
                            <div style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              width: "9px",
                              height: "9px",
                              borderRadius: "50%",
                              border: "1px solid white",
                              transform: "translate(-50%, -50%)"
                            }}></div>
                          </div>
                          <div style={{ fontSize: "7px", fontWeight: "700", color: "#739e53" }}>{p('billing.templates.models.organic')}</div>
                        </div>
                        <div style={{fontSize: "7px", fontWeight: "700", color: "#739e53"}}>{p('billing.templates_ui.preview_invoice')}</div>
                      </div>
                      <div style={{
                        backgroundColor: "#f8f9f3",
                        padding: "4px 5px",
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "6px",
                        color: "#8a9a78",
                        borderTop: "1px solid #e8ecd9",
                        borderBottom: "1px solid #e8ecd9"
                      }}>
                        <span>{p('billing.templates_ui.preview_date_sep')}</span>
                        <div style={{
                          color: "#739e53", 
                          fontWeight: "600",
                          display: "flex",
                          alignItems: "center"
                        }}>
                          <span style={{
                            width: "4px",
                            height: "4px",
                            backgroundColor: "#739e53",
                            borderRadius: "50%",
                            marginRight: "3px"
                          }}></span>
                          {p('billing.templates_ui.preview_issued')}
                        </div>
                      </div>
                      <div className="model-section table-section mini" style={{backgroundColor: "white", color: "#333"}}>
                        <div className="model-table-header" style={{borderBottom: "1px solid #e8ecd9"}}>
                          <div className="model-cell small" style={{color: "#8a9a78", fontSize: "5px"}}>{p('billing.templates_ui.preview_description')}</div>
                          <div className="model-cell medium" style={{color: "#8a9a78", fontSize: "5px", textAlign: "center"}}>{p('billing.templates_ui.preview_qty')}</div>
                          <div className="model-cell large" style={{color: "#8a9a78", fontSize: "5px", textAlign: "right"}}>{p('billing.templates_ui.preview_amount')}</div>
                        </div>
                        <div className="model-table-row" style={{backgroundColor: "#f8f9f3", borderRadius: "5px", marginTop: "2px"}}>
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                      </div>
                    </div>
                    <div className="document-model-card-footer">
                      <button 
                        className="document-model-view-btn premium-preview-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          updateSettings('design', 'selectedModel', 'organic');
                          setShowModelPreview(true);
                        }}
                      >
                        <Eye className="h-4 w-4 mr-1" />
                        {p('billing.templates_ui.preview_button')}
                      </button>
                    </div>
                  </div>
                  
                  {/* Model 17 - Architectural */}
                  <div 
                    className={`document-model-card ${settings.design?.selectedModel === 'architectural' ? 'selected' : ''}`}
                    onClick={() => updateSettings('design', 'selectedModel', 'architectural')}
                  >
                    <div className="document-model-card-header">
                      <h4>{p('billing.templates.models.geometric')}</h4>
                      {settings.design?.selectedModel === 'geometric' && (
                        <div className="document-model-selected-badge">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="document-model-thumbnail">
                      <div style={{
                        position: "relative",
                        backgroundColor: "white", 
                        padding: "10px 5px", 
                        display: "flex", 
                        justifyContent: "space-between", 
                        alignItems: "center",
                        overflow: "hidden"
                      }}>
                        {/* Geometric Elements */}
                        <div style={{
                          position: "absolute",
                          top: "0",
                          right: "0",
                          width: "20px",
                          height: "20px",
                          backgroundColor: "#3498db",
                          transform: "rotate(45deg) translate(10px, -15px)",
                          opacity: "0.8",
                          zIndex: "0"
                        }}></div>
                        <div style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          width: "10px",
                          height: "10px",
                          backgroundColor: "#2980b9",
                          transform: "rotate(45deg)",
                          opacity: "0.6",
                          zIndex: "0"
                        }}></div>
                        
                        <div style={{display: "flex", alignItems: "center", zIndex: "1"}}>
                          <div style={{
                            width: "12px",
                            height: "12px",
                            position: "relative",
                            marginRight: "4px"
                          }}>
                            <div style={{
                              position: "absolute",
                              top: "0",
                              left: "0",
                              width: "7px",
                              height: "7px",
                              backgroundColor: "#3498db",
                              zIndex: "1"
                            }}></div>
                            <div style={{
                              position: "absolute",
                              bottom: "0",
                              right: "0",
                              width: "7px",
                              height: "7px",
                              backgroundColor: "#2980b9",
                              zIndex: "2"
                            }}></div>
                        </div>
                          <div style={{ fontSize: "7px", fontWeight: "500", color: "#2c3e50" }}>GEOMETRIC</div>
                      </div>
                        <div style={{
                          fontSize: "7px",
                          fontWeight: "500", 
                          color: "#2c3e50",
                          position: "relative",
                          zIndex: "1"
                        }}>{p('billing.templates_ui.preview_invoice')}</div>
                      </div>
                      <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "4px 5px",
                        backgroundColor: "#ecf0f1",
                        borderTop: "2px solid #3498db",
                        borderBottom: "2px solid #3498db",
                        fontSize: "6px",
                        color: "#7f8c8d"
                      }}>
                        <span>{p('billing.templates_ui.preview_date_upper_demo')}</span>
                        <span>{p('billing.templates_ui.preview_reference_demo')}</span>
                      </div>
                      <div className="model-section table-section mini" style={{backgroundColor: "white", color: "#333"}}>
                        <div className="model-table-header" style={{backgroundColor: "#ecf0f1", borderBottom: "2px solid #3498db"}}>
                          <div className="model-cell small" style={{color: "#2c3e50", fontSize: "5px"}}>{p('billing.templates_ui.preview_description_upper')}</div>
                          <div className="model-cell medium" style={{color: "#2c3e50", fontSize: "5px", textAlign: "center"}}>{p('billing.templates_ui.preview_qty_upper')}</div>
                          <div className="model-cell large" style={{color: "#2c3e50", fontSize: "5px", textAlign: "right"}}>{p('billing.templates_ui.preview_amount_upper')}</div>
                        </div>
                        <div className="model-table-row">
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                      </div>
                    </div>
                    <div className="document-model-card-footer">
                      <button 
                        className="document-model-view-btn premium-preview-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          updateSettings('design', 'selectedModel', 'geometric');
                          setShowModelPreview(true);
                        }}
                      >
                        <Eye className="h-4 w-4 mr-1" />
                        {p('billing.templates_ui.preview_button')}
                      </button>
                    </div>
                  </div>
                  
                  {/* Model 19 - Finance */}
                  <div 
                    className={`document-model-card ${settings.design?.selectedModel === 'finance' ? 'selected' : ''}`}
                    onClick={() => updateSettings('design', 'selectedModel', 'finance')}
                  >
                    <div className="document-model-card-header">
                      <h4>{p('billing.templates.models.finance')}</h4>
                      {settings.design?.selectedModel === 'finance' && (
                        <div className="document-model-selected-badge">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="document-model-thumbnail">
                      <div style={{
                        backgroundColor: "white", 
                        padding: "10px 5px", 
                        display: "flex", 
                        justifyContent: "space-between", 
                        alignItems: "center",
                        borderBottom: "1px solid #ebeef2"
                      }}>
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div style={{
                            width: "12px",
                            height: "12px",
                            backgroundColor: "#192a56",
                            borderRadius: "2px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "4px",
                            color: "white",
                            fontWeight: "600",
                            fontSize: "7px"
                          }}>F</div>
                          <div style={{ fontSize: "7px", fontWeight: "600", color: "#192a56" }}>FINANCE<span style={{color: "#4a69bd"}}>PRO</span></div>
                        </div>
                        <div style={{fontSize: "7px", fontWeight: "600", color: "#192a56"}}>{p('billing.templates_ui.preview_invoice')}</div>
                      </div>
                      <div style={{
                        backgroundColor: "#f9fafc",
                        padding: "4px 5px",
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "6px",
                        color: "#57606f"
                      }}>
                        <span>{p('billing.templates_ui.preview_invoice_no_demo')}</span>
                        <span>10/10/2023</span>
                      </div>
                      <div className="model-section table-section mini" style={{backgroundColor: "white", color: "#333"}}>
                        <div className="model-table-header" style={{
                          backgroundColor: "#f9fafc", 
                          border: "1px solid #ebeef2"
                        }}>
                          <div className="model-cell small" style={{color: "#192a56", fontSize: "5px"}}>{p('billing.templates_ui.preview_description_upper')}</div>
                          <div className="model-cell medium" style={{color: "#192a56", fontSize: "5px", textAlign: "center"}}>{p('billing.templates_ui.preview_hours')}</div>
                          <div className="model-cell large" style={{color: "#192a56", fontSize: "5px", textAlign: "right"}}>{p('billing.templates_ui.preview_amount_upper')}</div>
                        </div>
                        <div className="model-table-row" style={{border: "1px solid #ebeef2", borderTop: "none"}}>
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                      </div>
                    </div>
                    <div className="document-model-card-footer">
                      <button 
                        className="document-model-view-btn premium-preview-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          updateSettings('design', 'selectedModel', 'finance');
                          setShowModelPreview(true);
                        }}
                      >
                        <Eye className="h-4 w-4 mr-1" />
                        {p('billing.templates_ui.preview_button')}
                      </button>
                    </div>
                  </div>
                  
                  {/* Model 21 - Heritage */}
                  <div 
                    className={`document-model-card ${settings.design?.selectedModel === 'heritage' ? 'selected' : ''}`}
                    onClick={() => updateSettings('design', 'selectedModel', 'heritage')}
                  >
                    <div className="document-model-card-header">
                      <h4>{p('billing.templates.models.heritage')}</h4>
                      {settings.design?.selectedModel === 'heritage' && (
                        <div className="document-model-selected-badge">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="document-model-thumbnail">
                      <div style={{
                        backgroundColor: "white", 
                        padding: "10px 5px", 
                        display: "flex", 
                        justifyContent: "space-between", 
                        alignItems: "center",
                        borderBottom: "1px solid #e7e3da",
                        position: "relative"
                      }}>
                        {/* Decorative Frame */}
                        <div style={{
                          position: "absolute",
                          top: "2px",
                          left: "2px",
                          right: "2px",
                          bottom: "2px",
                          border: "1px solid #e7e3da",
                          pointerEvents: "none",
                          zIndex: "0"
                        }}></div>
                        
                        <div style={{
                          fontFamily: '"Playfair Display", serif',
                          fontWeight: "700", 
                          fontSize: "10px", 
                          color: "#3a3025", 
                          letterSpacing: "0.5px",
                          borderBottom: "1px solid #c7b299",
                          paddingBottom: "2px",
                          zIndex: "1"
                        }}>{p('billing.templates.models.heritage')}</div>
                        <div style={{ 
                          fontFamily: '"Playfair Display", serif',
                          fontWeight: "700", 
                          fontSize: "9px", 
                          color: "#3a3025",
                          zIndex: "1"
                        }}>{p('billing.templates_ui.preview_invoice')}</div>
                      </div>
                      <div style={{
                        backgroundColor: "#fbfaf8",
                        padding: "4px 5px",
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "5px",
                        color: "#7d735f",
                        fontFamily: '"Cormorant Garamond", serif',
                        fontStyle: "italic"
                      }}>
                        <span>№ <span style={{color: "#3a3025", fontWeight: "600"}}>{p('billing.templates_ui.preview_heritage_no_demo')}</span></span>
                        <span>18 Oct 2023</span>
                      </div>
                      <div className="model-section table-section mini" style={{backgroundColor: "white", color: "#333"}}>
                        <div className="model-table-header" style={{backgroundColor: "#fbfaf8", borderBottom: "1px solid #e7e3da"}}>
                          <div className="model-cell small" style={{color: "#3a3025", fontSize: "5px"}}>{p('billing.templates_ui.preview_description_upper')}</div>
                          <div className="model-cell medium" style={{color: "#3a3025", fontSize: "5px", textAlign: "center"}}>{p('billing.templates_ui.preview_qty_upper')}</div>
                          <div className="model-cell large" style={{color: "#3a3025", fontSize: "5px", textAlign: "right"}}>{p('billing.templates_ui.preview_amount_upper')}</div>
                        </div>
                        <div className="model-table-row" style={{borderBottom: "1px solid #e7e3da"}}>
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                      </div>
                    </div>
                    <div className="document-model-card-footer">
                      <button 
                        className="document-model-view-btn premium-preview-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          updateSettings('design', 'selectedModel', 'heritage');
                          setShowModelPreview(true);
                        }}
                      >
                        <Eye className="h-4 w-4 mr-1" />
                        {p('billing.templates_ui.preview_button')}
                      </button>
                    </div>
                  </div>

                  {/* Model 28 - Nexus */}
                  <div 
                    className={`document-model-card ${settings.design?.selectedModel === 'nexus' ? 'selected' : ''}`}
                    onClick={() => updateSettings('design', 'selectedModel', 'nexus')}
                  >
                    <div className="document-model-card-header">
                      <h4>{p('billing.templates.models.nexus')}</h4>
                      {settings.design?.selectedModel === 'nexus' && (
                        <div className="document-model-selected-badge">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="document-model-thumbnail">
                      <div style={{
                        background: "linear-gradient(45deg, #3182ce 0%, #63b3ed 100%)",
                        padding: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                        color: "white"
                      }}>
                        <div style={{
                          display: "flex",
                          alignItems: "center"
                        }}>
                          <div style={{
                            width: "15px",
                            height: "15px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginRight: "5px",
                            backgroundColor: "rgba(255, 255, 255, 0.2)",
                            borderRadius: "4px"
                          }}>
                            <div style={{
                              width: "10px",
                              height: "2px",
                              backgroundColor: "white"
                            }}></div>
                          </div>
                          <div style={{fontSize: "8px", fontWeight: "bold"}}>NEXUS</div>
                        </div>
                        <div style={{fontSize: "8px", fontWeight: "bold"}}>{p('billing.templates_ui.preview_invoice')}</div>
                      </div>
                      <div className="model-section table-section mini" style={{backgroundColor: "white", color: "#333"}}>
                        <div className="model-table-header" style={{
                          backgroundColor: "#ebf8ff",
                          borderBottom: "1px solid #bee3f8"
                        }}>
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                        <div className="model-table-row">
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                      </div>
                    </div>
                    <div className="document-model-card-footer">
                      <button 
                        className="document-model-view-btn premium-preview-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          updateSettings('design', 'selectedModel', 'nexus');
                          setShowModelPreview(true);
                        }}
                      >
                        <Eye className="h-4 w-4 mr-1" />
                        {p('billing.templates_ui.preview_button')}
                      </button>
                    </div>
                  </div>

                  {/* Model 30 - Nova */}
                  <div 
                    className={`document-model-card ${settings.design?.selectedModel === 'nova' ? 'selected' : ''}`}
                    onClick={() => updateSettings('design', 'selectedModel', 'nova')}
                  >
                    <div className="document-model-card-header">
                      <h4>{p('billing.templates.models.nova')}</h4>
                      {settings.design?.selectedModel === 'nova' && (
                        <div className="document-model-selected-badge">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="document-model-thumbnail">
                      <div style={{
                        background: "linear-gradient(135deg, #805ad5 0%, #667eea 100%)",
                        padding: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                        color: "white"
                      }}>
                        <div style={{
                          display: "flex",
                          alignItems: "center"
                        }}>
                          <div style={{
                            width: "14px",
                            height: "14px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginRight: "5px",
                            backgroundColor: "rgba(255, 255, 255, 0.2)",
                            borderRadius: "50%"
                          }}>
                            <div style={{
                              width: "7px",
                              height: "7px",
                              borderRadius: "50%",
                              backgroundColor: "white"
                            }}></div>
                          </div>
                          <div style={{fontSize: "8px", fontWeight: "bold"}}>NOVA</div>
                        </div>
                        <div style={{fontSize: "8px", fontWeight: "bold"}}>{p('billing.templates_ui.preview_invoice')}</div>
                      </div>
                      <div className="model-section table-section mini" style={{backgroundColor: "white", color: "#333"}}>
                        <div className="model-table-header" style={{
                          backgroundColor: "#faf5ff",
                          borderBottom: "1px solid #e9d8fd"
                        }}>
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                        <div className="model-table-row">
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                      </div>
                    </div>
                    <div className="document-model-card-footer">
                      <button 
                        className="document-model-view-btn premium-preview-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          updateSettings('design', 'selectedModel', 'nova');
                          setShowModelPreview(true);
                        }}
                      >
                        <Eye className="h-4 w-4 mr-1" />
                        {p('billing.templates_ui.preview_button')}
                      </button>
                    </div>
                  </div>
                  
                  {/* Model 31 - Sphere */}
                  <div 
                    className={`document-model-card premium-model ${settings.design?.selectedModel === 'sphere' ? 'selected' : ''}`}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    <div className="document-model-card-header">
                      <div className="premium-badge">
                        <svg className="w-3 h-3 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                        <span style={{color: '#f59e0b', fontSize: '11px', fontWeight: '600'}}>{p('billing.templates_ui.premium_paid')}</span>
                      </div>
                      <h4>{p('billing.templates.models.sphere')}</h4>
                      {settings.design?.selectedModel === 'sphere' && (
                        <div className="document-model-selected-badge">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="document-model-thumbnail">
                      <div style={{
                        backgroundColor: "white",
                        padding: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderBottom: "1px solid #eaeaea"
                      }}>
                        <div style={{
                          display: "flex",
                          alignItems: "center"
                        }}>
                          <div style={{
                            width: "15px",
                            height: "15px",
                            borderRadius: "50%",
                            border: "2px solid #4299e1",
                            marginRight: "5px"
                          }}></div>
                          <div style={{fontSize: "8px", fontWeight: "600", color: "#333"}}>SPHERE</div>
                        </div>
                        <div style={{fontSize: "8px", fontWeight: "600", color: "#333"}}>{p('billing.templates_ui.preview_invoice')}</div>
                      </div>
                      <div className="model-section table-section mini" style={{backgroundColor: "white", color: "#333"}}>
                        <div className="model-table-header" style={{
                          backgroundColor: "#f7fafc",
                          borderBottom: "1px solid #e2e8f0"
                        }}>
                          <div className="model-cell small" style={{
                            position: "relative"
                          }}>
                            <div style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              width: "5px",
                              height: "5px",
                              borderRadius: "50%",
                              backgroundColor: "#4299e1",
                              opacity: "0.2"
                            }}></div>
                          </div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                        <div className="model-table-row">
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                      </div>
                    </div>
                    <div className="document-model-card-footer">
                      <button 
                        className="document-model-view-btn premium-preview-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          updateSettings('design', 'selectedModel', 'sphere');
                          setShowModelPreview(true);
                        }}
                      >
                        <Eye className="h-4 w-4 mr-1" />
                        {p('billing.templates_ui.preview_button')}
                      </button>
                    </div>
                  </div>
                  
                  {/* Model 32 - Fusion */}
                  <div 
                    className={`document-model-card premium-model ${settings.design?.selectedModel === 'fusion' ? 'selected' : ''}`}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    <div className="document-model-card-header">
                      <div className="premium-badge">
                        <svg className="w-3 h-3 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                        <span style={{color: '#f59e0b', fontSize: '11px', fontWeight: '600'}}>{p('billing.templates_ui.premium_paid')}</span>
                      </div>
                      <h4>{p('billing.templates.models.fusion')}</h4>
                      {settings.design?.selectedModel === 'fusion' && (
                        <div className="document-model-selected-badge">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="document-model-thumbnail">
                      <div style={{
                        background: "linear-gradient(135deg, #4c51bf 0%, #10b981 100%)",
                        padding: "12px 10px 8px 10px",
                        position: "relative"
                      }}>
                        <div style={{
                          color: "white",
                          fontSize: "9px",
                          fontWeight: "bold",
                          textTransform: "uppercase",
                          letterSpacing: "1px",
                          position: "relative",
                          zIndex: "2",
                          textAlign: "center"
                        }}>{p('billing.templates.models.fusion')}</div>
                        <div style={{
                          position: "absolute",
                          bottom: "-5px",
                          right: "15px",
                          width: "30px",
                          height: "10px",
                          backgroundColor: "white",
                          zIndex: "1",
                          borderTopLeftRadius: "10px",
                          borderTopRightRadius: "10px",
                          opacity: "0.2"
                        }}></div>
                      </div>
                      <div style={{
                        backgroundColor: "white",
                        padding: "10px 10px 5px 10px",
                        textAlign: "center",
                        borderBottom: "1px solid #eaeaea"
                      }}>
                        <div style={{
                          fontSize: "7px",
                          fontWeight: "bold",
                          color: "#4c51bf",
                          textTransform: "uppercase",
                          letterSpacing: "1px"
                        }}>{p('billing.templates_ui.preview_invoice')}</div>
                      </div>
                      <div className="model-section table-section mini" style={{backgroundColor: "white", color: "#333"}}>
                        <div className="model-table-header" style={{
                          backgroundColor: "#f7fafc",
                          borderBottom: "1px solid #e2e8f0"
                        }}>
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                        <div className="model-table-row">
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                      </div>
                    </div>
                    <div className="document-model-card-footer">
                      <button 
                        className="document-model-view-btn premium-preview-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          updateSettings('design', 'selectedModel', 'fusion');
                          setShowModelPreview(true);
                        }}
                      >
                        <Eye className="h-4 w-4 mr-1" />
                        {p('billing.templates_ui.preview_button')}
                      </button>
                    </div>
                  </div>
                  
                  {/* Model 34 - Pixel */}
                  <div 
                    className={`document-model-card premium-model ${settings.design?.selectedModel === 'pixel' ? 'selected' : ''}`}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    <div className="document-model-card-header">
                      <div className="premium-badge">
                        <svg className="w-3 h-3 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                        <span style={{color: '#f59e0b', fontSize: '11px', fontWeight: '600'}}>{p('billing.templates_ui.premium_paid')}</span>
                      </div>
                      <h4>{p('billing.templates.models.pixel')}</h4>
                      {settings.design?.selectedModel === 'pixel' && (
                        <div className="document-model-selected-badge">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="document-model-thumbnail">
                      <div style={{
                        background: "linear-gradient(135deg, #6b46c1 0%, #00b5d8 100%)",
                        padding: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                        position: "relative"
                      }}>
                        <div style={{
                          position: "absolute",
                          top: "4px",
                          right: "4px",
                          width: "16px",
                          height: "16px",
                          display: "grid",
                          gridTemplateColumns: "repeat(4, 1fr)",
                          gridTemplateRows: "repeat(4, 1fr)",
                          gap: "1px"
                        }}>
                          {[...Array(16)].map((_, i) => (
                            <div key={i} style={{
                              backgroundColor: i % 3 === 0 ? "rgba(255,255,255,0.6)" : "rgba(255,255,255,0.2)"
                            }}></div>
                          ))}
                        </div>
                        <div style={{
                          color: "white",
                          fontSize: "8px",
                          fontWeight: "bold",
                          letterSpacing: "1px"
                        }}>PIXEL</div>
                      </div>
                      <div style={{
                        backgroundColor: "white",
                        padding: "5px 10px",
                        borderBottom: "2px solid #6b46c1"
                      }}>
                        <div style={{
                          color: "#6b46c1",
                          fontSize: "7px",
                          fontWeight: "bold",
                          textAlign: "center",
                          textTransform: "uppercase"
                        }}>{p('billing.templates_ui.preview_invoice')}</div>
                      </div>
                      <div className="model-section table-section mini" style={{backgroundColor: "white", color: "#333"}}>
                        <div className="model-table-header" style={{
                          backgroundColor: "#f8f9fa"
                        }}>
                          <div className="model-cell small" style={{
                            position: "relative"
                          }}>
                            <div style={{
                              position: "absolute",
                              top: "2px",
                              right: "2px",
                              width: "4px",
                              height: "4px",
                              backgroundColor: "#6b46c1"
                            }}></div>
                          </div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                        <div className="model-table-row">
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                      </div>
                    </div>
                    <div className="document-model-card-footer">
                      <button 
                        className="document-model-view-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          updateSettings('design', 'selectedModel', 'pixel');
                          setShowModelPreview(true);
                        }}
                      >
                        <Eye className="h-4 w-4 mr-1" />
                        {p('billing.templates_ui.preview_button')}
                      </button>
                    </div>
                  </div>
                  
                  {/* Model 35 - Echo */}
                  <div 
                    className={`document-model-card premium-model ${settings.design?.selectedModel === 'echo' ? 'selected' : ''}`}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    <div className="document-model-card-header">
                      <div className="premium-badge">
                        <svg className="w-3 h-3 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                        <span style={{color: '#f59e0b', fontSize: '11px', fontWeight: '600'}}>{p('billing.templates_ui.premium_paid')}</span>
                      </div>
                      <h4>{p('billing.templates.models.echo')}</h4>
                      {settings.design?.selectedModel === 'echo' && (
                        <div className="document-model-selected-badge">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="document-model-thumbnail">
                      <div style={{
                        backgroundColor: "#f8fafc",
                        padding: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                        borderBottom: "2px solid #3b82f6",
                        position: "relative",
                        overflow: "hidden"
                      }}>
                        <div style={{
                          position: "absolute",
                          top: "-15px",
                          left: "-15px",
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          border: "2px solid rgba(59, 130, 246, 0.2)"
                        }}></div>
                        <div style={{
                          position: "absolute",
                          top: "-10px",
                          left: "-10px",
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          border: "2px solid rgba(59, 130, 246, 0.3)"
                        }}></div>
                        <div style={{
                          position: "relative",
                          zIndex: "2",
                          color: "#3b82f6",
                          fontSize: "9px",
                          fontWeight: "bold",
                          letterSpacing: "0.5px"
                        }}>ECHO</div>
                        <div style={{
                          position: "relative",
                          zIndex: "2",
                          color: "#333",
                          fontSize: "8px",
                          fontWeight: "bold"
                        }}>{p('billing.templates_ui.preview_invoice')}</div>
                      </div>
                      <div className="model-section table-section mini" style={{backgroundColor: "white", color: "#333"}}>
                        <div className="model-table-header" style={{
                          backgroundColor: "#f8fafc",
                          borderBottom: "1px solid #e2e8f0"
                        }}>
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                        <div className="model-table-row">
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                      </div>
                    </div>
                    <div className="document-model-card-footer">
                      <button 
                        className="document-model-view-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          updateSettings('design', 'selectedModel', 'echo');
                          setShowModelPreview(true);
                        }}
                      >
                        <Eye className="h-4 w-4 mr-1" />
                        {p('billing.templates_ui.preview_button')}
                      </button>
                    </div>
                  </div>
                  
                  {/* Model 37 - Vortex */}
                  <div 
                    className={`document-model-card premium-model ${settings.design?.selectedModel === 'vortex' ? 'selected' : ''}`}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    <div className="document-model-card-header">
                      <div className="premium-badge">
                        <svg className="w-3 h-3 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                        <span style={{color: '#f59e0b', fontSize: '11px', fontWeight: '600'}}>{p('billing.templates_ui.premium_paid')}</span>
                      </div>
                      <h4>{p('billing.templates.models.vortex')}</h4>
                      {settings.design?.selectedModel === 'vortex' && (
                        <div className="document-model-selected-badge">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="document-model-thumbnail">
                      <div style={{
                        backgroundColor: "#7b2cf8",
                        padding: "10px",
                        display: "flex",
                        justifyContent: "center",
                        position: "relative",
                        overflow: "hidden"
                      }}>
                        <div style={{
                          position: "absolute",
                          top: "5px",
                          left: "50%",
                          width: "60px",
                          height: "60px",
                          transform: "translateX(-50%)",
                          borderRadius: "50%",
                          border: "3px solid rgba(255,255,255,0.1)"
                        }}></div>
                        <div style={{
                          position: "absolute",
                          top: "10px",
                          left: "50%",
                          width: "40px",
                          height: "40px",
                          transform: "translateX(-50%)",
                          borderRadius: "50%",
                          border: "3px solid rgba(255,255,255,0.15)"
                        }}></div>
                        <div style={{
                          position: "absolute",
                          top: "15px",
                          left: "50%",
                          width: "20px",
                          height: "20px",
                          transform: "translateX(-50%)",
                          borderRadius: "50%",
                          border: "3px solid rgba(255,255,255,0.2)"
                        }}></div>
                        <div style={{
                          color: "white",
                          fontSize: "10px",
                          fontWeight: "bold",
                          position: "relative",
                          zIndex: "2"
                        }}>VORTEX</div>
                      </div>
                      <div style={{
                        backgroundColor: "white",
                        padding: "5px 10px",
                        textAlign: "center",
                        borderBottom: "1px solid #eaeaea"
                      }}>
                        <div style={{
                          color: "#7b2cf8",
                          fontSize: "7px",
                          fontWeight: "bold",
                          textTransform: "uppercase"
                        }}>{p('billing.templates_ui.preview_invoice')}</div>
                      </div>
                      <div className="model-section table-section mini" style={{backgroundColor: "white", color: "#333"}}>
                        <div className="model-table-header" style={{
                          backgroundColor: "#f8f9fa",
                          borderBottom: "1px solid #eaeaea"
                        }}>
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                        <div className="model-table-row">
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                      </div>
                    </div>
                    <div className="document-model-card-footer">
                      <button 
                        className="document-model-view-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          updateSettings('design', 'selectedModel', 'vortex');
                          setShowModelPreview(true);
                        }}
                      >
                        <Eye className="h-4 w-4 mr-1" />
                        {p('billing.templates_ui.preview_button')}
                      </button>
                    </div>
                  </div>
                  
                  
                  {/* Model 41 - Forge */}
                  <div 
                    className={`document-model-card premium-model ${settings.design?.selectedModel === 'forge' ? 'selected' : ''}`}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    <div className="document-model-card-header">
                      <div className="premium-badge">
                        <svg className="w-3 h-3 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                        <span style={{color: '#f59e0b', fontSize: '11px', fontWeight: '600'}}>{p('billing.templates_ui.premium_paid')}</span>
                      </div>
                      <h4>{p('billing.templates.models.forge')}</h4>
                      {settings.design?.selectedModel === 'forge' && (
                        <div className="document-model-selected-badge">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="document-model-thumbnail">
                      <div style={{
                        backgroundColor: "#1a202c",
                        padding: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                        backgroundImage: "repeating-linear-gradient(45deg, rgba(0,0,0,0) 0, rgba(0,0,0,0.1) 1px, rgba(0,0,0,0) 2px, rgba(0,0,0,0) 3px)"
                      }}>
                        <div style={{
                          display: "flex",
                          alignItems: "center"
                        }}>
                          <div style={{
                            width: "12px",
                            height: "12px",
                            backgroundColor: "#ed8936",
                            borderRadius: "0",
                            marginRight: "5px",
                            position: "relative"
                          }}>
                            <div style={{
                              position: "absolute",
                              top: "2px",
                              left: "2px",
                              right: "2px",
                              bottom: "2px",
                              border: "1px solid rgba(255,255,255,0.3)"
                            }}></div>
                          </div>
                          <div style={{fontSize: "8px", fontWeight: "bold", color: "white"}}>FORGE</div>
                        </div>
                        <div style={{fontSize: "8px", fontWeight: "bold", color: "#ed8936"}}>{p('billing.templates_ui.preview_invoice')}</div>
                      </div>
                      <div className="model-section table-section mini" style={{backgroundColor: "white", color: "#333"}}>
                        <div className="model-table-header" style={{
                          backgroundColor: "#f5f5f5",
                          borderBottom: "2px solid #ed8936"
                        }}>
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                        <div className="model-table-row">
                          <div className="model-cell small"></div>
                          <div className="model-cell medium"></div>
                          <div className="model-cell large"></div>
                        </div>
                      </div>
                    </div>
                    <div className="document-model-card-footer">
                      <button 
                        className="document-model-view-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          updateSettings('design', 'selectedModel', 'forge');
                          setShowModelPreview(true);
                        }}
                      >
                        <Eye className="h-4 w-4 mr-1" />
                        {p('billing.templates_ui.preview_button')}
                      </button>
                    </div>
                  </div>
                </div>
                
                <div className="flex justify-center mt-6">
                  <p className="text-white/70 text-center max-w-lg">
                    {p('billing.templates_ui.model_applied', { model: (() => {
                      const model = settings.design?.selectedModel;
                      if (!model || model === 'classic') return p('billing.templates.models.classic');
                      if (model === 'modern') return p('billing.templates.models.modern');
                      if (model === 'minimal') return p('billing.templates.models.contemporary');
                      if (model === 'arabic1') return p('billing.templates.models.classic');
                      if (model === 'arabic2') return p('billing.templates.models.professional');
                      if (model === 'arabic3') return p('billing.templates.models.elegant');
                      if (model === 'moderne') return p('billing.templates.models.contemporary');
                      if (model === 'corporate') return p('billing.templates.models.professional');
                      if (model === 'minimaliste') return p('billing.templates.models.contemporary');
                      return model || p('billing.templates.models.classic');
                    })() })}
                    <br/>
                    <span className="text-blue-400">{p('billing.templates_ui.click_preview_detail')}</span>
                  </p>
                </div>
              </div>
              </div>
              )}
              
              {/* Configuration des taxes Tab */}
              {facturationTab === 'taxes' && (
              <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-6 border border-white/20">
                <h3 className="text-xl font-bold text-white pb-2 border-b border-white/20 mb-6">{p('billing.taxes_title')}</h3>
              
              <div className="tax-info">
                <p>{p('billing.taxes_saudi_hint')}</p>
              </div>

              <div className="form-grid">
                <div className="form-group">
                  <label>{p('company.default_vat_rate')} (%)</label>
                  <input
                    type="number"
                    min="0"
                    max="99"
                    step="0.01"
                    value={settings.taxes?.tva ?? SAUDI_VAT_RATE}
                    onChange={(e) => updateSettings('taxes', 'tva', parseFloat(e.target.value))}
                  />
                  <small>{p('company.vat_standard_hint', { rate: SAUDI_VAT_RATE })}</small>
                </div>

                <div className="form-group">
                  <label>{p('company.withholding_rate')} (%)</label>
                  <input
                    type="number"
                    min="0"
                    max="99"
                    step="0.01"
                    value={settings.taxes.tap}
                    onChange={(e) => updateSettings('taxes', 'tap', parseFloat(e.target.value))}
                  />
                  <small>{p('company.withholding_hint')}</small>
                </div>


                <div className="form-group full-width">
                  <label>{p('billing.default_taxes')}</label>
                  <div className="checkbox-group">
                    {['tva', 'tap'].map(tax => (
                      <label key={tax} className="checkbox-label">
                        <input
                          type="checkbox"
                          checked={(settings.taxes.defaultTaxes || []).includes(tax)}
                          onChange={(e) => {
                            const currentTaxes = settings.taxes.defaultTaxes || [];
                            const newTaxes = e.target.checked
                              ? [...currentTaxes, tax]
                              : currentTaxes.filter(t => t !== tax);
                            updateSettings('taxes', 'defaultTaxes', newTaxes);
                          }}
                        />
                        {tax.toUpperCase()}
                      </label>
                    ))}
                  </div>
                </div>

                <div className="form-group full-width">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={settings.taxes.taxIncluded}
                      onChange={(e) => updateSettings('taxes', 'taxIncluded', e.target.checked)}
                    />
                    {p('billing.tax_included')}
                  </label>
                  <small>{p('billing.tax_included_hint')}</small>
                </div>
              </div>

              {/* Additional Costs Section */}
              <div className="form-grid mt-8">
                <h4 className="text-lg font-semibold text-white pb-2 border-b border-white/20 mb-4 col-span-full">{p('billing.extra_fees_title')}</h4>
                
                <div className="form-group">
                  <label>{p('company.guarantee_amount')} (ر.س)</label>
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    value={settings.taxes?.guarantee || 0}
                    onChange={(e) => updateSettings('taxes', 'guarantee', parseFloat(e.target.value) || 0)}
                  />
                  <small>{p('company.guarantee_hint', { symbol: SAUDI_CURRENCY_SYMBOL })}</small>
                </div>

                <div className="form-group">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={settings.taxes?.guaranteeByDefault || false}
                      onChange={(e) => updateSettings('taxes', 'guaranteeByDefault', e.target.checked)}
                    />
                    {p('billing.fees.guarantee_default')}
                  </label>
                  <small>{p('billing.fees.guarantee_auto_hint')}</small>
                </div>

                <div className="form-group">
                  <label>{p('company.return_fee')} (ر.س)</label>
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    value={settings.taxes?.returnCost || 0}
                    onChange={(e) => updateSettings('taxes', 'returnCost', parseFloat(e.target.value) || 0)}
                  />
                  <small>{p('billing.fees.return_fee_hint')}</small>
                </div>

                <div className="form-group">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={settings.taxes?.returnCostByDefault || false}
                      onChange={(e) => updateSettings('taxes', 'returnCostByDefault', e.target.checked)}
                    />
                    {p('billing.fees.return_default')}
                  </label>
                  <small>{p('billing.fees.return_auto_hint')}</small>
                </div>

                <div className="form-group">
                  <label>{p('company.transport_fee')} (ر.س)</label>
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    value={settings.taxes?.transportCost || 0}
                    onChange={(e) => updateSettings('taxes', 'transportCost', parseFloat(e.target.value) || 0)}
                  />
                  <small>{p('billing.fees.transport_hint')}</small>
                </div>

                <div className="form-group">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={settings.taxes?.transportCostByDefault || false}
                      onChange={(e) => updateSettings('taxes', 'transportCostByDefault', e.target.checked)}
                    />
                    {p('billing.fees.transport_default')}
                  </label>
                  <small>{p('billing.fees.transport_auto_hint')}</small>
                </div>
              </div>
              
              {/* Document Prefixes Section */}
              <div className="space-y-6 mt-8">
                <h2 className="text-xl font-bold text-white pb-2 border-b border-white/20">{p('billing.document_prefixes.title')}</h2>
                <p className="text-white/60 mb-4">{p('billing.document_prefixes.subtitle')}</p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="form-group">
                    <label className="form-label">{p('billing.document_prefixes.invoice')}</label>
                    <input 
                      type="text"
                      className="form-input"
                      value={settings.configuration?.documentPrefixes?.invoice ?? ""}
                      onChange={(e) => {
                        const prefixes = {...(settings.configuration?.documentPrefixes || {})};
                        prefixes.invoice = e.target.value.toUpperCase();
                        updateSettings('configuration', 'documentPrefixes', prefixes);
                        setUnsavedChanges(true);
                      }}
                      maxLength="5"
                      style={{textTransform: 'uppercase'}}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">{p('billing.document_prefixes.proforma')}</label>
                    <input 
                      type="text"
                      className="form-input"
                      value={settings.configuration?.documentPrefixes?.proforma ?? ""}
                      onChange={(e) => {
                        const prefixes = {...(settings.configuration?.documentPrefixes || {})};
                        prefixes.proforma = e.target.value.toUpperCase();
                        updateSettings('configuration', 'documentPrefixes', prefixes);
                        setUnsavedChanges(true);
                      }}
                      maxLength="5"
                      style={{textTransform: 'uppercase'}}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">{p('billing.document_prefixes.quote')}</label>
                    <input 
                      type="text"
                      className="form-input"
                      value={settings.configuration?.documentPrefixes?.quote ?? ""}
                      onChange={(e) => {
                        const prefixes = {...(settings.configuration?.documentPrefixes || {})};
                        prefixes.quote = e.target.value.toUpperCase();
                        updateSettings('configuration', 'documentPrefixes', prefixes);
                        setUnsavedChanges(true);
                      }}
                      maxLength="5"
                      style={{textTransform: 'uppercase'}}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">{p('billing.document_prefixes.order')}</label>
                    <input 
                      type="text"
                      className="form-input"
                      value={settings.configuration?.documentPrefixes?.order ?? ""}
                      onChange={(e) => {
                        const prefixes = {...(settings.configuration?.documentPrefixes || {})};
                        prefixes.order = e.target.value.toUpperCase();
                        updateSettings('configuration', 'documentPrefixes', prefixes);
                        setUnsavedChanges(true);
                      }}
                      maxLength="5"
                      style={{textTransform: 'uppercase'}}
                    />
                  </div>



                  <div className="form-group">
                    <label className="form-label">{p('billing.document_prefixes.delivery')}</label>
                    <input 
                      type="text"
                      className="form-input"
                      value={settings.configuration?.documentPrefixes?.delivery ?? ""}
                      onChange={(e) => {
                        const prefixes = {...(settings.configuration?.documentPrefixes || {})};
                        prefixes.delivery = e.target.value.toUpperCase();
                        updateSettings('configuration', 'documentPrefixes', prefixes);
                        setUnsavedChanges(true);
                      }}
                      maxLength="5"
                      style={{textTransform: 'uppercase'}}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">{p('billing.document_prefixes.reception')}</label>
                    <input 
                      type="text"
                      className="form-input"
                      value={settings.configuration?.documentPrefixes?.reception ?? ""}
                      onChange={(e) => {
                        const prefixes = {...(settings.configuration?.documentPrefixes || {})};
                        prefixes.reception = e.target.value.toUpperCase();
                        updateSettings('configuration', 'documentPrefixes', prefixes);
                        setUnsavedChanges(true);
                      }}
                      maxLength="5"
                      style={{textTransform: 'uppercase'}}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">{p('billing.document_prefixes.return')}</label>
                    <input 
                      type="text"
                      className="form-input"
                      value={settings.configuration?.documentPrefixes?.return ?? ""}
                      onChange={(e) => {
                        const prefixes = {...(settings.configuration?.documentPrefixes || {})};
                        prefixes.return = e.target.value.toUpperCase();
                        updateSettings('configuration', 'documentPrefixes', prefixes);
                        setUnsavedChanges(true);
                      }}
                      maxLength="5"
                      style={{textTransform: 'uppercase'}}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">{p('billing.document_prefixes.send_slip')}</label>
                    <input 
                      type="text"
                      className="form-input"
                      value={settings.configuration?.documentPrefixes?.sendSlip ?? ""}
                      onChange={(e) => {
                        const prefixes = {...(settings.configuration?.documentPrefixes || {})};
                        prefixes.sendSlip = e.target.value.toUpperCase();
                        updateSettings('configuration', 'documentPrefixes', prefixes);
                        setUnsavedChanges(true);
                      }}
                      maxLength="5"
                      style={{textTransform: 'uppercase'}}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">{p('billing.document_prefixes.quote_request')}</label>
                    <input 
                      type="text"
                      className="form-input"
                      value={settings.configuration?.documentPrefixes?.quoteRequest ?? ""}
                      onChange={(e) => {
                        const prefixes = {...(settings.configuration?.documentPrefixes || {})};
                        prefixes.quoteRequest = e.target.value.toUpperCase();
                        updateSettings('configuration', 'documentPrefixes', prefixes);
                        setUnsavedChanges(true);
                      }}
                      maxLength="5"
                      style={{textTransform: 'uppercase'}}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">{p('billing.document_prefixes.proforma_request')}</label>
                    <input 
                      type="text"
                      className="form-input"
                      value={settings.configuration?.documentPrefixes?.proformaRequest ?? ""}
                      onChange={(e) => {
                        const prefixes = {...(settings.configuration?.documentPrefixes || {})};
                        prefixes.proformaRequest = e.target.value.toUpperCase();
                        updateSettings('configuration', 'documentPrefixes', prefixes);
                        setUnsavedChanges(true);
                      }}
                      maxLength="5"
                      style={{textTransform: 'uppercase'}}
                      placeholder="DPR"
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">{p('billing.document_prefixes.shipping')}</label>
                    <input 
                      type="text"
                      className="form-input"
                      value={settings.configuration?.documentPrefixes?.shipping ?? ""}
                      onChange={(e) => {
                        const prefixes = {...(settings.configuration?.documentPrefixes || {})};
                        prefixes.shipping = e.target.value.toUpperCase();
                        updateSettings('configuration', 'documentPrefixes', prefixes);
                        setUnsavedChanges(true);
                      }}
                      maxLength="5"
                      style={{textTransform: 'uppercase'}}
                      placeholder="BE"
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">{p('billing.document_prefixes.customer_return_slip')}</label>
                    <input 
                      type="text"
                      className="form-input"
                      value={settings.configuration?.documentPrefixes?.customerReturnSlip ?? ""}
                      onChange={(e) => {
                        const prefixes = {...(settings.configuration?.documentPrefixes || {})};
                        prefixes.customerReturnSlip = e.target.value.toUpperCase();
                        updateSettings('configuration', 'documentPrefixes', prefixes);
                        setUnsavedChanges(true);
                      }}
                      maxLength="5"
                      style={{textTransform: 'uppercase'}}
                      placeholder="BRC"
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">{p('billing.document_prefixes.payment_slip')}</label>
                    <input 
                      type="text"
                      className="form-input"
                      value={settings.configuration?.documentPrefixes?.paymentSlip ?? ""}
                      onChange={(e) => {
                        const prefixes = {...(settings.configuration?.documentPrefixes || {})};
                        prefixes.paymentSlip = e.target.value.toUpperCase();
                        updateSettings('configuration', 'documentPrefixes', prefixes);
                        setUnsavedChanges(true);
                      }}
                      maxLength="5"
                      style={{textTransform: 'uppercase'}}
                      placeholder="BV"
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">{p('billing.document_prefixes.payment_receipt')}</label>
                    <input 
                      type="text"
                      className="form-input"
                      value={settings.configuration?.documentPrefixes?.paymentReceipt ?? ""}
                      onChange={(e) => {
                        const prefixes = {...(settings.configuration?.documentPrefixes || {})};
                        prefixes.paymentReceipt = e.target.value.toUpperCase();
                        updateSettings('configuration', 'documentPrefixes', prefixes);
                        setUnsavedChanges(true);
                      }}
                      maxLength="5"
                      style={{textTransform: 'uppercase'}}
                      placeholder="RP"
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">{p('billing.document_prefixes.exit_slip')}</label>
                    <input 
                      type="text"
                      className="form-input"
                      value={settings.configuration?.documentPrefixes?.exitSlip ?? ""}
                      onChange={(e) => {
                        const prefixes = {...(settings.configuration?.documentPrefixes || {})};
                        prefixes.exitSlip = e.target.value.toUpperCase();
                        updateSettings('configuration', 'documentPrefixes', prefixes);
                        setUnsavedChanges(true);
                      }}
                      maxLength="5"
                      style={{textTransform: 'uppercase'}}
                      placeholder="BS"
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">{p('billing.document_prefixes.transfer_slip')}</label>
                    <input 
                      type="text"
                      className="form-input"
                      value={settings.configuration?.documentPrefixes?.transferSlip ?? ""}
                      onChange={(e) => {
                        const prefixes = {...(settings.configuration?.documentPrefixes || {})};
                        prefixes.transferSlip = e.target.value.toUpperCase();
                        updateSettings('configuration', 'documentPrefixes', prefixes);
                        setUnsavedChanges(true);
                      }}
                      maxLength="5"
                      style={{textTransform: 'uppercase'}}
                      placeholder="BT"
                    />
                  </div>
                </div>
              </div>

              {/* Entity reference prefixes (رمز) */}
              <div className="space-y-6 mt-8">
                <h2 className="text-xl font-bold text-white pb-2 border-b border-white/20">{p('billing.entity_prefixes.title')}</h2>
                <p className="text-white/60 mb-4">{p('billing.entity_prefixes.subtitle')}</p>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {Object.entries(settings.configuration?.entityPrefixes || {}).sort(([a], [b]) => a.localeCompare(b)).map(([key, value]) => (
                    <div key={key} className="form-group">
                      <label className="form-label">{p(`billing.entity_prefixes.${key}`, { defaultValue: key })}</label>
                      <input
                        type="text"
                        className="form-input"
                        value={value ?? ''}
                        onChange={(e) => {
                          const prefixes = { ...(settings.configuration?.entityPrefixes || {}) };
                          prefixes[key] = e.target.value.toUpperCase();
                          updateSettings('configuration', 'entityPrefixes', prefixes);
                          setUnsavedChanges(true);
                        }}
                        maxLength="8"
                        style={{ textTransform: 'uppercase' }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            <div className="space-y-6 mt-8" style={{display:'none'}}>







                <div className="numbering-category">
                  <h4 className="category-title">{p('billing.extended_document_prefixes.cat_real_estate')}</h4>
                  <div className="numbering-grid-prefix">
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_rental_contract')}</label>
                      <input type="text" value={settings.invoicing.rentalContractPrefix || 'CL'} onChange={(e) => updateSettings('invoicing', 'rentalContractPrefix', e.target.value)} placeholder="CL" />
                    </div>
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_property_inspection')}</label>
                      <input type="text" value={settings.invoicing.propertyInspectionPrefix || 'EDL'} onChange={(e) => updateSettings('invoicing', 'propertyInspectionPrefix', e.target.value)} placeholder="EDL" />
                    </div>
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_rent_receipt')}</label>
                      <input type="text" value={settings.invoicing.rentReceiptPrefix || 'QL'} onChange={(e) => updateSettings('invoicing', 'rentReceiptPrefix', e.target.value)} placeholder="QL" />
                    </div>
                  </div>
                </div>

                {/* SÉCURITÉ & ASSURANCE */}
                <div className="numbering-category">
                  <h4 className="category-title">{p('billing.extended_document_prefixes.cat_security')}</h4>
                  <div className="numbering-grid-prefix">
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_accident_report')}</label>
                      <input type="text" value={settings.invoicing.accidentReportPrefix || 'DA'} onChange={(e) => updateSettings('invoicing', 'accidentReportPrefix', e.target.value)} placeholder="DA" />
                    </div>
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_security_report')}</label>
                      <input type="text" value={settings.invoicing.securityReportPrefix || 'RS'} onChange={(e) => updateSettings('invoicing', 'securityReportPrefix', e.target.value)} placeholder="RS" />
                    </div>
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_safety_compliance')}</label>
                      <input type="text" value={settings.invoicing.safetyCompliancePrefix || 'FCS'} onChange={(e) => updateSettings('invoicing', 'safetyCompliancePrefix', e.target.value)} placeholder="FCS" />
                    </div>
                  </div>
                </div>

                {/* SERVICES & MAINTENANCE */}
                <div className="numbering-category">
                  <h4 className="category-title">{p('billing.extended_document_prefixes.cat_services')}</h4>
                  <div className="numbering-grid-prefix">
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_maintenance_report')}</label>
                      <input type="text" value={settings.invoicing.maintenanceReportPrefix || 'RM'} onChange={(e) => updateSettings('invoicing', 'maintenanceReportPrefix', e.target.value)} placeholder="RM" />
                    </div>
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_maintenance_plan')}</label>
                      <input type="text" value={settings.invoicing.maintenancePlanPrefix || 'PM'} onChange={(e) => updateSettings('invoicing', 'maintenancePlanPrefix', e.target.value)} placeholder="PM" />
                    </div>
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_client_intervention')}</label>
                      <input type="text" value={settings.invoicing.clientInterventionPrefix || 'FIC'} onChange={(e) => updateSettings('invoicing', 'clientInterventionPrefix', e.target.value)} placeholder="FIC" />
                    </div>
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_warranty')}</label>
                      <input type="text" value={settings.invoicing.warrantyPrefix || 'GAR'} onChange={(e) => updateSettings('invoicing', 'warrantyPrefix', e.target.value)} placeholder="GAR" />
                    </div>
                  </div>
                </div>

                {/* INFORMATIQUE & TÉLÉCOMS */}
                <div className="numbering-category">
                  <h4 className="category-title">{p('billing.extended_document_prefixes.cat_it')}</h4>
                  <div className="numbering-grid-prefix">
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_it_audit')}</label>
                      <input type="text" value={settings.invoicing.itAuditPrefix || 'RAI'} onChange={(e) => updateSettings('invoicing', 'itAuditPrefix', e.target.value)} placeholder="RAI" />
                    </div>
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_software_install')}</label>
                      <input type="text" value={settings.invoicing.softwareInstallPrefix || 'FIL'} onChange={(e) => updateSettings('invoicing', 'softwareInstallPrefix', e.target.value)} placeholder="FIL" />
                    </div>
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_it_maintenance')}</label>
                      <input type="text" value={settings.invoicing.itMaintenancePrefix || 'CMIT'} onChange={(e) => updateSettings('invoicing', 'itMaintenancePrefix', e.target.value)} placeholder="CMIT" />
                    </div>
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_backup')}</label>
                      <input type="text" value={settings.invoicing.backupPrefix || 'BAK'} onChange={(e) => updateSettings('invoicing', 'backupPrefix', e.target.value)} placeholder="BAK" />
                    </div>
                  </div>
                </div>

                {/* ACHATS & APPROVISIONNEMENT */}
                <div className="numbering-category">
                  <h4 className="category-title">{p('billing.extended_document_prefixes.cat_purchasing')}</h4>
                  <div className="numbering-grid-prefix">
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_purchase_request')}</label>
                      <input type="text" value={settings.invoicing.purchaseRequestPrefix || 'DA'} onChange={(e) => updateSettings('invoicing', 'purchaseRequestPrefix', e.target.value)} placeholder="DA" />
                    </div>
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_tender')}</label>
                      <input type="text" value={settings.invoicing.tenderPrefix || 'AO'} onChange={(e) => updateSettings('invoicing', 'tenderPrefix', e.target.value)} placeholder="AO" />
                    </div>
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_supplier_comparison')}</label>
                      <input type="text" value={settings.invoicing.supplierComparisonPrefix || 'CF'} onChange={(e) => updateSettings('invoicing', 'supplierComparisonPrefix', e.target.value)} placeholder="CF" />
                    </div>
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_goods_receipt')}</label>
                      <input type="text" value={settings.invoicing.goodsReceiptPrefix || 'RM'} onChange={(e) => updateSettings('invoicing', 'goodsReceiptPrefix', e.target.value)} placeholder="RM" />
                    </div>
                  </div>
                </div>

                {/* FORMATION & DÉVELOPPEMENT */}
                <div className="numbering-category">
                  <h4 className="category-title">{p('billing.extended_document_prefixes.cat_training')}</h4>
                  <div className="numbering-grid-prefix">
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_training_plan')}</label>
                      <input type="text" value={settings.invoicing.trainingPlanPrefix || 'PF'} onChange={(e) => updateSettings('invoicing', 'trainingPlanPrefix', e.target.value)} placeholder="PF" />
                    </div>
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_training_eval')}</label>
                      <input type="text" value={settings.invoicing.trainingEvalPrefix || 'EF'} onChange={(e) => updateSettings('invoicing', 'trainingEvalPrefix', e.target.value)} placeholder="EF" />
                    </div>
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_training_cert')}</label>
                      <input type="text" value={settings.invoicing.trainingCertPrefix || 'CF'} onChange={(e) => updateSettings('invoicing', 'trainingCertPrefix', e.target.value)} placeholder="CF" />
                    </div>
                  </div>
                </div>

                {/* COMMERCE & VENTE */}
                <div className="numbering-category">
                  <h4 className="category-title">{p('billing.extended_document_prefixes.cat_sales')}</h4>
                  <div className="numbering-grid-prefix">
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_prospect_sheet')}</label>
                      <input type="text" value={settings.invoicing.prospectSheetPrefix || 'FP'} onChange={(e) => updateSettings('invoicing', 'prospectSheetPrefix', e.target.value)} placeholder="FP" />
                    </div>
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_client_visit')}</label>
                      <input type="text" value={settings.invoicing.clientVisitPrefix || 'RVC'} onChange={(e) => updateSettings('invoicing', 'clientVisitPrefix', e.target.value)} placeholder="RVC" />
                    </div>
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_catalog')}</label>
                      <input type="text" value={settings.invoicing.catalogPrefix || 'CAT'} onChange={(e) => updateSettings('invoicing', 'catalogPrefix', e.target.value)} placeholder="CAT" />
                    </div>
                  </div>
                </div>

                {/* ÉQUIPEMENTS & MATÉRIEL */}
                <div className="numbering-category">
                  <h4 className="category-title">{p('billing.extended_document_prefixes.cat_equipment')}</h4>
                  <div className="numbering-grid-prefix">
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_equipment_sheet')}</label>
                      <input type="text" value={settings.invoicing.equipmentSheetPrefix || 'FE'} onChange={(e) => updateSettings('invoicing', 'equipmentSheetPrefix', e.target.value)} placeholder="FE" />
                    </div>
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_calibration')}</label>
                      <input type="text" value={settings.invoicing.calibrationPrefix || 'CAL'} onChange={(e) => updateSettings('invoicing', 'calibrationPrefix', e.target.value)} placeholder="CAL" />
                    </div>
                    <div className="numbering-item-prefix">
                      <label>{p('billing.extended_document_prefixes.label_material_loan')}</label>
                      <input type="text" value={settings.invoicing.materialLoanPrefix || 'PM'} onChange={(e) => updateSettings('invoicing', 'materialLoanPrefix', e.target.value)} placeholder="PM" />
                    </div>
                  </div>
                </div>



              </div>
              </div>
              )}
              
              {/* Configuration des clients Tab */}
              {facturationTab === 'clients' && (
              <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-6 border border-white/20">
                <h3 className="text-xl font-bold text-white pb-2 border-b border-white/20 mb-6">{p('billing.clients_title')}</h3>
              
              <div className="tax-info">
                <p>{p('billing.clients.discount_intro')}</p>
              </div>

              <div className="form-grid">
                <div className="form-group">
                  <label>{p('billing.clients.company_rate')}</label>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="0.01"
                    value={settings.configuration?.clientDiscounts?.company || 0}
                    onChange={(e) => updateSettings('configuration', 'clientDiscounts', {
                      ...settings.configuration?.clientDiscounts,
                      company: parseFloat(e.target.value)
                    })}
                  />
                  <small>{p('billing.clients.company_rate_hint')}</small>
                </div>

                <div className="form-group">
                  <label>{p('billing.clients.individual_rate')}</label>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="0.01"
                    value={settings.configuration?.clientDiscounts?.individual || 0}
                    onChange={(e) => updateSettings('configuration', 'clientDiscounts', {
                      ...settings.configuration?.clientDiscounts,
                      individual: parseFloat(e.target.value)
                    })}
                  />
                  <small>{p('billing.clients.individual_rate_hint')}</small>
                </div>

                <div className="form-group">
                  <label>{p('billing.clients.institution_rate')}</label>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="0.01"
                    value={settings.configuration?.clientDiscounts?.institution || 0}
                    onChange={(e) => updateSettings('configuration', 'clientDiscounts', {
                      ...settings.configuration?.clientDiscounts,
                      institution: parseFloat(e.target.value)
                    })}
                  />
                  <small>{p('billing.clients.institution_rate_hint')}</small>
                </div>
              </div>
              </div>
              )}

              {/* Notifications Tab */}
              {facturationTab === 'notifications' && (
              <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-6 border border-white/20">
                <h3 className="text-xl font-bold text-white pb-2 border-b border-white/20 mb-6">{p('billing.notifications.title')}</h3>
              
              <div className="tax-info">
                <p>{p('billing.notifications.configure_desc')}</p>
              </div>

              <div className="form-grid">
                <div className="form-group full-width">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={settings.notifications?.emailNotifications || false}
                      onChange={(e) => updateSettings('notifications', 'emailNotifications', e.target.checked)}
                    />
                    {p('billing.notifications.email_notifications')}
                  </label>
                  <small>{p('billing.notifications.email_help')}</small>
                </div>

                <div className="form-group full-width">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={settings.notifications?.smsNotifications || false}
                      onChange={(e) => updateSettings('notifications', 'smsNotifications', e.target.checked)}
                    />
                    {p('billing.notifications.sms_notifications')}
                  </label>
                  <small>{p('billing.notifications.sms_help')}</small>
                </div>

                <div className="form-group full-width">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={settings.notifications?.pushNotifications || false}
                      onChange={(e) => updateSettings('notifications', 'pushNotifications', e.target.checked)}
                    />
                    {p('billing.notifications.push_notifications')}
                  </label>
                  <small>{p('billing.notifications.push_help')}</small>
                </div>

                <div className="form-group full-width">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={settings.notifications?.invoiceReminders !== false}
                      onChange={(e) => updateSettings('notifications', 'invoiceReminders', e.target.checked)}
                    />
                    {p('billing.notifications.invoice_reminders')}
                  </label>
                  <small>{p('billing.notifications.invoice_reminders_help')}</small>
                </div>

                <div className="form-group full-width">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={settings.notifications?.paymentAlerts !== false}
                      onChange={(e) => updateSettings('notifications', 'paymentAlerts', e.target.checked)}
                    />
                    {p('billing.notifications.payment_alerts')}
                  </label>
                  <small>{p('billing.notifications.payment_alerts_help')}</small>
                </div>

                <div className="form-group full-width">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={settings.notifications?.lowStockAlerts || false}
                      onChange={(e) => updateSettings('notifications', 'lowStockAlerts', e.target.checked)}
                    />
                    {p('billing.notifications.low_stock_alerts')}
                  </label>
                  <small>{p('billing.notifications.low_stock_help')}</small>
                </div>
              </div>
              </div>
              )}
            </div>
          )}
          
          {/* Utilisateurs Tab - Admin User Management Only */}
          {activeTab === 'utilisateurs' && (
            <>
              {isSuperAdminUser ? (
              <div className={`space-y-3 employees-container mb-10`}>
                <div className="flex justify-between items-center flex-wrap gap-4">
                  <div>
                    <h1 className="text-3xl font-bold text-white flex items-center gap-3">
                      <UserCheck className="h-8 w-8 text-blue-400" />
                  {p('users.title')}
                      <button type="button" onClick={() => permissions.loadPermissionsData && permissions.loadPermissionsData()} className="refresh-button" aria-label={t('common.refresh')} title={t('common.refresh')}><RefreshCw size={20} /></button>
                    </h1>
                    <p className="text-white/60 mt-2">{p('users.subtitle')}</p>
                  </div>
                  <div className="flex gap-3 flex-wrap">
                    <button type="button" className="bg-gradient-to-r from-blue-500 to-blue-700 text-white px-6 py-3 rounded-xl font-semibold hover:from-blue-600 hover:to-blue-800 transition-all duration-300 flex items-center space-x-2 shadow-lg shadow-blue-500/30" onClick={openAddUserModal}>
                      <Plus className="h-5 w-5" /><span>{t('settings.user_management.add_user')}</span>
                </button>
                  </div>
              </div>
              
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-6">
                  {[
                    { title: p('users.stat_total'), value: umStats.total, icon: Users, color: 'from-blue-500 to-blue-600' },
                    { title: p('users.stat_active'), value: umStats.active, icon: CheckCircle, color: 'from-green-500 to-green-600' },
                    { title: p('users.stat_inactive'), value: umStats.inactive, icon: XCircle, color: 'from-gray-500 to-gray-600' },
                    { title: p('users.stat_super_admins'), value: umStats.superC, icon: Shield, color: 'from-purple-500 to-purple-600' },
                    { title: p('users.stat_avg_sections'), value: umStats.avgSec, icon: TrendingUp, color: 'from-orange-500 to-orange-600' }
                  ].map((stat, i) => (
                    <motion.div key={i} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.1 }} className="relative group">
                      <div className={`absolute -inset-0.5 bg-gradient-to-r ${stat.color} rounded-3xl opacity-0 group-hover:opacity-50 transition-opacity duration-500 blur-sm`}></div>
                      <div className="relative bg-white/10 backdrop-blur-lg rounded-3xl p-6 border border-white/20">
                        <div className="flex items-center justify-between">
                          <div><p className="text-white/60 text-sm font-medium">{stat.title}</p><p className="text-2xl font-bold text-white force-white mt-2">{stat.value}</p></div>
                          <div className="relative">
                            <div className={`absolute inset-0 bg-gradient-to-br ${stat.color} rounded-2xl opacity-0 group-hover:opacity-20 transition-opacity duration-300 blur-lg`}></div>
                            <div className={`relative p-3 rounded-2xl bg-gradient-to-r ${stat.color}`}><stat.icon className="h-6 w-6 text-white force-white" /></div>
                          </div>
                        </div>
                      </div>
                </motion.div>
                  ))}
                </div>

                <motion.div initial={false} animate={{ height: umShowAdvancedOptions ? 'auto' : 0, opacity: umShowAdvancedOptions ? 1 : 0 }} transition={{ duration: 0.3, ease: 'easeInOut' }} style={{ overflow: 'hidden' }}>
                  <div className="space-y-4 pt-4">
                    <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-2 border border-white/20">
                      <div className="flex space-x-1 overflow-x-auto table-scroll">
                        {[
                          { id: 'all_users', name: p('users.view_general'), icon: LayoutGrid },
                          { id: 'par_role', name: p('users.view_by_role'), icon: Shield },
                          { id: 'par_statut', name: p('users.view_by_status'), icon: CheckCircle },
                          { id: 'par_acces', name: p('users.view_by_access'), icon: Layers }
                        ].map((tab) => (
                          <button key={tab.id} type="button" onClick={() => { setUmMainViewMode(tab.id); setUmQuickFilter('all'); setUmActiveDistributionFilter(null); }} className={`flex-1 flex items-center justify-center space-x-2 px-4 py-3 rounded-2xl font-medium transition-all duration-300 ${umMainViewMode === tab.id ? 'bg-gradient-to-r from-blue-500 to-blue-700 text-white shadow-lg shadow-blue-500/30' : 'text-white/80 hover:bg-white/10 hover:text-white'}`}>
                            <tab.icon className="h-5 w-5" /><span className="hidden sm:inline whitespace-nowrap">{tab.name}</span>
                          </button>
                        ))}
                  </div>
                </div>
                    {umMainViewMode === 'all_users' && (
                      <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-2 border border-white/20">
                        <div className="flex space-x-1 overflow-x-auto table-scroll">
                          {[
                            { id: 'all', name: p('audit.filters.all'), icon: Layers },
                            { id: 'active', name: p('users.filter_active'), icon: CheckCircle },
                            { id: 'inactive', name: p('users.filter_inactive'), icon: XCircle },
                            { id: 'super_admins', name: p('users.filter_admin'), icon: Shield }
                          ].map((filterBtn) => (
                            <button key={filterBtn.id} type="button" onClick={() => setUmQuickFilter(filterBtn.id)} className={`flex-1 flex items-center justify-center space-x-2 px-4 py-3 rounded-2xl font-medium transition-all duration-300 ${umQuickFilter === filterBtn.id ? 'bg-gradient-to-r from-blue-500 to-blue-700 text-white shadow-lg shadow-blue-500/30' : 'text-white/80 hover:bg-white/10 hover:text-white'}`}>
                              <filterBtn.icon className="h-5 w-5" /><span className="hidden sm:inline whitespace-nowrap">{filterBtn.name}</span>
                            </button>
                          ))}
                        </div>
                      </div>
                    )}

                    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="bg-white/10 backdrop-blur-lg rounded-3xl p-6 border border-white/20">
                      <div className="flex items-center justify-between mb-4">
                        <h3 className="text-xl font-semibold text-white">{umDistributionInfo.title}</h3>
                        {umActiveDistributionFilter && (
                          <button type="button" onClick={() => setUmActiveDistributionFilter(null)} className="text-xs text-white/60 hover:text-white bg-white/5 hover:bg-white/10 px-3 py-1.5 rounded-lg transition-all flex items-center gap-1">
                            <XCircle size={14} />{p('common.reset_filter')}
                          </button>
                        )}
                    </div>
                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
                        {umDistributionInfo.data.map((item) => (
                          <button type="button" key={item.name} onClick={() => setUmActiveDistributionFilter(umActiveDistributionFilter === item.name ? null : item.name)} className={`bg-white/5 rounded-xl p-4 border transition-all cursor-pointer text-left ${umActiveDistributionFilter === item.name ? 'border-blue-400/60 bg-blue-500/20 shadow-lg shadow-blue-500/20' : 'border-white/10 hover:border-white/20 hover:bg-white/10'}`}>
                            <div className="flex justify-between items-center mb-2">
                              <h4 className={`font-medium ${umActiveDistributionFilter === item.name ? 'text-white' : 'text-white/80'}`}>{item.name}</h4>
                              <div className={`text-sm rounded-full px-2 py-0.5 ${item.color} text-white force-white font-semibold`}>{item.count}</div>
                  </div>
                            <div className="w-full bg-white/10 h-3 rounded-full overflow-hidden">
                              <div className={`h-3 rounded-full ${item.color} transition-all`} style={{ width: `${(() => {
                                const total = umDistributionInfo.data.reduce((sum, d) => sum + d.count, 0);
                                return total > 0 ? (item.count / total * 100).toFixed(1) : 0;
                              })()}%` }}></div>
                    </div>
                            <p className={`mt-2 text-sm ${umActiveDistributionFilter === item.name ? 'text-white/80' : 'text-white/60'}`}>{(() => {
                              const total = umDistributionInfo.data.reduce((sum, d) => sum + d.count, 0);
                              return total > 0 ? (item.count / total * 100).toFixed(1) : 0;
                            })()}% du total</p>
                          </button>
                        ))}
                    </div>
                    </motion.div>
                  </div>
              </motion.div>
              
                <div className="bg-white/10 backdrop-blur-lg rounded-3xl border border-white/20 overflow-hidden">
                  <div className="p-4 border-b border-white/10">
                    <div className="flex flex-col lg:flex-row gap-4 items-center justify-between">
                      <div className="relative flex-1 max-w-md w-full">
                        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-white/50" />
                        <input type="text" placeholder={p('common.search')} value={umSearchTerm} onChange={(e) => setUmSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 bg-white/10 border border-white/20 rounded-xl text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-blue-500" />
                          </div>
                      <div className="flex items-center gap-2 flex-wrap ml-auto">
                        <div className="flex items-center gap-0">
                          <button type="button" onClick={() => setUmViewMode('cards')} className={`px-3 py-2 border border-white/20 transition-all ${umViewMode === 'cards' ? 'bg-blue-500/20 text-blue-300 border-blue-500/30' : 'bg-white/5 text-white hover:text-white/90 hover:border-white/30'} rounded-l-lg border-r-0`}>
                            <LayoutList size={18} />
                          </button>
                          <button type="button" onClick={() => setUmViewMode('table')} className={`px-3 py-2 border border-white/20 transition-all ${umViewMode === 'table' ? 'bg-blue-500/20 text-blue-300 border-blue-500/30' : 'bg-white/5 text-white hover:text-white/90 hover:border-white/30'} rounded-r-lg`}>
                            <List size={18} />
                          </button>
                          </div>

                        <div className="relative" ref={umStatusFilterRef}>
                          <button type="button" onClick={() => setUmIsStatusFilterOpen(!umIsStatusFilterOpen)} className="flex items-center gap-2 px-4 py-2 border border-white/20 rounded-lg text-white hover:border-white/30 transition-all bg-white/5">
                            <Filter size={18} className="text-white/80" />
                            <span className="text-white font-medium text-sm">{umStatusFilter === 'all' ? p('audit_tab.col_status') : umStatusFilter === 'active' ? p('users_extra.active_label') : p('users_extra.inactive_label')}</span>
                            <ChevronDown size={14} className={`text-white/70 transition-transform ${umIsStatusFilterOpen ? 'rotate-180' : ''}`} />
                          </button>
                          {umIsStatusFilterOpen && (
                            <div className="border border-blue-400/60 rounded-2xl shadow-2xl min-w-[200px]" style={{ position: 'absolute', top: 'calc(100% + 8px)', right: 0, zIndex: 99999, backgroundImage: 'linear-gradient(to bottom right, rgb(51, 65, 85), rgb(29, 71, 196), rgb(51, 65, 85))', boxShadow: '0 8px 32px rgba(59, 130, 246, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.2)' }}>
                              <div className="p-2">
                                <button type="button" onClick={() => { setUmStatusFilter('all'); setUmIsStatusFilterOpen(false); }} className={`w-full px-4 py-2.5 text-left transition-colors flex items-center gap-3 rounded-xl ${umStatusFilter === 'all' ? 'bg-blue-500/20 text-white' : 'text-white/90 hover:bg-blue-500/20'}`}>
                                  <Filter size={16} className="text-white/50" /><span className="text-sm font-medium">{p('users.all_statuses')}</span>
                                </button>
                                <button type="button" onClick={() => { setUmStatusFilter('active'); setUmIsStatusFilterOpen(false); }} className={`w-full px-4 py-2.5 text-left transition-colors flex items-center gap-3 rounded-xl ${umStatusFilter === 'active' ? 'bg-blue-500/20 text-white' : 'text-white/90 hover:bg-blue-500/20'}`}>
                                  <CheckCircle size={16} className="text-green-400" /><span className="text-sm font-medium">{p('users_extra.active_label')}</span>
                                </button>
                                <button type="button" onClick={() => { setUmStatusFilter('inactive'); setUmIsStatusFilterOpen(false); }} className={`w-full px-4 py-2.5 text-left transition-colors flex items-center gap-3 rounded-xl ${umStatusFilter === 'inactive' ? 'bg-blue-500/20 text-white' : 'text-white/90 hover:bg-blue-500/20'}`}>
                                  <XCircle size={16} className="text-gray-400" /><span className="text-sm font-medium">{p('users_extra.inactive_label')}</span>
                                </button>
                        </div>
                            </div>
                          )}
                      </div>

                        <div className="relative" ref={umDateRangeRef}>
                          <button type="button" onClick={() => { setUmIsDateRangeOpen(!umIsDateRangeOpen); setUmShowImportDropdown(false); setUmShowExportDropdown(false); }} className="flex items-center gap-2 px-4 py-2 border border-white/20 rounded-lg text-white hover:border-white/30 transition-all bg-white/5">
                            <Calendar size={18} className="text-white/80" /><span className="text-white font-medium text-sm">{p('audit_tab.filter_period')}</span><ChevronDown size={14} className={`text-white/70 transition-transform ${umIsDateRangeOpen ? 'rotate-180' : ''}`} />
                          </button>
                          {umIsDateRangeOpen && (
                            <div className="border border-blue-400/60 rounded-2xl shadow-2xl min-w-[320px]" style={{ position: 'absolute', top: 'calc(100% + 8px)', right: 0, zIndex: 99999, backgroundImage: 'linear-gradient(to bottom right, rgb(51, 65, 85), rgb(29, 71, 196), rgb(51, 65, 85))', boxShadow: '0 8px 32px rgba(59, 130, 246, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.2)', overflow: 'visible' }}>
                              <div className="p-4" style={{ overflow: 'visible' }}>
                                <p className="text-white/50 text-xs mb-3">{p('audit_tab.account_creation_filter')}</p>
                                <div className="flex flex-col gap-3" style={{ overflow: 'visible' }}>
                                  <div className="grid grid-cols-2 gap-3" style={{ overflow: 'visible' }}>
                                    <div style={{ overflow: 'visible' }}>
                                      <label className="text-white/80 text-xs mb-1.5 block w-full font-medium text-right">{p('audit_tab.start_date')}</label>
                                      <DatePicker selected={umDateRange.start} onChange={(date) => setUmDateRange({ ...umDateRange, start: date })} dateFormat="dd/MM/yyyy" placeholderText={p('common.select')} locale={datePickerLocale} className="w-full px-3 py-2 bg-white/10 border border-blue-400/30 rounded-xl text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-400/50 focus:border-blue-400/60 backdrop-blur-sm gps-datepicker" calendarClassName="gps-calendar" wrapperClassName="w-full" popperProps={{ strategy: 'fixed' }} />
                        </div>
                                    <div style={{ overflow: 'visible' }}>
                                      <label className="text-white/80 text-xs mb-1.5 block w-full font-medium text-right">{p('audit_tab.end_date')}</label>
                                      <DatePicker selected={umDateRange.end} onChange={(date) => setUmDateRange({ ...umDateRange, end: date })} dateFormat="dd/MM/yyyy" placeholderText={p('common.select')} minDate={umDateRange.start} locale={datePickerLocale} className="w-full px-3 py-2 bg-white/10 border border-blue-400/30 rounded-xl text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-400/50 focus:border-blue-400/60 backdrop-blur-sm gps-datepicker" calendarClassName="gps-calendar" wrapperClassName="w-full" popperProps={{ strategy: 'fixed' }} />
                        </div>
                      </div>
                                  <div className="flex gap-2 pt-2 border-t border-blue-400/30">
                                    <button type="button" onClick={() => setUmDateRange({ start: null, end: null })} className="flex-1 px-3 py-2 bg-white/5 hover:bg-blue-500/20 text-white/80 hover:text-white rounded-xl text-sm transition-all font-medium">{p('common.reset')}</button>
                                    <button type="button" onClick={() => setUmIsDateRangeOpen(false)} className="flex-1 px-3 py-2 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white rounded-xl text-sm transition-all font-medium shadow-lg shadow-blue-500/30">{p('common.apply')}</button>
                        </div>
                        </div>
                              </div>
                          </div>
                        )}
                      </div>

                        {umSelectedRecords.length > 0 && (
                          <button type="button" onClick={handleUmBulkDelete} className="flex items-center gap-2 px-3 py-2 bg-red-500/20 hover:bg-red-500/30 border border-red-500/30 text-red-200 rounded-lg transition-all text-sm font-medium">
                            <Trash2 size={16} /><span className="hidden sm:inline">{p('common.delete_selected', { count: umSelectedRecords.length })}</span>
                          </button>
                        )}
                        
                        <div className="relative" ref={umImportDropdownRef}>
                          <button type="button" onClick={() => { setUmShowImportDropdown(!umShowImportDropdown); setUmShowExportDropdown(false); }} className="bg-orange-500/20 hover:bg-orange-500/30 text-orange-200 border border-orange-500/30 px-3 py-2 rounded-lg transition-all duration-200 flex items-center gap-1.5">
                            <Upload size={16} /><span className="text-sm font-medium">{t('common.import')}</span><ChevronDown size={14} className={`transition-transform ${umShowImportDropdown ? 'rotate-180' : ''}`} />
                        </button>
                          {umShowImportDropdown && (
                            <div className="border border-blue-400/60 rounded-2xl shadow-2xl min-w-[120px]" style={{ position: 'absolute', top: 'calc(100% + 8px)', right: 0, zIndex: 99999, backgroundImage: 'linear-gradient(to bottom right, rgb(51, 65, 85), rgb(29, 71, 196), rgb(51, 65, 85))', boxShadow: '0 8px 32px rgba(59, 130, 246, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.2)' }}>
                              <div className="p-2">
                                <button type="button" onClick={() => { setUmShowImportDropdown(false); window.alert(p('messages.import_users_csv')); }} className="w-full px-4 py-2.5 text-left text-white/90 hover:bg-blue-500/20 transition-colors flex items-center gap-3 rounded-xl"><FileText size={16} className="text-red-400" /><span className="text-sm font-medium">{p('common.csv')}</span></button>
                                <button type="button" onClick={() => { setUmShowImportDropdown(false); window.alert(p('messages.import_excel_coming')); }} className="w-full px-4 py-2.5 text-left text-white/90 hover:bg-blue-500/20 transition-colors flex items-center gap-3 rounded-xl"><FileSpreadsheet size={16} className="text-green-400" /><span className="text-sm font-medium">{p('common.excel')}</span></button>
                      </div>
                    </div>
                          )}
                        </div>

                        <div className="relative" ref={umExportDropdownRef}>
                          <button type="button" onClick={() => { setUmShowExportDropdown(!umShowExportDropdown); setUmShowImportDropdown(false); }} className="bg-green-500/20 hover:bg-green-500/30 text-green-200 border border-green-500/30 px-3 py-2 rounded-lg transition-all duration-200 flex items-center gap-1.5">
                            <Download size={16} /><span className="text-sm font-medium">{t('common.export')}</span><ChevronDown size={14} className={`transition-transform ${umShowExportDropdown ? 'rotate-180' : ''}`} />
                          </button>
                          {umShowExportDropdown && (
                            <div className="border border-blue-400/60 rounded-2xl shadow-2xl min-w-[120px]" style={{ position: 'absolute', top: 'calc(100% + 8px)', right: 0, zIndex: 99999, backgroundImage: 'linear-gradient(to bottom right, rgb(51, 65, 85), rgb(29, 71, 196), rgb(51, 65, 85))', boxShadow: '0 8px 32px rgba(59, 130, 246, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.2)' }}>
                              <div className="p-2">
                                <button type="button" onClick={() => { exportUmUsers('excel'); setUmShowExportDropdown(false); }} className="w-full px-4 py-2.5 text-left text-white/90 hover:bg-blue-500/20 transition-colors flex items-center gap-3 rounded-xl"><FileSpreadsheet size={16} className="text-green-400" /><span className="text-sm font-medium">{p('common.excel')}</span></button>
                                <button type="button" onClick={() => { setUmShowExportDropdown(false); window.alert(p('messages.export_users_pdf_coming')); }} className="w-full px-4 py-2.5 text-left text-white/90 hover:bg-blue-500/20 transition-colors flex items-center gap-3 rounded-xl"><FileText size={16} className="text-blue-400" /><span className="text-sm font-medium">{p('common.pdf')}</span></button>
                                <button type="button" onClick={() => { exportUmUsers('csv'); setUmShowExportDropdown(false); }} className="w-full px-4 py-2.5 text-left text-white/90 hover:bg-blue-500/20 transition-colors flex items-center gap-3 rounded-xl"><FileOutput size={16} className="text-purple-400" /><span className="text-sm font-medium">{p('common.csv')}</span></button>
                  </div>
                    </div>
                          )}
                    </div>
                    </div>
                    </div>
              </div>

                  {umViewMode === 'table' && (
                <div className="overflow-x-auto">
                      <table className="w-full employees-table data-table">
                    <thead className="bg-white/5">
                      <tr>
                            <th className="px-3 py-4 text-center text-white font-semibold">
                              <button type="button" onClick={handleUmSelectAllRows} className="text-white/70 hover:text-white transition-colors">{umSelectAll ? <CheckSquare size={20} /> : <Square size={20} />}</button>
                            </th>
                            <th className="px-6 py-4 text-left text-white font-semibold">
                              <button type="button" onClick={() => umHandleSort('id')} className="flex items-center gap-2 hover:text-blue-300 transition-colors">
                                <span>ID</span>
                                {(() => {
                                  const sortInfo = umGetSortInfo('id');
                                  if (sortInfo) {
                                    return (
                                      <span className="flex items-center gap-1">
                                        {sortInfo.direction === 'asc' ? <ArrowUp size={16} className="text-blue-400" /> : <ArrowDown size={16} className="text-blue-400" />}
                                        {sortInfo.isMulti && <span className="text-xs bg-blue-500 text-white rounded-full w-4 h-4 flex items-center justify-center font-bold">{sortInfo.order}</span>}
                                      </span>
                                    );
                                  }
                                  return <ArrowUpDown size={16} className="text-white/30" />;
                                })()}
                              </button>
                            </th>
                            <th className="px-6 py-4 text-left text-white font-semibold">
                              <button type="button" onClick={() => umHandleSort('name')} className="flex items-center gap-2 hover:text-blue-300 transition-colors">
                                <span>{p('users_extra.full_name', { defaultValue: t('common.name') })}</span>
                                {(() => {
                                  const sortInfo = umGetSortInfo('name');
                                  if (sortInfo) {
                                    return (
                                      <span className="flex items-center gap-1">
                                        {sortInfo.direction === 'asc' ? <ArrowUp size={16} className="text-blue-400" /> : <ArrowDown size={16} className="text-blue-400" />}
                                        {sortInfo.isMulti && <span className="text-xs bg-blue-500 text-white rounded-full w-4 h-4 flex items-center justify-center font-bold">{sortInfo.order}</span>}
                                      </span>
                                    );
                                  }
                                  return <ArrowUpDown size={16} className="text-white/30" />;
                                })()}
                              </button>
                            </th>
                            <th className="px-6 py-4 text-left text-white font-semibold">
                              <button type="button" onClick={() => umHandleSort('email')} className="flex items-center gap-2 hover:text-blue-300 transition-colors">
                                <span>{p('company.email')}</span>
                                {(() => {
                                  const sortInfo = umGetSortInfo('email');
                                  if (sortInfo) {
                                    return (
                                      <span className="flex items-center gap-1">
                                        {sortInfo.direction === 'asc' ? <ArrowUp size={16} className="text-blue-400" /> : <ArrowDown size={16} className="text-blue-400" />}
                                        {sortInfo.isMulti && <span className="text-xs bg-blue-500 text-white rounded-full w-4 h-4 flex items-center justify-center font-bold">{sortInfo.order}</span>}
                                      </span>
                                    );
                                  }
                                  return <ArrowUpDown size={16} className="text-white/30" />;
                                })()}
                              </button>
                            </th>
                            <th className="px-6 py-4 text-left text-white font-semibold">
                              <button type="button" onClick={() => umHandleSort('role')} className="flex items-center gap-2 hover:text-blue-300 transition-colors">
                                <span>{p('users_extra.role')}</span>
                                {(() => {
                                  const sortInfo = umGetSortInfo('role');
                                  if (sortInfo) {
                                    return (
                                      <span className="flex items-center gap-1">
                                        {sortInfo.direction === 'asc' ? <ArrowUp size={16} className="text-blue-400" /> : <ArrowDown size={16} className="text-blue-400" />}
                                        {sortInfo.isMulti && <span className="text-xs bg-blue-500 text-white rounded-full w-4 h-4 flex items-center justify-center font-bold">{sortInfo.order}</span>}
                                      </span>
                                    );
                                  }
                                  return <ArrowUpDown size={16} className="text-white/30" />;
                                })()}
                              </button>
                            </th>
                            <th className="px-6 py-4 text-center text-white font-semibold">
                              <button type="button" onClick={() => umHandleSort('sections')} className="flex items-center gap-2 hover:text-blue-300 transition-colors">
                                <span>{p('users.col_modules')}</span>
                                {(() => {
                                  const sortInfo = umGetSortInfo('sections');
                                  if (sortInfo) {
                                    return (
                                      <span className="flex items-center gap-1">
                                        {sortInfo.direction === 'asc' ? <ArrowUp size={16} className="text-blue-400" /> : <ArrowDown size={16} className="text-blue-400" />}
                                        {sortInfo.isMulti && <span className="text-xs bg-blue-500 text-white rounded-full w-4 h-4 flex items-center justify-center font-bold">{sortInfo.order}</span>}
                                      </span>
                                    );
                                  }
                                  return <ArrowUpDown size={16} className="text-white/30" />;
                                })()}
                              </button>
                            </th>
                            <th className="px-6 py-4 text-left text-white font-semibold">{p('users.col_last_activity')}</th>
                            <th className="px-6 py-4 text-center text-white font-semibold">
                              <button type="button" onClick={() => umHandleSort('status')} className="flex items-center gap-2 hover:text-blue-300 transition-colors mx-auto">
                                <span>{p('users.col_status')}</span>
                                {(() => {
                                  const sortInfo = umGetSortInfo('status');
                                  if (sortInfo) {
                                    return (
                                      <span className="flex items-center gap-1">
                                        {sortInfo.direction === 'asc' ? <ArrowUp size={16} className="text-blue-400" /> : <ArrowDown size={16} className="text-blue-400" />}
                                        {sortInfo.isMulti && <span className="text-xs bg-blue-500 text-white rounded-full w-4 h-4 flex items-center justify-center font-bold">{sortInfo.order}</span>}
                                      </span>
                                    );
                                  }
                                  return <ArrowUpDown size={16} className="text-white/30" />;
                                })()}
                              </button>
                            </th>
                            <th className="px-6 py-4 text-center text-white font-semibold">{p('users.col_actions')}</th>
                      </tr>
                    </thead>
                        <tbody className="divide-y divide-white/10 employees-table-body">
                          {filteredSortedUmUsers.length > 0 ? (
                            filteredSortedUmUsers.map((user, index) => {
                        const userRole = permissions.roles?.[user.role];
                              const nSec = getUserSectionsCount(user.id);
                        return (
                                <tr key={user.id} className={`hover:bg-white/5 transition-colors ${umSelectedRecords.includes(user.id) ? 'bg-white/10' : ''}`}>
                                  <td className="px-3 py-4 text-center">
                                    <button type="button" onClick={() => handleUmSelectOneRow(user.id)} className="text-white/70 hover:text-white transition-colors">{umSelectedRecords.includes(user.id) ? <CheckSquare size={18} /> : <Square size={18} />}</button>
                                  </td>
                                  <td className="px-6 py-4"><span className="text-white font-semibold text-sm">{user.id}</span></td>
                                  <td className="px-6 py-4">
                                    <div className="flex items-center gap-2">
                                      <div className="h-8 w-8 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 flex items-center justify-center text-white font-semibold text-xs">{(user.name || '?').charAt(0).toUpperCase()}</div>
                                      <span className="text-white font-semibold">{user.name}</span>
                              </div>
                            </td>
                                  <td className="px-6 py-4"><span className="text-white/70 text-sm">{user.email || '—'}</span></td>
                                  <td className="px-6 py-4">
                                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${user.role === 'super_admin' ? 'bg-red-500/20 text-red-300' : user.role === 'admin' ? 'bg-blue-500/20 text-blue-300' : user.role === 'manager' ? 'bg-green-500/20 text-green-300' : 'bg-yellow-500/20 text-yellow-300'}`}>
                                {userRole?.name || user.role}
                              </span>
                            </td>
                                  <td className="px-6 py-4 text-center"><span className="text-white font-bold text-lg">{nSec}</span></td>
                                  <td className="px-6 py-4 text-sm text-white/60">{formatArSaDate(user.lastActivity || user.lastLogin || user.createdAt)}</td>
                                  <td className="px-6 py-4 text-center">
                                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${user.status === 'active' ? 'bg-green-500/20 text-green-300' : 'bg-red-500/20 text-red-300'}`}>
                                      <span className={`w-2 h-2 rounded-full mr-1 ${user.status === 'active' ? 'bg-green-400' : 'bg-red-400'}`} />
                                {user.status === 'active' ? t('settings.user_management.active') : t('settings.user_management.inactive')}
                              </span>
                            </td>
                                  <td className="px-6 py-4">
                                    <div className="flex items-center justify-center gap-1">
                                      <button type="button" onClick={() => { setUmViewingUser(user); setUmShowViewUserModal(true); }} className="p-1.5 transition-colors" title={p('common.view')}><Eye size={16} className="text-blue-400 hover:text-blue-300" /></button>
                                      <button type="button" onClick={() => openEditUserModal(user)} className="p-1.5 transition-colors" title={p('common.edit')}><Edit size={16} className="text-green-400 hover:text-green-300" /></button>
                                      <button type="button" onClick={() => handleEditUserPermissions(user.id)} className="p-1.5 transition-colors" title={t('permissions.edit_permissions')}><Shield size={16} className="text-amber-400 hover:text-amber-300" /></button>
                                {user.id !== permissions.currentUser?.id && (
                                        <button type="button" onClick={() => handleUmDeleteOne(user.id)} className="p-1.5 transition-colors" title={p('common.delete')}><Trash2 size={16} className="text-red-400 hover:text-red-300" /></button>
                                )}
                              </div>
                            </td>
                                </tr>
                        );
                            })
                          ) : (
                            <tr><td colSpan={9} className="text-center py-12 text-white/60"><Users size={48} className="mx-auto mb-4 text-white/30" /><p className="text-lg">{p('users.no_users')}</p></td></tr>
                          )}
                    </tbody>
                        <tfoot>
                          <tr className="bg-white/5 border-t border-white/10">
                            <td colSpan={9} className="px-6 py-4">
                              <div className="flex items-center justify-between text-white/70 text-sm flex-wrap gap-2">
                                <span>{p('profile_tab.footer_users', { count: filteredSortedUmUsers.length })}</span>
                                <span>{p('profile_tab.footer_sections_total')}: <span className="text-white font-semibold">{filteredSortedUmUsers.reduce((s, u) => s + getUserSectionsCount(u.id), 0)}</span></span>
                                <span>{p('profile_tab.footer_actives')}: <span className="text-white font-semibold">{filteredSortedUmUsers.filter((u) => u.status === 'active').length}</span></span>
                              </div>
                            </td>
                          </tr>
                        </tfoot>
                  </table>
                </div>
                  )}

                  {umViewMode === 'cards' && (
                    <div className="p-6 space-y-4">
                      {filteredSortedUmUsers.length > 0 ? (
                        filteredSortedUmUsers.map((user, index) => {
                          const userRole = permissions.roles?.[user.role];
                          const nSec = getUserSectionsCount(user.id);
                          const effectivePermissions = permissions.getUserEffectivePermissions(user.id);
                  return (
                            <motion.div key={user.id} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: index * 0.05 }} className="bg-white/[0.03] rounded-2xl p-6 border border-white/20 hover:border-white/40 hover:bg-white/[0.05] transition-all">
                              <div className="flex items-start justify-between gap-4">
                                <div className="flex-1 min-w-0">
                                  <div className="flex items-center space-x-4 mb-4 flex-wrap">
                                    <h3 className="text-xl font-bold text-white flex items-center gap-2"><UserCheck size={20} className="text-emerald-400" />{user.name}</h3>
                                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${user.role === 'super_admin' ? 'bg-red-500/20 text-red-300' : user.role === 'admin' ? 'bg-blue-500/20 text-blue-300' : user.role === 'manager' ? 'bg-green-500/20 text-green-300' : 'bg-yellow-500/20 text-yellow-300'}`}>{userRole?.name || user.role}</span>
                      </div>
                                  <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
                                    <div>
                                      <h5 className="font-medium text-white mb-2">{t('common.identity')}</h5>
                                      <div className="space-y-1 text-sm text-white/70">
                                        <div><span className="font-medium">ID:</span> {user.id}</div>
                                        <div className="flex items-center gap-2"><Mail size={14} className="text-blue-400 shrink-0" /><span>{user.email || '—'}</span></div>
                    </div>
                                    </div>
                                    <div>
                                      <h5 className="font-medium text-white mb-2">{t('common.access')}</h5>
                                      <div className="space-y-1 text-sm text-white/70">
                                        <div><span className="font-medium">{p('users_extra.visible_modules')}:</span> {nSec} / {SAUDI_MODULE_KEYS.length}</div>
                                        <div><span className="font-medium">{t('common.status')}:</span> {user.status === 'active' ? t('settings.user_management.active') : t('settings.user_management.inactive')}</div>
                                      </div>
                                    </div>
                                    <div>
                                      <h5 className="font-medium text-white mb-2 flex items-center gap-2"><Clock size={16} /> {t('common.activity')}</h5>
                                      <div className="space-y-1 text-sm text-white/70">
                                        <div>{t('settings.user_management.now')}</div>
                                      </div>
                                    </div>
                                    <div>
                                      <h5 className="font-medium text-white mb-2">{p('profile_tab.permissions_preview')}</h5>
                                      <div className="text-xs text-white/50 max-h-24 overflow-y-auto space-y-0.5">
                                        {Object.entries(effectivePermissions).filter(([, v]) => v?.includes(PermissionLevels.SEE)).slice(0, 8).map(([k]) => (
                                          <div key={k} className="truncate">{k}</div>
                                        ))}
                                        {Object.keys(effectivePermissions).filter((k) => effectivePermissions[k]?.includes(PermissionLevels.SEE)).length > 8 && <div className="text-white/40">…</div>}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="flex gap-1 shrink-0">
                                  <button type="button" onClick={() => { setUmViewingUser(user); setUmShowViewUserModal(true); }} className="p-1.5"><Eye size={16} className="text-blue-400 hover:text-blue-300" /></button>
                                  <button type="button" onClick={() => openEditUserModal(user)} className="p-1.5"><Edit size={16} className="text-green-400 hover:text-green-300" /></button>
                                  <button type="button" onClick={() => handleEditUserPermissions(user.id)} className="p-1.5"><Shield size={16} className="text-amber-400 hover:text-amber-300" /></button>
                                  {user.id !== permissions.currentUser?.id && (
                                    <button type="button" onClick={() => handleUmDeleteOne(user.id)} className="p-1.5"><Trash2 size={16} className="text-red-400 hover:text-red-300" /></button>
                                  )}
                                </div>
                              </div>
                            </motion.div>
                          );
                        })
                      ) : (
                        <div className="text-center py-12"><Users size={48} className="mx-auto mb-4 text-white/30" /><p className="text-white/60 text-lg">{p('users.no_users')}</p></div>
                      )}
              </div>
                  )}
                </div>
              </div>
              ) : (
                <div className="text-center py-20">
                  <Users size={64} className="mx-auto mb-4 text-white/30" />
                  <h2 className="text-2xl font-bold text-white mb-2">{p('profile_tab.admin_section_title')}</h2>
                  <p className="text-white/60 text-lg">{p('profile_tab.admin_access_only')}</p>
                  <p className="text-white/40 text-sm mt-4">{p('users.use_profile_tab')}</p>
                </div>
              )}

              {showAddUserModal &&
                createPortal(
                  <div
                    className="fixed inset-0 bg-black/20 backdrop-blur-md flex items-center justify-center z-[99999] p-4"
                    onClick={() => {
                      setShowAddUserModal(false);
                      setEditingUserRecord(null);
                    }}
                    role="presentation"
                  >
                    <motion.div
                      initial={{ opacity: 0, scale: 0.95 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ duration: 0.2 }}
                      className="bg-gradient-to-br from-slate-800 via-blue-750 to-slate-800 backdrop-blur-lg border-2 border-blue-400/60 rounded-2xl max-h-[90vh] flex flex-col overflow-hidden"
                      style={{ boxShadow: '0 0 40px rgba(59, 130, 246, 0.4), 0 0 80px rgba(59, 130, 246, 0.2)', width: '90%', maxWidth: '960px' }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="flex items-center justify-between p-6">
                        <h2 className="text-2xl font-bold text-white">
                          {editingUserRecord ? p('users_extra.edit_user') : t('settings.user_management.add_user')}
                        </h2>
                        <div className="flex items-center gap-3">
                        <button
                            type="submit"
                            form="settings-user-form"
                            className="px-6 py-2.5 rounded-xl bg-gradient-to-r from-blue-500 to-blue-700 text-white hover:from-blue-600 hover:to-blue-800 transition-all duration-200 font-semibold flex items-center gap-2 shadow-lg shadow-blue-500/30"
                          >
                            <CheckCircle size={18} />
                            {p('common.save')}
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              setShowAddUserModal(false);
                              setEditingUserRecord(null);
                            }}
                            className="text-white/70 hover:text-white transition-colors"
                          >
                            <X size={24} />
                        </button>
                      </div>
                    </div>
                      <div className="overflow-y-auto p-6 flex-1">
                        <form id="settings-user-form" onSubmit={handleUserFormSubmit} className="space-y-4">
                          <div className="bg-white/5 rounded-xl border border-white/20 overflow-hidden">
                            <button
                              type="button"
                              onClick={() => toggleUserFormSection('identity')}
                              className="w-full flex items-center justify-between p-4 hover:bg-white/5 transition-colors"
                            >
                              <div className="flex items-center gap-3">
                                <User size={20} className="text-emerald-400" />
                                <h3 className="text-lg font-semibold text-white">{p('users_extra.section_identity')}</h3>
                              </div>
                              {userFormExpandedSections.identity ? <ChevronUp size={20} className="text-white/60" /> : <ChevronDown size={20} className="text-white/60" />}
                            </button>
                            <AnimatePresence>
                              {userFormExpandedSections.identity && (
                                <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.3 }} className="overflow-hidden">
                                  <div className="p-4 pt-0 grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                                      <label className="block text-white/70 text-sm mb-2 font-medium">{p('users_extra.name_ar')} <span className="qawaem-required-mark">*</span></label>
                          <input
                                        value={userFormData.nameAr}
                                        onChange={(e) => setUserFormData({ ...userFormData, nameAr: e.target.value })}
                                        className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        dir="rtl"
                          />
                        </div>
                        <div>
                                      <label className="block text-white/70 text-sm mb-2 font-medium">{p('users_extra.name_en')} <span className="qawaem-required-mark">*</span></label>
                          <input
                                        value={userFormData.nameEn}
                                        onChange={(e) => setUserFormData({ ...userFormData, nameEn: e.target.value })}
                                        className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                          />
                        </div>
                        <div>
                                      <label className="block text-white/70 text-sm mb-2 font-medium">{p('users_extra.username')}</label>
                          <input
                                        value={userFormData.username}
                                        onChange={(e) => setUserFormData({ ...userFormData, username: e.target.value })}
                                        className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                          />
                        </div>
                        <div>
                                      <label className="block text-white/70 text-sm mb-2 font-medium">{p('users_extra.email')} <span className="qawaem-required-mark">*</span></label>
                          <input
                            type="email"
                                        value={userFormData.email}
                                        onChange={(e) => setUserFormData({ ...userFormData, email: e.target.value })}
                                        className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        placeholder={p('users_extra.email_placeholder')}
                          />
                        </div>
                                    <div>
                                      <label className="block text-white/70 text-sm mb-2 font-medium">{p('users_extra.phone')}</label>
                          <input
                                        value={userFormData.phone}
                                        onChange={(e) => setUserFormData({ ...userFormData, phone: e.target.value })}
                                        className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        placeholder={SAUDI_PHONE_PLACEHOLDER}
                          />
                        </div>
                                    <div>
                                      <label className="block text-white/70 text-sm mb-2 font-medium">{p('users_extra.department')}</label>
                          <input
                                        value={userFormData.department}
                                        onChange={(e) => setUserFormData({ ...userFormData, department: e.target.value })}
                                        className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                          />
                        </div>
                                    <div>
                                      <label className="block text-white/70 text-sm mb-2 font-medium">{p('users_extra.position')}</label>
                          <input
                                        value={userFormData.position}
                                        onChange={(e) => setUserFormData({ ...userFormData, position: e.target.value })}
                                        className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                          />
                        </div>
                                    <div>
                                      <label className="block text-white/70 text-sm mb-2 font-medium">{p('users_extra.national_id')}</label>
                          <input
                                        value={userFormData.nationalId}
                                        onChange={(e) => setUserFormData({ ...userFormData, nationalId: e.target.value })}
                                        className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                          />
                        </div>
                                    <div>
                                      <label className="block text-white/70 text-sm mb-2 font-medium">{p('users_extra.residency_type')}</label>
                                      <CustomSelect
                                        value={userFormData.residencyType}
                                        onChange={(v) => setUserFormData({ ...userFormData, residencyType: v })}
                                        options={[
                                          { value: 'saudi', label: p('users_extra.residency_saudi') },
                                          { value: 'expat', label: p('users_extra.residency_expat') },
                                        ]}
                                      />
                        </div>
                                  </div>
                                </motion.div>
                              )}
                            </AnimatePresence>
                      </div>

                          <div className="bg-white/5 rounded-xl border border-white/20 overflow-hidden">
                            <button
                              type="button"
                              onClick={() => toggleUserFormSection('credentials')}
                              className="w-full flex items-center justify-between p-4 hover:bg-white/5 transition-colors"
                            >
                              <div className="flex items-center gap-3">
                                <Lock size={20} className="text-blue-400" />
                                <h3 className="text-lg font-semibold text-white">{p('users_extra.section_credentials')}</h3>
                              </div>
                              {userFormExpandedSections.credentials ? <ChevronUp size={20} className="text-white/60" /> : <ChevronDown size={20} className="text-white/60" />}
                            </button>
                            <AnimatePresence>
                              {userFormExpandedSections.credentials && (
                                <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.3 }} className="overflow-hidden">
                                  <div className="p-4 pt-0 grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div className="md:col-span-2">
                                      <label className="block text-white/70 text-sm mb-2 font-medium">{p('users_extra.role')} <span className="qawaem-required-mark">*</span></label>
                                      <CustomSelect
                                        value={userFormData.role}
                                        onChange={(v) => setUserFormData({ ...userFormData, role: v })}
                                        options={umRoleSelectOptions}
                                        placeholder={p('users_extra.choose_role')}
                                        searchable
                                        creatable
                                        autoSelect={false}
                                      />
                        </div>
                                    <div className="md:col-span-2">
                                      <label className="block text-white/70 text-sm mb-2 font-medium">{p('users_extra.temp_password')}</label>
                                      <input
                                        type="password"
                                        value={userFormData.tempPassword}
                                        onChange={(e) => setUserFormData({ ...userFormData, tempPassword: e.target.value })}
                                        className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        autoComplete="new-password"
                                      />
                          </div>
                          </div>
                                </motion.div>
                              )}
                            </AnimatePresence>
                          </div>

                          <div className="bg-white/5 rounded-xl border border-white/20 overflow-hidden">
                            <button
                              type="button"
                              onClick={() => toggleUserFormSection('accessPreview')}
                              className="w-full flex items-center justify-between p-4 hover:bg-white/5 transition-colors"
                            >
                              <div className="flex items-center gap-3">
                                <Shield size={20} className="text-amber-400" />
                                <h3 className="text-lg font-semibold text-white">{p('users_extra.section_access_preview')}</h3>
                        </div>
                              {userFormExpandedSections.accessPreview ? <ChevronUp size={20} className="text-white/60" /> : <ChevronDown size={20} className="text-white/60" />}
                            </button>
                            <AnimatePresence>
                              {userFormExpandedSections.accessPreview && (
                                <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.3 }} className="overflow-hidden">
                                  <div className="p-4 pt-0 text-sm text-white/70">
                                    {userFormData.role && permissions.roles?.[userFormData.role] ? (
                                      <p>{permissions.roles[userFormData.role].description}</p>
                                    ) : (
                                      <p className="text-white/50">{p('users_extra.select_role_hint')}</p>
                                    )}
                                  </div>
                                </motion.div>
                              )}
                            </AnimatePresence>
                      </div>

                          <div className="bg-white/5 rounded-xl border border-white/20 overflow-hidden">
                        <button
                              type="button"
                              onClick={() => toggleUserFormSection('metadata')}
                              className="w-full flex items-center justify-between p-4 hover:bg-white/5 transition-colors"
                        >
                        <div className="flex items-center gap-3">
                                <FileText size={20} className="text-purple-400" />
                                <h3 className="text-lg font-semibold text-white">{p('users_extra.section_metadata')}</h3>
                              </div>
                              {userFormExpandedSections.metadata ? <ChevronUp size={20} className="text-white/60" /> : <ChevronDown size={20} className="text-white/60" />}
                          </button>
                            <AnimatePresence>
                              {userFormExpandedSections.metadata && (
                                <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.3 }} className="overflow-hidden">
                                  <div className="p-4 pt-0">
                                    <textarea
                                      value={userFormData.notes}
                                      onChange={(e) => setUserFormData({ ...userFormData, notes: e.target.value })}
                                      rows={4}
                                      className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                                      placeholder={p('users_extra.notes_placeholder')}
                                    />
                        </div>
                                </motion.div>
                              )}
                            </AnimatePresence>
                      </div>
                        </form>
                    </div>
                    </motion.div>
                  </div>,
                  document.body
                )}

              {umShowViewUserModal && umViewingUser &&
                createPortal(
                  <motion.div 
                    initial={{ opacity: 0 }} 
                    animate={{ opacity: 1 }} 
                    exit={{ opacity: 0 }} 
                    className="fixed inset-0 bg-black/20 backdrop-blur-md flex items-center justify-center z-[99999] p-4" 
                    onClick={() => setUmShowViewUserModal(false)}
                  >
                    <motion.div 
                      initial={{ scale: 0.95, opacity: 0 }} 
                      animate={{ scale: 1, opacity: 1 }} 
                      exit={{ scale: 0.95, opacity: 0 }} 
                      transition={{ duration: 0.2 }} 
                      onClick={(e) => e.stopPropagation()} 
                      className="bg-gradient-to-br from-slate-800 via-blue-750 to-slate-800 backdrop-blur-lg border-2 border-blue-400/60 rounded-2xl p-6 max-h-[90vh] overflow-y-auto" 
                      style={{ boxShadow: '0 0 40px rgba(59, 130, 246, 0.4), 0 0 80px rgba(59, 130, 246, 0.2)', width: '95%', maxWidth: '600px' }}
                    >
                      <div className="flex justify-between items-center mb-6">
                        <h2 className="text-2xl font-bold text-white">{umViewingUser.name}</h2>
                        <button 
                          onClick={() => setUmShowViewUserModal(false)} 
                          className="text-white/70 hover:text-white transition-colors"
                        >
                          <X size={24} />
                        </button>
                      </div>
                      <div className="space-y-4">
                        <div className="bg-white/5 rounded-xl p-5 border border-white/20">
                          <div className="space-y-3">
                            <div>
                              <p className="text-sm text-white/60 mb-1">{p('users_extra.col_id')}</p>
                              <p className="text-white font-medium">{umViewingUser.id}</p>
                            </div>
                            <div>
                              <p className="text-sm text-white/60 mb-1">{t('common.email')}</p>
                              <p className="text-white font-medium">{umViewingUser.email}</p>
                            </div>
                            <div>
                              <p className="text-sm text-white/60 mb-1">{t('common.role')}</p>
                              <p className="text-white font-medium">{permissions.roles?.[umViewingUser.role]?.name || umViewingUser.role}</p>
                            </div>
                            <div>
                              <p className="text-sm text-white/60 mb-1">{t('common.sections')}</p>
                              <p className="text-white font-medium">{getUserSectionsCount(umViewingUser.id)} / {Object.keys(SystemSections).length}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  </motion.div>,
                  document.body
              )}

              {/* Permission Management Modal */}
              {showPermissionModal && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  className="fixed inset-0 bg-black/20 backdrop-blur-md flex items-center justify-center z-[99999] p-4"
                  onClick={() => setShowPermissionModal(false)}
                >
                  <motion.div
                    initial={{ scale: 0.95, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.95, opacity: 0 }}
                    transition={{ duration: 0.2 }}
                    onClick={(e) => e.stopPropagation()}
                    className="bg-gradient-to-br from-slate-800 via-blue-750 to-slate-800 backdrop-blur-lg border-2 border-blue-400/60 rounded-2xl p-6 max-h-[90vh] overflow-y-auto"
                    style={{
                      boxShadow: '0 0 40px rgba(59, 130, 246, 0.4), 0 0 80px rgba(59, 130, 246, 0.2)',
                      width: '95%',
                      maxWidth: '1400px'
                    }}
                  >
                    <div className="flex justify-between items-center mb-6">
                      <div>
                        <h2 className="text-2xl font-bold text-white">
                          {p('permissions.title')} — {permissions.users?.find(u => u.id === selectedUserId)?.nameEn || permissions.users?.find(u => u.id === selectedUserId)?.nameAr || permissions.users?.find(u => u.id === selectedUserId)?.name}
                        </h2>
                        <p className="text-white/60 mt-2 text-sm">
                          {p('permissions.subtitle')}
                        </p>
                      </div>
                      <button
                        onClick={() => setShowPermissionModal(false)}
                        className="text-white/70 hover:text-white transition-colors"
                      >
                        <X size={24} />
                      </button>
                    </div>
                    
                    <div className="space-y-6">
                        <div className="bg-white/5 rounded-xl p-5 border border-white/20">
                          <h4 className="text-white font-semibold mb-4">{p('permissions.legend')}</h4>
                          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 text-sm">
                            {[
                              { key: 'none', color: 'bg-gray-500' },
                              { key: 'view', color: 'bg-blue-500' },
                              { key: 'create', color: 'bg-green-500' },
                              { key: 'edit', color: 'bg-yellow-500' },
                              { key: 'delete', color: 'bg-orange-500' },
                              { key: 'full', color: 'bg-red-500' },
                            ].map(({ key, color }) => (
                              <div key={key} className="flex items-center gap-2">
                                <div className={`w-3 h-3 ${color} rounded`}></div>
                                <span className="text-white/80">{p(`permissions.${key}`)}</span>
                              </div>
                            ))}
                          </div>
                        </div>

                        <div className="bg-white/5 rounded-xl overflow-hidden border border-white/20">
                          <div className="overflow-x-auto">
                            <table className="w-full text-sm">
                              <thead className="bg-white/10">
                                <tr>
                                  <th className="px-4 py-3 text-right text-white font-semibold">{p('permissions.module')}</th>
                                  <th className="px-4 py-3 text-right text-white font-semibold">{p('permissions.level')}</th>
                                </tr>
                              </thead>
                              <tbody className="divide-y divide-white/10">
                                {SAUDI_MODULE_KEYS.map((sectionId) => {
                                  const sectionNames = permissions.getSectionDisplayNames();
                                  return (
                                  <tr key={sectionId} className="hover:bg-white/5">
                                    <td className="px-4 py-3 text-white font-medium text-right">{sectionNames[sectionId] || sectionId}</td>
                                    <td className="px-4 py-3">
                                      <select
                                        value={getPermissionLevel(sectionId)}
                                        onChange={(e) => handlePermissionLevelChange(sectionId, e.target.value)}
                                        className="w-full bg-white/10 border border-white/20 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                      >
                                        {['none', 'view', 'create', 'edit', 'delete', 'full'].map((lvl) => (
                                          <option key={lvl} value={lvl} className="bg-slate-800">{p(`permissions.${lvl}`)}</option>
                                        ))}
                                      </select>
                                    </td>
                                  </tr>
                                );})}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div className="flex items-center justify-between bg-white/5 rounded-xl p-5 border border-white/20 flex-wrap gap-3">
                          <div className="flex items-center gap-3 flex-wrap">
                            <button
                              onClick={() => {
                                const allPermissions = {};
                                SAUDI_MODULE_KEYS.forEach((key) => {
                                  allPermissions[key] = PermissionLevels.FULL;
                                });
                                setEditingPermissions(allPermissions);
                              }}
                              className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg text-sm transition-colors"
                            >
                              {p('permissions.grant_all')}
                            </button>
                            <button
                              onClick={() => {
                                const noPermissions = {};
                                SAUDI_MODULE_KEYS.forEach((key) => {
                                  noPermissions[key] = PermissionLevels.NONE;
                                });
                                setEditingPermissions(noPermissions);
                              }}
                              className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm transition-colors"
                            >
                              {p('permissions.revoke_all')}
                            </button>
                            <button
                              onClick={() => {
                                const readOnlyPermissions = {};
                                SAUDI_MODULE_KEYS.forEach((key) => {
                                  readOnlyPermissions[key] = PermissionLevels.VIEW;
                                });
                                setEditingPermissions(readOnlyPermissions);
                              }}
                              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm transition-colors"
                            >
                              {p('permissions.read_only_all')}
                            </button>
                          </div>
                          
                          <div className="flex items-center gap-3">
                            <button
                              onClick={() => setShowPermissionModal(false)}
                              className="px-6 py-2 bg-white/10 hover:bg-white/20 text-white rounded-lg transition-colors"
                            >
                              {p('common.cancel')}
                            </button>
                            <button
                              onClick={handleSavePermissions}
                              className="px-6 py-2.5 rounded-xl bg-gradient-to-r from-blue-500 to-blue-700 text-white hover:from-blue-600 hover:to-blue-800 transition-all duration-200 font-semibold flex items-center gap-2 shadow-lg shadow-blue-500/30"
                            >
                              <CheckCircle size={18} />
                              {p('common.save')}
                            </button>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  </motion.div>
              )}
              </>
              )}

          {/* Profil Tab - Personal Profile Management */}
          {activeTab === 'profil' && (
            <div>
              <h1 className={`text-3xl font-bold flex items-center gap-3 mb-2 ${isDashboardLightMode ? 'text-slate-900' : 'text-white'}`}>
                <User className={`h-8 w-8 ${isDashboardLightMode ? 'text-blue-600' : 'text-blue-400'}`} />
                {p('profile_tab.title')}
              </h1>
              <p className={`mb-6 ${isDashboardLightMode ? 'text-slate-600' : 'text-white/60'}`}>{p('profile_tab.subtitle')}</p>

              {profileMessage.text && (
                <motion.div 
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.2 }}
                  style={{
                    padding: '1rem 1.25rem',
                    borderRadius: '0.75rem',
                    marginBottom: '1.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                    background: profileMessage.type === 'success' ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)',
                    border: `1px solid ${profileMessage.type === 'success' ? 'rgba(16, 185, 129, 0.3)' : 'rgba(239, 68, 68, 0.3)'}`,
                    color: profileMessage.type === 'success' ? 'rgb(52, 211, 153)' : 'rgb(248, 113, 113)'
                  }}
                >
                  {profileMessage.type === 'success' ? <CheckCircle size={18} /> : <AlertCircle size={18} />}
                  {profileMessage.text}
                </motion.div>
              )}
              
              {/* Profile Card */}
              <motion.div 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: 0.1 }}
                style={{
                  background: settingsCardGlass.background,
                  backdropFilter: settingsCardGlass.backdropFilter,
                  border: settingsCardGlass.border,
                  borderRadius: settingsCardGlass.borderRadius,
                  padding: settingsCardGlass.padding,
                  marginBottom: settingsCardGlass.marginBottom,
                  position: 'relative',
                  boxShadow: isDashboardLightMode ? '0 1px 3px rgba(0,0,0,0.06)' : undefined
                }}
              >
                {/* Buttons - Top Right */}
                {!isEditingProfile && (
                  <>
                    <motion.button 
                      onClick={() => setShowLicenseKey(true)}
                      whileHover={{ scale: 1.03 }}
                      whileTap={{ scale: 0.97 }}
                      style={{
                        position: 'absolute',
                        top: '1.5rem',
                        right: '1.5rem',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        padding: '0.625rem 1.25rem',
                        background: 'linear-gradient(135deg, #10b981, #059669)',
                        border: 'none',
                        borderRadius: '0.75rem',
                        color: 'white',
                        fontSize: '0.875rem',
                        fontWeight: '600',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                        boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)'
                      }}
                    >
                      <Key size={16} />
                      {p('profile_tab.product_key')}
                    </motion.button>
                    
                    <motion.button 
                      onClick={() => {
                        console.log('✏️ Opening profile editor with:', {
                          profileUser,
                          currentUser: permissions.currentUser
                        });
                      setProfileFormData({
                        ...profileFormData,
                        name: profileUser.name || '',
                        email: profileUser.email || permissions.currentUser?.email || '',
                        jobTitle: profileUser.jobTitle || permissions.currentUser?.jobTitle || '',
                        phone: profileUser.phone || permissions.currentUser?.phone || '',
                        department: profileUser.department || permissions.currentUser?.department || ''
                      });
                        console.log('✏️ Form data initialized:', {
                          phone: profileUser.phone || permissions.currentUser?.phone || '',
                          jobTitle: profileUser.jobTitle || permissions.currentUser?.jobTitle || '',
                          department: profileUser.department || permissions.currentUser?.department || ''
                        });
                        setIsEditingProfile(true);
                      }}
                      whileHover={{ scale: 1.03 }}
                      whileTap={{ scale: 0.97 }}
                      style={{
                        position: 'absolute',
                        top: '1.5rem',
                        right: '10.5rem',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        padding: '0.625rem 1.25rem',
                        background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
                        border: 'none',
                        borderRadius: '0.75rem',
                        color: 'white',
                        fontSize: '0.875rem',
                        fontWeight: '600',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)'
                      }}
                    >
                      <Edit size={16} />
                      {p('profile_tab.edit_profile')}
                    </motion.button>
            </>
          )}

                <div className="flex min-w-0 flex-col items-stretch gap-4 sm:flex-row sm:items-start sm:gap-6">
                  <motion.div 
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="mx-auto h-20 w-20 shrink-0 bg-gradient-to-br from-blue-400 to-blue-600 rounded-full flex items-center justify-center text-3xl font-bold text-white cursor-pointer sm:mx-0"
                  >
                    {profileUser?.name?.charAt(0)?.toUpperCase() || 'U'}
                  </motion.div>
                  <div className={`min-w-0 flex-1 ${!isEditingProfile ? 'pr-0 xl:pr-[180px]' : ''}`}>
                    <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: settingsInkPrimary, margin: 0 }}>{profileUser?.name || p('profile_tab.default_user')}</h2>
                    <p style={{ color: settingsInkMuted, marginTop: '0.25rem', marginBottom: '1rem' }}>
                      {permissions.currentUser?.role === 'super_admin' ? p('profile_tab.role_super_admin') : 
                       permissions.currentUser?.role === 'admin' ? p('profile_tab.role_admin') : 
                       permissions.currentUser?.role === 'manager' ? p('profile_tab.role_manager') : p('profile_tab.role_user')}
                    </p>
                    
                    {/* Account Info — single column on small screens */}
                    <div className="mt-6 grid min-w-0 grid-cols-1 gap-6 md:grid-cols-2 md:gap-8">
                      {/* Left Column */}
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
                        {/* Type de compte */}
                        <div style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'space-between',
                          padding: '1rem 0',
                          borderBottom: `1px solid ${settingsInkBorder}`
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <Shield size={18} className="text-blue-400" />
                            <span style={{ fontSize: '0.875rem', color: settingsInkMuted, fontWeight: '500' }}>{p('profile_tab.account_type')}</span>
                          </div>
                          <span style={{ fontSize: '0.875rem', fontWeight: '600', color: settingsInkPrimary }}>
                            {permissions.currentUser?.role === 'super_admin' || permissions.currentUser?.role === 'admin' ? p('profile_tab.full_access') : p('profile_tab.limited_access')}
                          </span>
                        </div>

                        {/* Modules activés */}
                        <button
                          type="button"
                          onClick={() => setShowModulesModal(true)}
                          title={p('profile_tab.view_enabled_modules')}
                          style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'space-between',
                          padding: '1rem 0.5rem',
                          width: '100%',
                          background: 'transparent',
                          border: 'none',
                          borderBottom: `1px solid ${settingsInkBorder}`,
                          cursor: 'pointer',
                          transition: 'background 0.15s ease',
                        }}
                          className="group rounded-lg hover:bg-white/[0.04] -mx-2 px-2"
                        >
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <Layers size={18} className="text-green-400" />
                            <span style={{ fontSize: '0.875rem', color: settingsInkMuted, fontWeight: '500' }}>{p('profile_tab.enabled_modules')}</span>
                          </div>
                          <span style={{ fontSize: '0.875rem', fontWeight: '600', color: settingsInkPrimary }} className="flex items-center gap-1.5 group-hover:text-blue-300 transition-colors">
                            {enabledLicenseModuleCount} / {LICENSE_CATALOG_MODULE_COUNT}
                            <ChevronDown size={14} className="opacity-50 group-hover:opacity-100 -rotate-90" />
                          </span>
                        </button>

                        {/* Fonction */}
                        <div style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'space-between',
                          padding: '1rem 0',
                          borderBottom: `1px solid ${settingsInkBorder}`
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <User size={18} className="text-purple-400" />
                            <span style={{ fontSize: '0.875rem', color: settingsInkMuted, fontWeight: '500' }}>{p('profile_tab.job_title')}</span>
                          </div>
                          <span style={{ fontSize: '0.875rem', fontWeight: '600', color: settingsInkPrimary }}>
                            {profileUser?.jobTitle || permissions.currentUser?.jobTitle || t('common.not_provided')}
                          </span>
                        </div>

                        {/* Département */}
                        <div style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'space-between',
                          padding: '1rem 0'
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <Building size={18} className="text-indigo-400" />
                            <span style={{ fontSize: '0.875rem', color: settingsInkMuted, fontWeight: '500' }}>{p('profile_tab.department')}</span>
                          </div>
                          <span style={{ fontSize: '0.875rem', fontWeight: '600', color: settingsInkPrimary }}>
                            {profileUser?.department || permissions.currentUser?.department || t('common.not_provided')}
                          </span>
                        </div>
                      </div>

                      {/* Right Column */}
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
                        {/* Email */}
                        <div style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'space-between',
                          padding: '1rem 0',
                          borderBottom: `1px solid ${settingsInkBorder}`
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <Mail size={18} className="text-pink-400" />
                            <span style={{ fontSize: '0.875rem', color: settingsInkMuted, fontWeight: '500' }}>{t('common.email')}</span>
                          </div>
                          <span style={{ fontSize: '0.875rem', fontWeight: '600', color: settingsInkPrimary, wordBreak: 'break-all', textAlign: 'right', maxWidth: '60%' }}>
                            {profileUser?.email || permissions.currentUser?.email || t('common.not_provided')}
                          </span>
                        </div>

                        {/* Téléphone */}
                        <div style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'space-between',
                          padding: '1rem 0',
                          borderBottom: `1px solid ${settingsInkBorder}`
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <Phone size={18} className="text-cyan-400" />
                            <span style={{ fontSize: '0.875rem', color: settingsInkMuted, fontWeight: '500' }}>{t('common.phone')}</span>
                          </div>
                          <span style={{ fontSize: '0.875rem', fontWeight: '600', color: settingsInkPrimary }}>
                            {profileUser?.phone || permissions.currentUser?.phone || t('common.not_provided')}
                          </span>
                        </div>

                        {/* Membre depuis */}
                        <div style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'space-between',
                          padding: '1rem 0',
                          borderBottom: `1px solid ${settingsInkBorder}`
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <Calendar size={18} className="text-purple-400" />
                            <span style={{ fontSize: '0.875rem', color: settingsInkMuted, fontWeight: '500' }}>{p('profile_tab.member_since')}</span>
                          </div>
                          <span style={{ fontSize: '0.875rem', fontWeight: '600', color: settingsInkPrimary }}>
                            {(() => {
                              const date = profileUser?.createdAt || permissions.currentUser?.createdAt;
                              if (date) {
                                return new Date(date).toLocaleDateString(getBrandLocale(i18n.language), { day: '2-digit', month: 'long', year: 'numeric' });
                              }
                              return p('profile_tab.not_available');
                            })()}
                          </span>
                        </div>

                        {/* {p('audit_tab.expires_on')} */}
                        <div style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'space-between',
                          padding: '1rem 0'
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <Clock size={18} className="text-amber-400" />
                            <span style={{ fontSize: '0.875rem', color: settingsInkMuted, fontWeight: '500' }}>{p('audit_tab.expires_on')}</span>
                          </div>
                          <span style={{ fontSize: '0.875rem', fontWeight: '600', color: settingsInkPrimary }}>
                            {(() => {
                              const expiresAt = profileUser?.expiresAt || permissions.currentUser?.expiresAt;
                              if (expiresAt === 'never' || expiresAt === 'permanent') {
                                return p('profile_tab.lifetime_license');
                              }
                              if (expiresAt) {
                                return new Date(expiresAt).toLocaleDateString(getBrandLocale(i18n.language), { day: '2-digit', month: 'long', year: 'numeric' });
                              }
                              return p('profile_tab.lifetime_license');
                            })()}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                {!isEditingProfile ? (
                  <div>
                    {/* Name is already shown in the header above, no need to repeat it here */}
                  </div>
                ) : (
                  <form onSubmit={handleProfileSubmit} style={{ marginTop: '2rem', paddingTop: '1.5rem', borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}>
                    <div className="mb-6 grid min-w-0 grid-cols-1 gap-4 sm:grid-cols-2">
                  <div>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', fontWeight: '600', color: 'rgba(255, 255, 255, 0.7)', marginBottom: '0.5rem' }}>
                          <User size={16} />
                          {p('users_extra.username')}
                        </label>
                        <input
                          type="text"
                          name="name"
                          value={profileFormData.name}
                          onChange={handleProfileChange}
                          placeholder={p('profile_tab.enter_username')}
                          autoComplete="username"
                          required
                          style={{
                            width: '100%',
                            padding: '0.75rem 1rem',
                            background: 'rgba(255, 255, 255, 0.1)',
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            borderRadius: '0.75rem',
                            color: 'white',
                            fontSize: '0.95rem',
                            outline: 'none'
                          }}
                        />
                  </div>
                  <div>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', fontWeight: '600', color: 'rgba(255, 255, 255, 0.7)', marginBottom: '0.5rem' }}>
                          <Mail size={16} />
                          {t('common.email')}
                        </label>
                    <input 
                          type="email"
                          name="email"
                          value={profileFormData.email}
                          onChange={handleProfileChange}
                          placeholder={p('profile_tab.enter_email')}
                          style={{
                            width: '100%',
                            padding: '0.75rem 1rem',
                            background: 'rgba(255, 255, 255, 0.1)',
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            borderRadius: '0.75rem',
                            color: 'white',
                            fontSize: '0.95rem',
                            outline: 'none'
                          }}
                    />
                  </div>
                  <div>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', fontWeight: '600', color: 'rgba(255, 255, 255, 0.7)', marginBottom: '0.5rem' }}>
                          <User size={16} />
                          {p('profile_tab.job_title')}
                        </label>
                    <input 
                          type="text"
                          name="jobTitle"
                          value={profileFormData.jobTitle}
                          onChange={handleProfileChange}
                          placeholder={p('profile_tab.job_title_placeholder')}
                          style={{
                            width: '100%',
                            padding: '0.75rem 1rem',
                            background: 'rgba(255, 255, 255, 0.1)',
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            borderRadius: '0.75rem',
                            color: 'white',
                            fontSize: '0.95rem',
                            outline: 'none'
                          }}
                        />
                      </div>
                      <div>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', fontWeight: '600', color: 'rgba(255, 255, 255, 0.7)', marginBottom: '0.5rem' }}>
                          <Phone size={16} />
                          {t('common.phone')}
                        </label>
                        <input
                          type="tel"
                          name="phone"
                          value={profileFormData.phone}
                          onChange={handleProfileChange}
                          placeholder={p('profile_tab.phone_placeholder_sa')}
                          style={{
                            width: '100%',
                            padding: '0.75rem 1rem',
                            background: 'rgba(255, 255, 255, 0.1)',
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            borderRadius: '0.75rem',
                            color: 'white',
                            fontSize: '0.95rem',
                            outline: 'none'
                          }}
                        />
                      </div>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '1.25rem' }}>
                      <div>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', fontWeight: '600', color: 'rgba(255, 255, 255, 0.7)', marginBottom: '0.5rem' }}>
                          <Building size={16} />
                          {p('profile_tab.department')}
                        </label>
                        <input
                          type="text"
                          name="department"
                          value={profileFormData.department}
                          onChange={handleProfileChange}
                          placeholder={p('profile_tab.department_placeholder')}
                          style={{
                            width: '100%',
                            padding: '0.75rem 1rem',
                            background: 'rgba(255, 255, 255, 0.1)',
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            borderRadius: '0.75rem',
                            color: 'white',
                            fontSize: '0.95rem',
                            outline: 'none'
                          }}
                        />
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '0.75rem', marginTop: '1.5rem' }}>
                      <motion.button 
                        type="submit" 
                        whileHover={{ scale: 1.03 }}
                        whileTap={{ scale: 0.97 }}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem',
                          padding: '0.75rem 1.5rem',
                          background: 'linear-gradient(135deg, #10b981, #059669)',
                          border: 'none',
                          borderRadius: '0.75rem',
                          color: 'white',
                          fontSize: '0.95rem',
                          fontWeight: '600',
                          cursor: 'pointer'
                        }}
                      >
                        <CheckCircle size={16} />
                        {p('common.save')}
                      </motion.button>
                      <motion.button 
                        type="button" 
                        onClick={() => setIsEditingProfile(false)}
                        whileHover={{ scale: 1.03 }}
                        whileTap={{ scale: 0.97 }}
                        style={{
                          padding: '0.75rem 1.5rem',
                          background: 'rgba(255, 255, 255, 0.1)',
                          border: '1px solid rgba(255, 255, 255, 0.2)',
                          borderRadius: '0.75rem',
                          color: 'white',
                          fontSize: '0.95rem',
                          fontWeight: '600',
                          cursor: 'pointer'
                        }}
                      >
                        {p('common.cancel')}
                      </motion.button>
                    </div>
                  </form>
                )}
              </motion.div>

              {/* Language Settings Card */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: 0.12 }}
                style={{
                  background: settingsCardGlass.background,
                  backdropFilter: settingsCardGlass.backdropFilter,
                  border: settingsCardGlass.border,
                  borderRadius: settingsCardGlass.borderRadius,
                  padding: settingsCardGlass.padding,
                  marginBottom: settingsCardGlass.marginBottom,
                  boxShadow: isDashboardLightMode ? '0 1px 3px rgba(0,0,0,0.06)' : undefined
                }}
              >
                <h2 style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '1.25rem', fontWeight: 'bold', color: settingsInkPrimary, marginBottom: '1rem' }}>
                  <Globe size={20} className={isDashboardLightMode ? 'text-teal-600' : 'text-teal-400'} />
                  {t('settings.language_settings')}
                </h2>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', maxWidth: '28rem' }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '500', color: settingsInkMuted }}>
                    {t('settings.documents.language')}
                  </label>
                  <CustomSelect
                    value={settings.invoicing?.language || language || i18n.language || 'fr'}
                    onChange={handleProfileLanguageChange}
                    options={availableLanguages.map(({ code, name }) => ({ value: code, label: name }))}
                    placeholder={t('language_switcher.change_language')}
                    searchable={true}
                  />
                </div>
              </motion.div>

              {/* Version & mises à jour */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: 0.15 }}
                style={{
                  background: 'rgba(255, 255, 255, 0.05)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  borderRadius: '1.5rem',
                  padding: '1.5rem',
                  marginBottom: '1.5rem',
                }}
              >
                <h2
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    fontSize: '1.25rem',
                    fontWeight: 'bold',
                    color: 'white',
                    marginBottom: '1rem',
                  }}
                >
                  <Zap size={20} />
                  {p('app_update.title')}
                </h2>

                {appUpdateStatus?.desktopOnly ? (
                  <p style={{ color: 'rgba(255, 255, 255, 0.7)', margin: 0 }}>
                    {p('app_update.desktop_only_hint')}
                  </p>
                ) : (
                  <>
                    <p style={{ color: 'rgba(255, 255, 255, 0.85)', marginBottom: '0.5rem' }}>
                      {p('app_update.installed_version')}{' '}
                      <strong style={{ fontFamily: 'monospace' }}>
                        v{appUpdateStatus?.currentVersion || '—'}
                      </strong>
                    </p>

                    {appUpdateChecking || appUpdateUiPhase === 'checking' ? (
                      <p style={{ color: 'rgba(255, 255, 255, 0.55)', fontSize: '0.875rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <RefreshCw size={14} className="animate-spin" />
                        {p('app_update.checking')}
                      </p>
                    ) : appUpdateUiPhase === 'downloading' ? (
                      <div style={{ marginTop: '0.75rem' }}>
                        <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '0.875rem', marginBottom: '0.5rem' }}>
                          {p('app_update.downloading', { version: appUpdateStatus?.version || '…', progress: appUpdateStatus?.downloadProgress || 0 })}
                        </p>
                        <div style={{ height: '6px', background: 'rgba(255,255,255,0.1)', borderRadius: '999px', overflow: 'hidden' }}>
                          <div
                            style={{
                              height: '100%',
                              width: `${appUpdateStatus?.downloadProgress || 0}%`,
                              background: 'linear-gradient(90deg, #3b82f6, #2563eb)',
                              transition: 'width 0.2s',
                            }}
                          />
                        </div>
                      </div>
                    ) : appUpdateUiPhase === 'ready' ? (
                      <div>
                        <p style={{ color: 'rgb(52, 211, 153)', marginBottom: '0.75rem', fontSize: '0.875rem' }}>
                          {p('app_update.ready_to_install', { version: appUpdateStatus?.version || '' })}
                        </p>
                        <motion.button
                          type="button"
                          whileHover={{ scale: 1.03 }}
                          whileTap={{ scale: 0.97 }}
                          onClick={() => window.electronAPI?.updates?.install()}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            padding: '0.75rem 1.5rem',
                            background: 'linear-gradient(135deg, #10b981, #059669)',
                            border: 'none',
                            borderRadius: '0.75rem',
                            color: 'white',
                            fontSize: '0.95rem',
                            fontWeight: '600',
                            cursor: 'pointer',
                          }}
                        >
                          <Download size={16} />
                          {p('app_update.install')}
                        </motion.button>
                      </div>
                    ) : appUpdateUiPhase === 'available' ? (
                      <div>
                        <p style={{ color: 'rgba(255, 255, 255, 0.7)', marginBottom: '0.75rem', fontSize: '0.875rem' }}>
                          {p('app_update.new_version_available')}{' '}
                          <strong style={{ color: 'rgb(96, 165, 250)' }}>v{appUpdateStatus?.version}</strong>
                          {appUpdateStatus?.changelog ? (
                            <span style={{ display: 'block', marginTop: '0.35rem', color: 'rgba(255,255,255,0.5)' }}>
                              {String(appUpdateStatus.changelog).slice(0, 160)}
                            </span>
                          ) : null}
                        </p>
                        <motion.button
                          type="button"
                          whileHover={{ scale: 1.03 }}
                          whileTap={{ scale: 0.97 }}
                          onClick={() => window.electronAPI?.updates?.download()}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            padding: '0.75rem 1.5rem',
                            background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
                            border: 'none',
                            borderRadius: '0.75rem',
                            color: 'white',
                            fontSize: '0.95rem',
                            fontWeight: '600',
                            cursor: 'pointer',
                          }}
                        >
                          <Download size={16} />
                          {p('app_update.download')}
                        </motion.button>
                      </div>
                    ) : appUpdateUiPhase === 'error' ? (
                      <p style={{ color: 'rgb(248, 113, 113)', fontSize: '0.875rem', margin: 0 }}>
                        {appUpdateStatus?.message || p('app_update.check_error')}
                      </p>
                    ) : (
                      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '0.75rem' }}>
                        <p style={{ color: 'rgb(52, 211, 153)', margin: 0, fontSize: '0.875rem', display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
                          <CheckCircle size={16} />
                          {p('app_update.up_to_date')}
                        </p>
                        <motion.button
                          type="button"
                          whileHover={{ scale: 1.03 }}
                          whileTap={{ scale: 0.97 }}
                          onClick={() => {
                            setAppUpdateChecking(true);
                            window.electronAPI?.updates?.checkNow().finally(() => setAppUpdateChecking(false));
                          }}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '0.35rem',
                            padding: '0.5rem 1rem',
                            background: 'rgba(255, 255, 255, 0.1)',
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            borderRadius: '0.75rem',
                            color: 'white',
                            fontSize: '0.8rem',
                            cursor: 'pointer',
                          }}
                        >
                          <RefreshCw size={14} />
                          {p('app_update.recheck')}
                        </motion.button>
                      </div>
                    )}

                  </>
                )}
              </motion.div>
              
              {securityMessage.text && (
                <motion.div
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.2 }}
                  style={{
                    padding: '1rem 1.25rem',
                    borderRadius: '0.75rem',
                    marginBottom: '1rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                    background:
                      securityMessage.type === 'success'
                        ? 'rgba(16, 185, 129, 0.1)'
                        : securityMessage.type === 'info'
                          ? 'rgba(59, 130, 246, 0.1)'
                          : 'rgba(239, 68, 68, 0.1)',
                    border: `1px solid ${
                      securityMessage.type === 'success'
                        ? 'rgba(16, 185, 129, 0.3)'
                        : securityMessage.type === 'info'
                          ? 'rgba(59, 130, 246, 0.3)'
                          : 'rgba(239, 68, 68, 0.3)'
                    }`,
                    color:
                      securityMessage.type === 'success'
                        ? 'rgb(52, 211, 153)'
                        : securityMessage.type === 'info'
                          ? 'rgb(96, 165, 250)'
                          : 'rgb(248, 113, 113)',
                  }}
                >
                  {securityMessage.type === 'success' ? (
                    <CheckCircle size={18} />
                  ) : (
                    <AlertCircle size={18} />
                  )}
                  {securityMessage.text}
                </motion.div>
              )}

              {/* Security Card */}
              <motion.div 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: 0.2 }}
                style={{
                  background: 'rgba(255, 255, 255, 0.05)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  borderRadius: '1.5rem',
                  padding: '1.5rem',
                  marginBottom: '1.5rem'
                }}
              >
                <h2 style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '1.25rem', fontWeight: 'bold', color: 'white', marginBottom: '1rem' }}>
                  <Shield size={20} />
                  {t('modules.shared.profile.security')}
                </h2>
                
                {!isChangingPassword ? (
                  <div>
                    <p style={{ color: 'rgba(255, 255, 255, 0.7)', marginBottom: '1rem' }}>{t('modules.shared.profile.password_description')}</p>
                    <motion.button 
                      onClick={() => {
                        setSecurityMessage({ type: '', text: '' });
                        setIsChangingPassword(true);
                      }}
                      whileHover={{ scale: 1.03 }}
                      whileTap={{ scale: 0.97 }}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        padding: '0.75rem 1.5rem',
                        background: 'rgba(255, 255, 255, 0.1)',
                        border: '1px solid rgba(255, 255, 255, 0.2)',
                        borderRadius: '0.75rem',
                        color: 'white',
                        fontSize: '0.95rem',
                        fontWeight: '600',
                        cursor: 'pointer'
                      }}
                    >
                      <Lock size={16} />
                      {t('modules.shared.profile.change_password')}
                    </motion.button>
                  </div>
                ) : (
                  <form onSubmit={isResettingWithCode ? handleCodePasswordReset : handlePasswordSubmit}>
                    {isResettingWithCode && (
                      <p style={{ color: 'rgba(251, 191, 36, 0.95)', marginBottom: '1rem', fontSize: '0.875rem' }}>
                        {p('profile_tab.code_sent_hint')}
                      </p>
                    )}
                    {isResettingWithCode ? (
                      <div style={{ marginBottom: '1rem' }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', fontWeight: '600', color: 'rgba(255, 255, 255, 0.7)', marginBottom: '0.5rem' }}>
                          <AlertCircle size={16} />
                          {p('profile_tab.confirmation_code')}
                        </label>
                        <input
                          type="text"
                          name="resetCode"
                          inputMode="numeric"
                          autoComplete="one-time-code"
                          maxLength={6}
                          value={profileFormData.resetCode}
                          onChange={handleProfileChange}
                          placeholder="123456"
                          required
                          style={{
                            width: '100%',
                            padding: '0.75rem 1rem',
                            background: 'rgba(255, 255, 255, 0.1)',
                            border: '1px solid rgba(251, 191, 36, 0.35)',
                            borderRadius: '0.75rem',
                            color: 'white',
                            fontSize: '1.1rem',
                            letterSpacing: '0.25em',
                            outline: 'none',
                          }}
                        />
                      </div>
                    ) : (
                    <div style={{ marginBottom: '1rem' }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', fontWeight: '600', color: 'rgba(255, 255, 255, 0.7)', marginBottom: '0.5rem' }}>
                        <Lock size={16} />
                        {t('modules.shared.profile.current_password')}
                      </label>
                      <input
                        type="password"
                        name="currentPassword"
                        value={profileFormData.currentPassword}
                        onChange={handleProfileChange}
                        placeholder={p('profile_tab.enter_current_password')}
                        required
                        style={{
                          width: '100%',
                          padding: '0.75rem 1rem',
                          background: 'rgba(255, 255, 255, 0.1)',
                          border: '1px solid rgba(255, 255, 255, 0.2)',
                          borderRadius: '0.75rem',
                          color: 'white',
                          fontSize: '0.95rem',
                          outline: 'none'
                        }}
                      />
                    </div>
                    )}
                    <div style={{ marginBottom: '1rem' }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', fontWeight: '600', color: 'rgba(255, 255, 255, 0.7)', marginBottom: '0.5rem' }}>
                        <Lock size={16} />
                        {t('modules.shared.profile.new_password')}
                      </label>
                      <input
                        type="password"
                        name="newPassword"
                        value={profileFormData.newPassword}
                        onChange={handleProfileChange}
                        placeholder={p('profile_tab.enter_new_password')}
                        required
                        style={{
                          width: '100%',
                          padding: '0.75rem 1rem',
                          background: 'rgba(255, 255, 255, 0.1)',
                          border: '1px solid rgba(255, 255, 255, 0.2)',
                          borderRadius: '0.75rem',
                          color: 'white',
                          fontSize: '0.95rem',
                          outline: 'none'
                        }}
                      />
                    </div>
                    <div style={{ marginBottom: '1.5rem' }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', fontWeight: '600', color: 'rgba(255, 255, 255, 0.7)', marginBottom: '0.5rem' }}>
                        <Lock size={16} />
                        {t('modules.shared.profile.confirm_password')}
                      </label>
                      <input
                        type="password"
                        name="confirmPassword"
                        value={profileFormData.confirmPassword}
                        onChange={handleProfileChange}
                        placeholder={p('profile_tab.confirm_new_password')}
                        required
                        style={{
                          width: '100%',
                          padding: '0.75rem 1rem',
                          background: 'rgba(255, 255, 255, 0.1)',
                          border: '1px solid rgba(255, 255, 255, 0.2)',
                          borderRadius: '0.75rem',
                          color: 'white',
                          fontSize: '0.95rem',
                          outline: 'none'
                        }}
                      />
                    </div>
                    <div style={{ display: 'flex', gap: '0.75rem' }}>
                      <motion.button 
                        type="submit" 
                        whileHover={{ scale: 1.03 }}
                        whileTap={{ scale: 0.97 }}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem',
                          padding: '0.75rem 1.5rem',
                          background: 'linear-gradient(135deg, #10b981, #059669)',
                          border: 'none',
                          borderRadius: '0.75rem',
                          color: 'white',
                          fontSize: '0.95rem',
                          fontWeight: '600',
                          cursor: 'pointer'
                        }}
                      >
                        <CheckCircle size={16} />
                        {isResettingWithCode ? p('profile_tab.reset_with_code') : t('modules.shared.profile.update')}
                      </motion.button>
                      {!isResettingWithCode && (
                      <motion.button 
                        type="button" 
                        onClick={handleForgotPassword}
                        whileHover={{ scale: 1.03 }}
                        whileTap={{ scale: 0.97 }}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem',
                          padding: '0.75rem 1.5rem',
                          background: 'rgba(251, 191, 36, 0.1)',
                          border: '1px solid rgba(251, 191, 36, 0.3)',
                          borderRadius: '0.75rem',
                          color: '#fbbf24',
                          fontSize: '0.875rem',
                          fontWeight: '600',
                          cursor: 'pointer'
                        }}
                      >
                        <AlertCircle size={16} />
                        {p('profile_tab.forgot_password')}
                      </motion.button>
                      )}
                      <motion.button 
                        type="button" 
                        onClick={() => {
                          setIsChangingPassword(false);
                          setIsResettingWithCode(false);
                          setProfileFormData((prev) => ({
                            ...prev,
                            currentPassword: '',
                            newPassword: '',
                            confirmPassword: '',
                            resetCode: '',
                          }));
                        }}
                        whileHover={{ scale: 1.03 }}
                        whileTap={{ scale: 0.97 }}
                        style={{
                          padding: '0.75rem 1.5rem',
                          background: 'rgba(255, 255, 255, 0.1)',
                          border: '1px solid rgba(255, 255, 255, 0.2)',
                          borderRadius: '0.75rem',
                          color: 'white',
                          fontSize: '0.95rem',
                          fontWeight: '600',
                          cursor: 'pointer'
                        }}
                      >
                        {p('common.cancel')}
                      </motion.button>
                    </div>
                  </form>
                )}
              </motion.div>
              
              {/* Cloud Storage Section - Conditional based on license mode */}
              <motion.div 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: 0.25 }}
                style={{
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  borderRadius: '1.5rem',
                  padding: '1.5rem',
                  marginBottom: '1.5rem'
                }}
                className={isOnlineLicense ? 'bg-gradient-to-r from-green-500/10 to-emerald-500/10 border-green-500/30' : 'bg-white/5'}
              >
                <h2 style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '1.25rem', fontWeight: 'bold', color: 'white', marginBottom: '1rem' }}>
                  <Cloud size={20} className={isOnlineLicense ? 'text-green-400' : ''} />
                  {isOnlineLicense ? p('billing.backup.cloud_sync_title') : p('billing.backup.cloud_storage_title')}
                  {isOnlineLicense && (
                    <span className="px-2 py-0.5 bg-green-500/20 text-green-300 text-xs rounded-full ml-2">
                      {p('billing.backup.included_badge')}
                    </span>
                  )}
                  {!isOnlineLicense && (
                    <span className="px-2 py-0.5 bg-amber-500/20 text-amber-300 text-xs rounded-full ml-2">
                      {p('billing.backup.online_mode_available')}
                    </span>
                  )}
                </h2>
                {isOnlineLicense ? (
                  <div>
                    <p style={{ color: 'rgba(255, 255, 255, 0.7)', marginBottom: '1rem' }}>
                      {p('billing.backup.sync_online_desc')}
                    </p>
                    <div className="flex items-center gap-2 text-green-400 text-sm">
                      <CheckCircle className="w-4 h-4" />
                      <span>{p('billing.backup.sync_realtime')}</span>
                    </div>
                  </div>
                ) : (
                  <div>
                    <p style={{ color: 'rgba(255, 255, 255, 0.6)', marginBottom: '1rem' }}>
                      {p('billing.backup.upgrade_online_hint')}
                    </p>
                    <motion.button 
                      onClick={() => setShowChangeKeyModal(true)}
                      whileHover={{ scale: 1.03 }}
                      whileTap={{ scale: 0.97 }}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        padding: '0.75rem 1.5rem',
                        background: 'linear-gradient(to right, #2563eb, #06b6d4)',
                        border: 'none',
                        borderRadius: '0.75rem',
                        color: 'white',
                        fontSize: '0.95rem',
                        fontWeight: '600',
                        cursor: 'pointer'
                      }}
                    >
                      <Key size={16} />
                      {p('billing.backup.change_key')}
                    </motion.button>
                  </div>
                )}
              </motion.div>
              
              {/* Logout Card */}
              <motion.div 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: 0.3 }}
                style={{
                  background: 'rgba(255, 255, 255, 0.05)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  borderRadius: '1.5rem',
                  padding: '1.5rem'
                }}
              >
                <h2 style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '1.25rem', fontWeight: 'bold', color: 'white', marginBottom: '1rem' }}>
                  <LogOut size={20} />
                  {p('billing.backup.logout_title')}
                </h2>
                <p style={{ color: 'rgba(255, 255, 255, 0.7)', marginBottom: '1rem' }}>{p('billing.backup.logout_hint')}</p>
                <motion.button 
                  onClick={handleLogout}
                  whileHover={{ scale: 1.03 }}
                  whileTap={{ scale: 0.97 }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    padding: '0.75rem 1.5rem',
                    background: 'linear-gradient(135deg, #ef4444, #dc2626)',
                    border: 'none',
                    borderRadius: '0.75rem',
                    color: 'white',
                    fontSize: '0.95rem',
                    fontWeight: '600',
                    cursor: 'pointer'
                  }}
                >
                  <LogOut size={16} />
                  {t('common.logout')}
                </motion.button>
              </motion.div>
            </div>
          )}

          {/* {p('audit_tab.title')} */}
          {activeTab === 'audit' && (
            <div className={`space-y-3 employees-container`}>
              {/* Header */}
              <div className="flex justify-between items-center">
                <div>
                  <h1 className="text-3xl font-bold text-white flex items-center gap-3">
                    <ClipboardList className="h-8 w-8 text-blue-400" />
                    {p('audit_tab.title')}
                    <button onClick={loadAuditLogs} className="refresh-button"><RefreshCw size={20} /></button>
                  </h1>
                  <p className="text-white/60 mt-2">{p('audit_tab.subtitle')}</p>
                </div>
              </div>

              {/* Stats Cards - GPS Glow Effect */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-6">
                {[
                  { title: p('audit_tab.stat_total_actions'), value: auditLogs.length, icon: Activity, color: 'from-blue-500 to-blue-600' },
                  { title: p('audit_tab.stat_logins'), value: auditStats.loginAttempts || 0, icon: UserCheck, color: 'from-green-500 to-green-600' },
                  { title: p('audit_tab.stat_modifications'), value: auditStats.userActions || 0, icon: Edit, color: 'from-purple-500 to-purple-600' },
                  { title: p('audit.filters.errors'), value: auditStats.errors || 0, icon: AlertCircle, color: 'from-red-500 to-red-600' },
                  { title: p('audit_tab.stat_notifications'), value: 0, icon: Activity, color: 'from-amber-500 to-amber-600' }
                ].map((stat, i) => (
                  <motion.div key={i} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.1 }} className="relative group">
                    <div className={`absolute -inset-0.5 bg-gradient-to-r ${stat.color} rounded-3xl opacity-0 group-hover:opacity-50 transition-opacity duration-500 blur-sm`}></div>
                    <div className="relative bg-white/10 backdrop-blur-lg rounded-3xl p-6 border border-white/20">
                      <div className="flex items-center justify-between">
                        <div><p className="text-white/60 text-sm font-medium">{stat.title}</p><p className="text-2xl font-bold text-white force-white mt-2">{stat.value}</p></div>
                        <div className="relative">
                          <div className={`absolute inset-0 bg-gradient-to-br ${stat.color} rounded-2xl opacity-0 group-hover:opacity-20 transition-opacity duration-300 blur-lg`}></div>
                          <div className={`relative p-3 rounded-2xl bg-gradient-to-r ${stat.color}`}><stat.icon className="h-6 w-6 text-white force-white" /></div>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>

              {/* Options Avancées Section */}
              <motion.div initial={false} animate={{ height: showAdvancedOptions ? "auto" : 0, opacity: showAdvancedOptions ? 1 : 0 }} transition={{ duration: 0.3, ease: "easeInOut" }} style={{ overflow: "hidden" }}>
                <div className="space-y-4 pt-4">
                  <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-2 border border-white/20">
                    <div className="flex space-x-1 overflow-x-auto table-scroll">
                      {[
                        { id: 'all_logs', name: p('audit_tab.view_general'), icon: LayoutGrid },
                        { id: 'by_type', name: p('audit_tab.view_by_type'), icon: Shield },
                        { id: 'by_user', name: p('audit.filters.by_user'), icon: Users },
                        { id: 'by_status', name: p('audit_tab.view_by_status'), icon: TrendingUp }
                      ].map((tab) => (
                        <button key={tab.id} onClick={() => setMainViewMode(tab.id)} className={`flex-1 flex items-center justify-center space-x-2 px-4 py-3 rounded-2xl font-medium transition-all duration-300 ${mainViewMode === tab.id ? 'bg-gradient-to-r from-blue-500 to-blue-700 text-white shadow-lg shadow-blue-500/30' : 'text-white/80 hover:bg-white/10 hover:text-white'}`}>
                          <tab.icon className="h-5 w-5" /><span className="hidden sm:inline whitespace-nowrap">{tab.name}</span>
                        </button>
                      ))}
                    </div>
                  </div>
                  {mainViewMode === 'all_logs' && (
                    <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-2 border border-white/20">
                      <div className="flex space-x-1 overflow-x-auto table-scroll">
                        {[
                          { id: 'all', name: p('audit.filters.all'), icon: Layers },
                          { id: 'success', name: p('audit.filters.success'), icon: CheckCircle },
                          { id: 'error', name: p('audit_tab.errors_label'), icon: XCircle },
                          { id: 'warning', name: p('audit_tab.warnings_label'), icon: AlertTriangle }
                        ].map((filter) => (
                          <button key={filter.id} onClick={() => setQuickFilter(filter.id)} className={`flex-1 flex items-center justify-center space-x-2 px-4 py-3 rounded-2xl font-medium transition-all duration-300 ${quickFilter === filter.id ? 'bg-gradient-to-r from-blue-500 to-blue-700 text-white shadow-lg shadow-blue-500/30' : 'text-white/80 hover:bg-white/10 hover:text-white'}`}>
                            <filter.icon className="h-5 w-5" /><span className="hidden sm:inline whitespace-nowrap">{filter.name}</span>
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="bg-white/10 backdrop-blur-lg rounded-3xl p-6 border border-white/20">
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-xl font-semibold text-white">{p('audit_tab.distribution_title')}</h3>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
                      {[
                        { name: p("audit_tab.status_success"), count: auditLogs.filter(l => l.level === 'success').length, color: "bg-gradient-to-r from-green-500 to-green-600" },
                        { name: p("audit_tab.errors_label"), count: auditLogs.filter(l => l.level === 'error' || l.level === 'critical').length, color: "bg-gradient-to-r from-red-500 to-red-600" },
                        { name: p("audit_tab.warnings_label"), count: auditLogs.filter(l => l.level === 'warning').length, color: "bg-gradient-to-r from-yellow-500 to-yellow-600" },
                        { name: p("audit.levels.info"), count: auditLogs.filter(l => l.level === 'info').length, color: "bg-gradient-to-r from-blue-500 to-blue-600" }
                      ].map((item) => {
                        const total = auditLogs.length;
                        return (
                          <button key={item.name} onClick={() => {}} className="bg-white/5 rounded-xl p-4 border transition-all cursor-pointer text-left border-white/10 hover:border-white/20 hover:bg-white/10">
                            <div className="flex justify-between items-center mb-2">
                              <h4 className="font-medium text-white/80">{item.name}</h4>
                              <div className={`text-sm rounded-full px-2 py-0.5 ${item.color} text-white force-white font-semibold`}>{item.count}</div>
                            </div>
                            <div className="w-full bg-white/10 h-3 rounded-full overflow-hidden">
                              <div className={`h-3 rounded-full ${item.color} transition-all`} style={{ width: `${total > 0 ? (item.count / total * 100).toFixed(1) : 0}%` }}></div>
                            </div>
                            <p className="mt-2 text-sm text-white/60">{p('common.percent_of_total', { percent: total > 0 ? (item.count / total * 100).toFixed(1) : 0 })}</p>
                          </button>
                        );
                      })}
                    </div>
                  </motion.div>
                </div>
              </motion.div>

              {/* Filters */}
              <div className="bg-white/10 backdrop-blur-lg rounded-3xl border border-white/20 overflow-hidden">
                <div className="p-4 border-b border-white/10">
                  <div className="flex flex-col lg:flex-row gap-4 items-center justify-between">
                    <div className="relative flex-1 max-w-md">
                      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-white/50" />
                      <input type="text" placeholder={p('common.search')} value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 bg-white/10 border border-white/20 rounded-xl text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    </div>
                    <div className="flex items-center gap-2 flex-wrap ml-auto">
                      <div className="flex items-center gap-0">
                        <button onClick={() => setViewMode('cards')} className={`px-3 py-2 border border-white/20 transition-all ${viewMode === 'cards' ? 'bg-blue-500/20 text-blue-300 border-blue-500/30' : 'bg-white/5 text-white hover:text-white/90 hover:border-white/30'} rounded-l-lg border-r-0`}>
                          <LayoutList size={18} />
                        </button>
                        <button onClick={() => setViewMode('table')} className={`px-3 py-2 border border-white/20 transition-all ${viewMode === 'table' ? 'bg-blue-500/20 text-blue-300 border-blue-500/30' : 'bg-white/5 text-white hover:text-white/90 hover:border-white/30'} rounded-r-lg`}>
                          <List size={18} />
                        </button>
                      </div>
                      
                      <div className="relative" ref={statusFilterRef}>
                        <button 
                          onClick={() => setIsStatusFilterOpen(!isStatusFilterOpen)} 
                          className="flex items-center gap-2 px-4 py-2 border border-white/20 rounded-lg text-white hover:border-white/30 transition-all bg-white/5"
                        >
                          <Filter size={18} className="text-white/80" />
                          <span className="text-white font-medium text-sm">{p('audit_tab.filter_type')}</span>
                          <ChevronDown size={14} className={`text-white/70 transition-transform ${isStatusFilterOpen ? 'rotate-180' : ''}`} />
                        </button>
                        {isStatusFilterOpen && (
                          <div 
                            className="border border-blue-400/60 rounded-2xl shadow-2xl min-w-[200px]" 
                            style={{ position: 'absolute', top: 'calc(100% + 8px)', right: 0, zIndex: 99999, backgroundImage: 'linear-gradient(to bottom right, rgb(51, 65, 85), rgb(29, 71, 196), rgb(51, 65, 85))', boxShadow: '0 8px 32px rgba(59, 130, 246, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.2)' }}
                          >
                            <div className="p-2">
                              {[
                                { value: '', label: p('audit_tab.filter_all_actions'), icon: Filter },
                                { value: 'login', label: p('audit_tab.filter_logins'), icon: UserCheck },
                                { value: 'document', label: p('audit_tab.filter_documents'), icon: FileText },
                                { value: 'error', label: p('audit_tab.errors_label'), icon: AlertCircle }
                              ].map((option) => (
                                <button
                                  key={option.value}
                                  onClick={() => {
                                    handleAuditFilterChange('actionType', option.value);
                                    setIsStatusFilterOpen(false);
                                  }}
                                  className={`w-full px-4 py-2.5 text-left transition-colors flex items-center gap-3 rounded-xl ${auditFilters.actionType === option.value ? 'bg-blue-500/20 text-white' : 'text-white/90 hover:bg-blue-500/20'}`}
                                >
                                  <option.icon size={16} className="text-white/50" />
                                  <span className="text-sm font-medium">{option.label}</span>
                                </button>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                      
                      <div className="relative" ref={dateRangeRef}>
                        <button 
                          onClick={() => { setIsDateRangeOpen(!isDateRangeOpen); }} 
                          className="flex items-center gap-2 px-4 py-2 border border-white/20 rounded-lg text-white hover:border-white/30 transition-all bg-white/5"
                        >
                          <Calendar size={18} className="text-white/80" /><span className="text-white font-medium text-sm">{p('audit_tab.filter_period')}</span><ChevronDown size={14} className={`text-white/70 transition-transform ${isDateRangeOpen ? 'rotate-180' : ''}`} />
                        </button>
                        {isDateRangeOpen && (
                          <div 
                            className="border border-blue-400/60 rounded-2xl shadow-2xl min-w-[320px]" 
                            style={{ position: 'absolute', top: 'calc(100% + 8px)', right: 0, zIndex: 99999, backgroundImage: 'linear-gradient(to bottom right, rgb(51, 65, 85), rgb(29, 71, 196), rgb(51, 65, 85))', boxShadow: '0 8px 32px rgba(59, 130, 246, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.2)', overflow: 'visible' }}
                          >
                            <div className="p-4" style={{ overflow: 'visible' }}>
                              <div className="flex flex-col gap-3" style={{ overflow: 'visible' }}>
                                <div className="grid grid-cols-2 gap-3" style={{ overflow: 'visible' }}>
                                  <div style={{ overflow: 'visible' }}>
                                    <label className="text-white/80 text-xs mb-1.5 block w-full font-medium text-right">{p('audit_tab.start_date')}</label>
                                    <CustomDatePicker
                                      value={auditFilters.startDate}
                                      onChange={(dateString) => handleAuditFilterChange('startDate', dateString)}
                                      placeholder={p('common.select')}
                                    />
                                  </div>
                                  <div style={{ overflow: 'visible' }}>
                                    <label className="text-white/80 text-xs mb-1.5 block w-full font-medium text-right">{p('audit_tab.end_date')}</label>
                                    <CustomDatePicker
                      value={auditFilters.endDate}
                                      onChange={(dateString) => handleAuditFilterChange('endDate', dateString)}
                                      placeholder={p('common.select')}
                    />
                  </div>
                </div>
                                <div className="flex gap-2 pt-2 border-t border-blue-400/30">
                                  <button onClick={() => { handleAuditFilterChange('startDate', ''); handleAuditFilterChange('endDate', ''); }} className="flex-1 px-3 py-2 bg-white/5 hover:bg-blue-500/20 text-white/80 hover:text-white rounded-xl text-sm transition-all font-medium">{p('common.reset')}</button>
                                  <button onClick={() => setIsDateRangeOpen(false)} className="flex-1 px-3 py-2 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white rounded-xl text-sm transition-all font-medium shadow-lg shadow-blue-500/30">{p('common.apply')}</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
              </div>

                      {selectedRecords.length > 0 && (
                        <button onClick={handleBulkDelete} className="flex items-center gap-2 px-3 py-2 bg-red-500/20 hover:bg-red-500/30 border border-red-500/30 text-red-200 rounded-lg transition-all text-sm font-medium">
                          <Trash2 size={16} /><span className="hidden sm:inline">{p('common.delete_selected', { count: selectedRecords.length })}</span>
                        </button>
                      )}
                      
                      <div className="relative" ref={importDropdownRef}>
                        <button onClick={() => { setShowImportDropdown(!showImportDropdown); setShowExportDropdown(false); }} className="bg-orange-500/20 hover:bg-orange-500/30 text-orange-200 border border-orange-500/30 px-3 py-2 rounded-lg transition-all duration-200 flex items-center gap-1.5">
                          <Upload size={16} /><span className="text-sm font-medium">{t('common.import')}</span><ChevronDown size={14} className={`transition-transform ${showImportDropdown ? 'rotate-180' : ''}`} />
                        </button>
                        {showImportDropdown && (
                          <div className="border border-blue-400/60 rounded-2xl shadow-2xl min-w-[120px]" style={{ position: 'absolute', top: 'calc(100% + 8px)', right: 0, zIndex: 99999, backgroundImage: 'linear-gradient(to bottom right, rgb(51, 65, 85), rgb(29, 71, 196), rgb(51, 65, 85))', boxShadow: '0 8px 32px rgba(59, 130, 246, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.2)' }}>
                            <div className="p-2">
                              <button className="w-full px-4 py-2.5 text-left text-white/90 hover:bg-blue-500/20 transition-colors flex items-center gap-3 rounded-xl"><FileText size={16} className="text-red-400" /><span className="text-sm font-medium">{p('common.csv')}</span></button>
                              <button className="w-full px-4 py-2.5 text-left text-white/90 hover:bg-blue-500/20 transition-colors flex items-center gap-3 rounded-xl"><FileSpreadsheet size={16} className="text-green-400" /><span className="text-sm font-medium">{p('common.excel')}</span></button>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="relative" ref={exportDropdownRef}>
                        <button onClick={() => { setShowExportDropdown(!showExportDropdown); setShowImportDropdown(false); }} className="bg-green-500/20 hover:bg-green-500/30 text-green-200 border border-green-500/30 px-3 py-2 rounded-lg transition-all duration-200 flex items-center gap-1.5">
                          <Download size={16} /><span className="text-sm font-medium">{t('common.export')}</span><ChevronDown size={14} className={`transition-transform ${showExportDropdown ? 'rotate-180' : ''}`} />
                        </button>
                        {showExportDropdown && (
                          <div className="border border-blue-400/60 rounded-2xl shadow-2xl min-w-[120px]" style={{ position: 'absolute', top: 'calc(100% + 8px)', right: 0, zIndex: 99999, backgroundImage: 'linear-gradient(to bottom right, rgb(51, 65, 85), rgb(29, 71, 196), rgb(51, 65, 85))', boxShadow: '0 8px 32px rgba(59, 130, 246, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.2)' }}>
                            <div className="p-2">
                              <button onClick={handleExportAuditLogs} className="w-full px-4 py-2.5 text-left text-white/90 hover:bg-blue-500/20 transition-colors flex items-center gap-3 rounded-xl"><FileText size={16} className="text-blue-400" /><span className="text-sm font-medium">{p('common.pdf')}</span></button>
                              <button onClick={handleExportAuditLogs} className="w-full px-4 py-2.5 text-left text-white/90 hover:bg-blue-500/20 transition-colors flex items-center gap-3 rounded-xl"><FileSpreadsheet size={16} className="text-green-400" /><span className="text-sm font-medium">{p('common.excel')}</span></button>
                              <button onClick={handleExportAuditLogs} className="w-full px-4 py-2.5 text-left text-white/90 hover:bg-blue-500/20 transition-colors flex items-center gap-3 rounded-xl"><FileOutput size={16} className="text-purple-400" /><span className="text-sm font-medium">{p('common.csv')}</span></button>
                            </div>
                          </div>
                        )}
                      </div>

                      <button 
                        onClick={handleClearAuditLogs}
                        className="bg-gradient-to-r from-red-600 to-red-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:shadow-lg hover:shadow-red-500/30 transition-all font-semibold"
                      >
                        <Trash2 size={16} />
                        <span className="text-sm">{p('audit_tab.clear_logs')}</span>
                      </button>
                    </div>
                  </div>
                </div>

                {viewMode === 'table' && (
                <div className="overflow-x-auto">
                    <table className="w-full employees-table data-table">
                    <thead className="bg-white/5">
                      <tr>
                          <th className="px-3 py-4 text-center text-white font-semibold"><button onClick={handleSelectAll} className="text-white/70 hover:text-white transition-colors">{selectAll ? <CheckSquare size={20} /> : <Square size={20} />}</button></th>
                          <th className="px-6 py-4 text-left text-white font-semibold">
                            <button onClick={(e) => handleSort('timestamp', e)} className="flex items-center gap-2 hover:text-blue-300 transition-colors">
                              <span>{p('audit_tab.col_timestamp')}</span>
                              {(() => {
                                const sortInfo = getSortInfo('timestamp');
                                if (sortInfo) {
                                  return (
                                    <span className="flex items-center gap-1">
                                      {sortInfo.direction === 'asc' ? <ArrowUp size={16} className="text-blue-400" /> : <ArrowDown size={16} className="text-blue-400" />}
                                      {sortInfo.isMulti && <span className="text-xs bg-blue-500 text-white rounded-full w-4 h-4 flex items-center justify-center font-bold">{sortInfo.order}</span>}
                                    </span>
                                  );
                                }
                                return <ArrowUpDown size={16} className="text-white/30" />;
                              })()}
                            </button>
                          </th>
                          <th className="px-6 py-4 text-left text-white font-semibold">{p('audit_tab.col_user')}</th>
                          <th className="px-6 py-4 text-left text-white font-semibold">{p('audit_tab.col_action')}</th>
                          <th className="px-6 py-4 text-left text-white font-semibold">{p('audit_tab.col_resource')}</th>
                          <th className="px-6 py-4 text-left text-white font-semibold">{p('audit_tab.col_details')}</th>
                          <th className="px-6 py-4 text-center text-white font-semibold">{p('audit_tab.col_status')}</th>
                          <th className="px-6 py-4 text-center text-white font-semibold">{p('audit_tab.col_actions')}</th>
                      </tr>
                    </thead>
                      <tbody className="divide-y divide-white/10 employees-table-body">
                        {auditLogs.length > 0 ? (
                          auditLogs.slice(0, 10).map((log, index) => {
                        const getActionIcon = (action) => {
                          if (!action || typeof action !== 'string') return Activity;
                          if (action.includes('document')) return FileCheck;
                          if (action.includes('login') || action.includes('user')) return UserCheck;
                          if (action.includes('settings') || action.includes('config')) return Edit;
                          if (action.includes('backup')) return Database;
                          if (action.includes('download') || action.includes('export')) return Download;
                          if (action.includes('error')) return AlertCircle;
                          return Activity;
                        };

                        const getStatusFromLevel = (level) => {
                          switch (level) {
                            case 'success': return 'success';
                            case 'error': case 'critical': return 'error';
                            case 'warning': return 'warning';
                            default: return 'success';
                          }
                        };

                        const ActionIcon = getActionIcon(log.action);
                        const status = getStatusFromLevel(log.level);

                        return (
                              <tr key={log.id || index} className={`hover:bg-white/5 transition-colors ${selectedRecords.includes(log.id) ? 'bg-white/10' : ''}`}>
                                <td className="px-3 py-4 text-center"><button onClick={() => handleSelectRecord(log.id)} className="text-white/70 hover:text-white transition-colors">{selectedRecords.includes(log.id) ? <CheckSquare size={18} /> : <Square size={18} />}</button></td>
                                <td className="px-6 py-4">
                                  <div className="flex flex-col">
                                    <div className="flex items-center gap-1.5 text-white font-semibold">
                                      <Clock size={14} className="text-white/50" />
                                      {formatArSaDate(log.timestamp)}
                                    </div>
                                    <span className="text-white/50 text-xs mt-0.5">
                            {formatArSaDate(log.timestamp)}
                                    </span>
                                  </div>
                          </td>
                                <td className="px-6 py-4"><span className="text-white font-semibold">{log.user?.name || log.user || p('audit_tab.system_user')}</span></td>
                                <td className="px-6 py-4">
                                  <div className="flex flex-col">
                            <div className="flex items-center gap-2">
                                      <ActionIcon size={16} className="text-blue-400" />
                                      <span className="text-white font-semibold">{translateAction(log.action)}</span>
                                    </div>
                            </div>
                          </td>
                                <td className="px-6 py-4"><span className="text-white/70 text-sm">{translateResource(log.resource)}</span></td>
                                <td className="px-6 py-4 max-w-xs"><span className="text-white/60 text-sm truncate block">{translateDetails(log.details)}</span></td>
                                <td className="px-6 py-4 text-center">
                                  <div className="flex justify-center">
                                    <span className={`px-3 py-1.5 rounded-full text-xs font-medium flex items-center gap-1.5 border ${
                                      status === 'success' ? 'bg-green-500/20 text-green-400 border-green-500/30' :
                                      status === 'error' ? 'bg-red-500/20 text-red-400 border-red-500/30' :
                                      'bg-yellow-500/20 text-yellow-400 border-yellow-500/30'
                                    }`}>
                                      {status === 'success' ? <CheckCircle size={14} /> : status === 'error' ? <XCircle size={14} /> : <AlertTriangle size={14} />}
                              {status === 'success' ? p('audit_tab.status_success') : status === 'error' ? p('audit_tab.status_error') : p('audit_tab.status_warning')}
                            </span>
                                  </div>
                          </td>
                                <td className="px-6 py-4">
                                  <div className="flex items-center justify-center gap-1">
                                    <button 
                                      onClick={() => {
                                        setSelectedAuditLogForView(log);
                                        setShowAuditDetailsModal(true);
                                      }}
                                      className="p-1.5 transition-colors" 
                                      title={p('common.view')}
                                    >
                                      <Eye size={16} className="text-blue-400 hover:text-blue-300" />
                                    </button>
                                    <button className="p-1.5 transition-colors" title={p('common.delete')}><Trash2 size={16} className="text-red-400 hover:text-red-300" /></button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr><td colSpan="8" className="text-center py-12 text-white/60"><ClipboardList size={48} className="mx-auto mb-4 text-white/30" /><p className="text-lg">{p('audit_tab.no_logs', 'لا توجد سجلات')}</p></td></tr>
                        )}
                    </tbody>
                      <tfoot>
                        <tr className="bg-white/5 border-t border-white/10">
                          <td colSpan="8" className="px-6 py-4">
                            <div className="flex items-center justify-between text-white/70 text-sm">
                              <span>{auditLogs.length} logs total</span>
                              <span>{p('audit_tab.errors_count', { count: auditLogs.filter(l => l.level === 'error' || l.level === 'critical').length })}</span>
                              <span>{p('audit_tab.success_count', { count: auditLogs.filter(l => l.level === 'success').length })}</span>
                            </div>
                          </td>
                        </tr>
                      </tfoot>
                  </table>
                </div>
                )}

                {viewMode === 'cards' && (
                  <div className="p-6 space-y-4">
                    {auditLogs.length > 0 ? (
                      auditLogs.slice(0, 10).map((log, index) => (
                        <motion.div key={log.id || index} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: index * 0.05 }} className="bg-white/[0.03] rounded-2xl p-6 border border-white/20 hover:border-white/40 hover:bg-white/[0.05] transition-all">
                          <div className="flex items-start justify-between">
                            <div className="flex-1">
                              <div className="flex items-center space-x-4 mb-4">
                                <h3 className="text-xl font-bold text-white flex items-center gap-2">
                                  <Activity size={20} className="text-emerald-400" />
                                  {translateAction(log.action)}
                                </h3>
                                <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                                  log.level === 'success' ? 'bg-green-500/20 text-green-300' :
                                  log.level === 'error' ? 'bg-red-500/20 text-red-300' :
                                  'bg-yellow-500/20 text-yellow-300'
                                }`}>
                                  {translateLevel(log.level)}
                                </span>
                    </div>
                              
                              <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
                                <div>
                                  <h5 className="font-medium text-white mb-2">{p('audit_tab.col_timestamp')}</h5>
                                  <div className="space-y-1 text-sm text-white/70">
                                    <div><span className="font-medium">{p('audit.col_date')}:</span> {formatArSaDate(log.timestamp)}</div>
                    </div>
                  </div>
                                <div>
                                  <h5 className="font-medium text-white mb-2">{p('audit_tab.col_user')}</h5>
                                  <div className="space-y-1 text-sm text-white/70">
                                    <div><span className="font-medium">{p('audit_tab.label_name')}</span> {log.user?.name || log.user || p('audit_tab.system_user')}</div>
                </div>
              </div>
                                <div>
                                  <h5 className="font-medium text-white mb-2">{p('audit_tab.col_resource')}</h5>
                                  <div className="space-y-1 text-sm text-white/70">
                                    <div><span className="font-medium">{p('audit_tab.label_target')}</span> {translateResource(log.resource)}</div>
                                  </div>
                                </div>
                                <div>
                                  <h5 className="font-medium text-white mb-2">{p('audit_tab.col_details')}</h5>
                                  <div className="space-y-1 text-sm text-white/70">
                                    <div>{translateDetails(log.details)}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            <div className="flex gap-1 ml-4">
                              <button 
                                onClick={() => {
                                  setSelectedAuditLogForView(log);
                                  setShowAuditDetailsModal(true);
                                }}
                                className="p-1.5 text-blue-400 hover:text-blue-300 transition-colors" 
                                title={p('common.view')}
                              >
                                <Eye className="h-4 w-4" />
                              </button>
                              <button className="p-1.5 text-red-400 hover:text-red-300 transition-colors" title={p('common.delete')}><Trash2 className="h-4 w-4" /></button>
                            </div>
                          </div>
                        </motion.div>
                      ))
                    ) : (
                      <div className="text-center py-12"><ClipboardList size={48} className="mx-auto mb-4 text-white/30" /><p className="text-white/60 text-lg">{p('audit_tab.no_logs', 'لا توجد سجلات')}</p></div>
                    )}
                  </div>
                )}
              </div>

              {/* Audit Log Details Modal */}
              {showAuditDetailsModal && selectedAuditLogForView && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  className="fixed inset-0 bg-black/20 backdrop-blur-md flex items-center justify-center z-[99999] p-4"
                  onClick={() => {
                    setShowAuditDetailsModal(false);
                    setSelectedAuditLogForView(null);
                  }}
                >
                  <motion.div
                    initial={{ scale: 0.95, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.95, opacity: 0 }}
                    transition={{ duration: 0.2 }}
                    onClick={(e) => e.stopPropagation()}
                    className="bg-gradient-to-br from-slate-800 via-blue-750 to-slate-800 backdrop-blur-lg border-2 border-blue-400/60 rounded-2xl p-6 max-h-[90vh] overflow-y-auto"
                    style={{
                      boxShadow: '0 0 40px rgba(59, 130, 246, 0.4), 0 0 80px rgba(59, 130, 246, 0.2)',
                      width: '95%',
                      maxWidth: '950px'
                    }}
                  >
                    {/* Header */}
                    <div className="flex justify-between items-center mb-6">
                      <h2 className="text-2xl font-bold text-white">{p('audit_tab.log_detail_title')}</h2>
                      <button
                        onClick={() => {
                          setShowAuditDetailsModal(false);
                          setSelectedAuditLogForView(null);
                        }}
                        className="text-white/70 hover:text-white transition-colors"
                      >
                        <X size={24} />
                      </button>
                    </div>

                    {/* Content */}
                    <div className="space-y-4">
                      {/* Action & Status */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="bg-white/5 rounded-xl p-5 border border-white/20">
                          <div className="flex items-start gap-3">
                            <Activity size={20} className="text-blue-400 flex-shrink-0 mt-1" />
                            <div className="flex-1 min-w-0">
                              <p className="text-sm text-white/60 mb-1">{p('audit_tab.col_action')}</p>
                              <p className="text-white font-semibold break-words">{translateAction(selectedAuditLogForView.action)}</p>
                            </div>
                          </div>
                        </div>

                        <div className="bg-white/5 rounded-xl p-5 border border-white/20">
                          <div className="flex items-start gap-3">
                            <Tag size={20} className="text-purple-400 flex-shrink-0 mt-1" />
                            <div>
                              <p className="text-sm text-white/60 mb-1">{p('audit_tab.col_status')}</p>
                              <span className={`inline-flex px-3 py-1 rounded-full text-sm font-semibold ${
                                selectedAuditLogForView.level === 'success' 
                                  ? 'bg-green-500/20 text-green-300 border border-green-500/30' 
                                  : selectedAuditLogForView.level === 'error' || selectedAuditLogForView.level === 'critical'
                                  ? 'bg-red-500/20 text-red-300 border border-red-500/30'
                                  : 'bg-yellow-500/20 text-yellow-300 border border-yellow-500/30'
                              }`}>
                              {selectedAuditLogForView.level === 'success' ? p('audit_tab.status_success') : 
                               selectedAuditLogForView.level === 'error' || selectedAuditLogForView.level === 'critical' ? p('audit_tab.status_error') : 
                               translateLevel(selectedAuditLogForView.level)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Date & Time */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="bg-white/5 rounded-xl p-5 border border-white/20">
                          <div className="flex items-start gap-3">
                            <Calendar size={20} className="text-green-400 flex-shrink-0 mt-1" />
                            <div>
                              <p className="text-sm text-white/60 mb-1">{t('common.date')}</p>
                              <p className="text-white font-semibold">
                                {new Date(selectedAuditLogForView.timestamp).toLocaleDateString(getBrandLocale(i18n.language), {
                                  day: '2-digit',
                                  month: 'long',
                                  year: 'numeric'
                                })}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="bg-white/5 rounded-xl p-5 border border-white/20">
                          <div className="flex items-start gap-3">
                            <Clock size={20} className="text-orange-400 flex-shrink-0 mt-1" />
                            <div>
                              <p className="text-sm text-white/60 mb-1">{p('audit_tab.col_time')}</p>
                              <p className="text-white font-semibold">
                                {new Date(selectedAuditLogForView.timestamp).toLocaleTimeString(getBrandLocale(i18n.language))}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* User & Resource */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="bg-white/5 rounded-xl p-5 border border-white/20">
                          <div className="flex items-start gap-3">
                            <User size={20} className="text-cyan-400 flex-shrink-0 mt-1" />
                            <div className="flex-1 min-w-0">
                              <p className="text-sm text-white/60 mb-1">{p('audit_tab.col_user')}</p>
                              <p className="text-white font-semibold">{selectedAuditLogForView.user?.name || selectedAuditLogForView.user || p('audit_tab.system_user')}</p>
                              {selectedAuditLogForView.user?.email && (
                                <p className="text-white/50 text-sm mt-1">{selectedAuditLogForView.user.email}</p>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="bg-white/5 rounded-xl p-5 border border-white/20">
                          <div className="flex items-start gap-3">
                            <Folder size={20} className="text-yellow-400 flex-shrink-0 mt-1" />
                            <div className="flex-1 min-w-0">
                              <p className="text-sm text-white/60 mb-1">{p('audit_tab.col_resource')}</p>
                              <p className="text-white font-semibold break-words">{translateResource(selectedAuditLogForView.resource)}</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Details */}
                      <div className="bg-white/5 rounded-xl p-5 border border-white/20">
                        <div className="flex items-start gap-3">
                          <FileText size={20} className="text-pink-400 flex-shrink-0 mt-1" />
                          <div className="flex-1 min-w-0">
                            <p className="text-sm text-white/60 mb-2">{p('audit_tab.col_details')}</p>
                            <p className="text-white/80 text-sm leading-relaxed break-words">
                              {translateDetails(selectedAuditLogForView.details) || p('audit.no_detail')}
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Session & IP Info */}
                      <div className="grid grid-cols-2 gap-4">
                        {selectedAuditLogForView.sessionId && (
                          <div className="bg-white/5 rounded-xl p-5 border border-white/20">
                            <div className="flex items-start gap-3">
                              <Key size={18} className="text-indigo-400 flex-shrink-0 mt-1" />
                              <div className="flex-1 min-w-0">
                                <p className="text-xs text-white/60 mb-1">{p('audit_tab.col_session_id')}</p>
                                <p className="text-white/70 font-mono text-xs break-all">{selectedAuditLogForView.sessionId}</p>
                              </div>
                            </div>
                          </div>
                        )}

                        {selectedAuditLogForView.ipAddress && (
                          <div className="bg-white/5 rounded-xl p-5 border border-white/20">
                            <div className="flex items-start gap-3">
                              <Globe size={18} className="text-teal-400 flex-shrink-0 mt-1" />
                              <div>
                                <p className="text-xs text-white/60 mb-1">{p('audit_tab.col_ip_address')}</p>
                                <p className="text-white/70 font-mono text-xs">{selectedAuditLogForView.ipAddress}</p>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* User Agent */}
                      {selectedAuditLogForView.userAgent && (
                        <div className="bg-white/5 rounded-xl p-5 border border-white/20">
                          <div className="flex items-start gap-3">
                            <Activity size={18} className="text-gray-400 flex-shrink-0 mt-1" />
                            <div className="flex-1 min-w-0">
                              <p className="text-xs text-white/60 mb-1">{p('audit_tab.col_user_agent')}</p>
                              <p className="text-white/50 font-mono text-xs break-all leading-relaxed">
                                {selectedAuditLogForView.userAgent}
                              </p>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Action Button */}
                      <div className="flex gap-3 pt-2">
                        <button
                          onClick={() => {
                            setShowAuditDetailsModal(false);
                            setSelectedAuditLogForView(null);
                          }}
                          className="w-full px-6 py-3 rounded-xl bg-white/10 text-white hover:bg-white/20 transition-all duration-200 font-semibold flex items-center justify-center gap-2"
                        >
                          {t('common.close')}
                        </button>
                      </div>
                    </div>
                  </motion.div>
                </motion.div>
              )}
            </div>
          )}

      </div>

      {showLicenseKey && createPortal(
        <div
          className="fixed inset-0 bg-black/20 backdrop-blur-md flex items-center justify-center z-[99999] p-4"
          onClick={() => setShowLicenseKey(false)}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className={`backdrop-blur-lg rounded-2xl max-h-[90vh] flex flex-col overflow-hidden ${isDashboardLightMode ? 'qawaem-modal-light border' : 'border-2 border-blue-400/60 bg-gradient-to-br from-slate-800 via-blue-750 to-slate-800'}`}
            style={isDashboardLightMode ? { boxShadow: '0 10px 40px rgba(15, 23, 42, 0.12), 0 0 0 1px rgba(15, 23, 42, 0.06)', width: '90%', maxWidth: '720px' } : { boxShadow: '0 0 40px rgba(59, 130, 246, 0.4), 0 0 80px rgba(59, 130, 246, 0.2)', width: '90%', maxWidth: '720px' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={`flex items-center justify-between p-6 border-b ${isDashboardLightMode ? 'border-gray-200' : 'border-white/10'}`}>
              <h2 className={`text-2xl font-bold flex items-center gap-2 ${isDashboardLightMode ? 'text-gray-900' : 'text-white'}`}>
                <Key className="h-6 w-6 text-emerald-400" />
                {p('profile_tab.product_key')}
              </h2>
              <div className="flex items-center gap-3">
                <button
                  type="button"
                  onClick={copyProductLicenseKey}
                  disabled={!productLicenseKey}
                  className="px-6 py-2.5 rounded-xl bg-gradient-to-r from-emerald-500 to-teal-600 text-white hover:from-emerald-600 hover:to-teal-700 transition-all duration-200 font-semibold flex items-center gap-2 shadow-lg shadow-emerald-500/30 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <CheckCircle size={18} />
                  {p('profile_tab.copy_product_key')}
                </button>
                <button type="button" onClick={() => setShowLicenseKey(false)} className={isDashboardLightMode ? 'text-gray-500 hover:text-gray-800 transition-colors' : 'text-white/70 hover:text-white transition-colors'}>
                  <X size={24} />
                </button>
              </div>
            </div>

            <div className="overflow-y-auto p-6 flex-1">
              <div className="space-y-6">
                <div>
                  <label className={`block text-sm mb-2 font-medium flex items-center gap-2 ${isDashboardLightMode ? 'text-slate-600' : 'text-white/70'}`}>
                    <User size={18} className="text-blue-400" />
                    {p('profile_tab.linked_account')}
                  </label>
                  <div className={`rounded-xl px-4 py-3 border space-y-2 ${isDashboardLightMode ? 'bg-slate-50 border-slate-200 text-slate-900' : 'bg-white/5 border-white/15 text-white'}`}>
                    <div className="flex items-center justify-between gap-3 text-sm">
                      <span className={isDashboardLightMode ? 'text-slate-500' : 'text-white/50'}>{t('common.email')}</span>
                      <span className="font-medium truncate">{profileUser?.email || permissions.currentUser?.email || '—'}</span>
                    </div>
                    <div className="flex items-center justify-between gap-3 text-sm">
                      <span className={isDashboardLightMode ? 'text-slate-500' : 'text-white/50'}>{t('common.phone')}</span>
                      <span className="font-medium">{profileUser?.phone || permissions.currentUser?.phone || t('common.not_provided')}</span>
                    </div>
                    <div className="flex items-center justify-between gap-3 text-sm">
                      <span className={isDashboardLightMode ? 'text-slate-500' : 'text-white/50'}>{p('profile_tab.license_pack')}</span>
                      <span className="font-medium text-right">{licensePackLabel}</span>
                    </div>
                  </div>
                </div>

                <div>
                  <h4 className={`text-sm font-semibold flex items-center gap-2 mb-3 ${isDashboardLightMode ? 'text-slate-800' : 'text-white'}`}>
                    <Key size={16} className="text-emerald-400" />
                    {p('profile_tab.license_key_title')}
                  </h4>
                  <div className={`p-4 rounded-xl border ${isDashboardLightMode ? 'bg-slate-50 border-slate-200' : 'bg-white/5 border-white/10'}`}>
                    <p className={`font-mono text-sm break-all leading-relaxed ${productLicenseKey ? (isDashboardLightMode ? 'text-emerald-700' : 'text-emerald-300') : (isDashboardLightMode ? 'text-slate-500' : 'text-white/50')}`}>
                      {productLicenseKey || p('license.no_key_found', 'لم يتم العثور على مفتاح')}
                    </p>
                  </div>
                  <p className={`text-xs mt-2 ${isDashboardLightMode ? 'text-slate-500' : 'text-white/50'}`}>
                    {p('profile_tab.license_key_hint')}
                  </p>
                </div>

                <p className={`text-xs flex items-center gap-2 ${isDashboardLightMode ? 'text-slate-500' : 'text-white/45'}`}>
                  <AlertCircle size={14} className="shrink-0" />
                  {p('profile_tab.modules_console_hint')}
                </p>
              </div>
            </div>
          </motion.div>
        </div>,
        document.body
      )}

      {showModulesModal && createPortal(
        <div
          className="fixed inset-0 bg-black/20 backdrop-blur-md flex items-center justify-center z-[99999] p-4"
          onClick={() => setShowModulesModal(false)}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className={`backdrop-blur-lg rounded-2xl max-h-[90vh] flex flex-col overflow-hidden ${isDashboardLightMode ? 'qawaem-modal-light border' : 'border-2 border-blue-400/60 bg-gradient-to-br from-slate-800 via-blue-750 to-slate-800'}`}
            style={isDashboardLightMode ? { boxShadow: '0 10px 40px rgba(15, 23, 42, 0.12), 0 0 0 1px rgba(15, 23, 42, 0.06)', width: '90%', maxWidth: '720px' } : { boxShadow: '0 0 40px rgba(59, 130, 246, 0.4), 0 0 80px rgba(59, 130, 246, 0.2)', width: '90%', maxWidth: '720px' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={`flex items-center justify-between p-6 border-b ${isDashboardLightMode ? 'border-gray-200' : 'border-white/10'}`}>
              <h2 className={`text-2xl font-bold flex items-center gap-2 ${isDashboardLightMode ? 'text-gray-900' : 'text-white'}`}>
                <Layers className="h-6 w-6 text-blue-400" />
                {p('profile_tab.enabled_modules')}
              </h2>
              <div className="flex items-center gap-3">
                <button
                  type="button"
                  onClick={() => setShowModulesModal(false)}
                  className="px-6 py-2.5 rounded-xl bg-gradient-to-r from-blue-500 to-blue-700 text-white hover:from-blue-600 hover:to-blue-800 transition-all duration-200 font-semibold flex items-center gap-2 shadow-lg shadow-blue-500/30"
                >
                  <CheckCircle size={18} />
                  {t('common.close')}
                </button>
                <button type="button" onClick={() => setShowModulesModal(false)} className={isDashboardLightMode ? 'text-gray-500 hover:text-gray-800 transition-colors' : 'text-white/70 hover:text-white transition-colors'}>
                  <X size={24} />
                </button>
              </div>
            </div>

            <div className="overflow-y-auto p-6 flex-1">
              <div className="space-y-6">
                <div>
                  <label className={`block text-sm mb-2 font-medium flex items-center gap-2 ${isDashboardLightMode ? 'text-slate-600' : 'text-white/70'}`}>
                    <Award size={18} className="text-blue-400" />
                    {p('profile_tab.pack_license')}
                  </label>
                  <div className={`rounded-xl px-4 py-3 border ${isDashboardLightMode ? 'bg-slate-50 border-slate-200 text-slate-900' : 'bg-white/5 border-white/15 text-white'}`}>
                    <p className="font-semibold text-sm">{licensePackLabel}</p>
                    <p className={`text-xs mt-1 ${isDashboardLightMode ? 'text-slate-500' : 'text-white/45'}`}>
                      {p(enabledLicenseModuleCount === 1 ? 'profile_tab.modules_active_count' : 'profile_tab.modules_active_count_plural', {
                        active: enabledLicenseModuleCount,
                        total: LICENSE_CATALOG_MODULE_COUNT,
                      })}
                    </p>
                  </div>
                  <p className={`text-xs mt-2 ${isDashboardLightMode ? 'text-slate-500' : 'text-white/50'}`}>
                    {p('profile_tab.modules_list_hint')}
                  </p>
                </div>

                <div>
                  <h4 className={`text-sm font-semibold flex items-center gap-2 mb-3 ${isDashboardLightMode ? 'text-slate-800' : 'text-white'}`}>
                    <LayoutGrid className="h-4 w-4 text-blue-400" />
                    {p('profile_tab.modules_detail')}
                  </h4>
                  <div className={`p-4 rounded-xl border overflow-x-auto ${isDashboardLightMode ? 'bg-slate-50 border-slate-200' : 'bg-white/5 border-white/10'}`}>
                    {enabledModulesList.length > 0 ? (
                      <table className={`w-full text-sm ${isDashboardLightMode ? 'text-slate-800' : 'text-white/90'}`}>
                        <thead className={`text-xs uppercase ${isDashboardLightMode ? 'bg-slate-100 text-slate-600' : 'bg-white/10 text-white/70'}`}>
                          <tr>
                            {[p('profile_tab.col_number'), p('profile_tab.col_module'), p('profile_tab.col_status')].map((header) => (
                              <th key={header} className="px-3 py-2 text-left font-semibold">{header}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-white/10">
                          {enabledModulesList.map((mod) => (
                            <tr key={mod.key} className={isDashboardLightMode ? 'divide-slate-100' : ''}>
                              <td className="px-3 py-2.5 font-mono text-xs opacity-70">{mod.num}</td>
                              <td className="px-3 py-2.5 font-medium">{mod.label}</td>
                              <td className="px-3 py-2.5">
                                <span className="inline-flex items-center gap-1.5 text-emerald-400 text-xs font-semibold">
                                  <CheckCircle size={14} />
                                  {p('profile_tab.status_active')}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <p className={`text-center py-8 text-sm ${isDashboardLightMode ? 'text-slate-500' : 'text-white/50'}`}>
                        {p('license.no_modules_enabled', 'لا توجد وحدات مفعّلة على هذا الترخيص.')}
                      </p>
                    )}
                  </div>
                </div>

                <p className={`text-xs flex items-center gap-2 ${isDashboardLightMode ? 'text-slate-500' : 'text-white/45'}`}>
                  <AlertCircle size={14} className="shrink-0" />
                  {p('profile_tab.modules_console_restart_hint')}
                </p>
              </div>
            </div>
          </motion.div>
        </div>,
        document.body
      )}

    </>
  );
};

export default SettingsBody;

